﻿/// <reference path="../_references.js" />

var mAnalysisControls = new AnalysisControls(),
    mPrintControls = new PrintControls(),
    mAnalysisData = new AnalysisData();


function resetContentHoldersAnalysis() {
    "use strict";
    var lPanelWidth,
        lDetailHeight,
        lPanelHeight = $('#uAnalysisMainContentPanel').height(),
        lButtonBarHeight = $('#uAnalysisDetailsButtonBar').height(),
        lDetailWidth = $('#uAnalysisDetailsTable').width(),
        lMatchesWidth = $('#uAnalysisMatchesListCell').width(),
        lMapPlaybackHeight = $('#uMapPlaybackPanel').height(),
        lMatchFilterHeight,
        lMatchPaginationHeight,
        lListviewOverhead = 0;

    setWidth('#uMapPanel', 1);
    setHeight('#uMapPanel', 1);

    lPanelWidth = $('#uAnalysisDetailsPanel').width();
    lDetailHeight = $('#uAnalysisDetailsPanel').height();

    setWidth('#uMapPanel', lPanelWidth - (lDetailWidth + 14 + lMatchesWidth));
    setHeight('#uMapPanel', (lPanelHeight - (lButtonBarHeight + 14)) - lMapPlaybackHeight);
    setHeight('#uAnalysisIncidentDetailHolder', (lPanelHeight - (lButtonBarHeight + 14)) - lMapPlaybackHeight);
    if (mStateManager.Settings()[0] === 'Spatial') {
        lListviewOverhead = $('#uAnalysisDetailsPanel .ListOverhead').height();
        setHeight('#uAnalysisSpatialMatchesListHolder', ((lPanelHeight - (lButtonBarHeight + 14)) - (lListviewOverhead + 5)));
    } else {
        lMatchFilterHeight = $('#uAnalysisMatchesListFilterHolder').height();
        lMatchPaginationHeight = $('#uAnalysisMatchesPagerHolder').height();
        setHeight('#uAnalysisMatchesListHolder', lDetailHeight - (lMatchFilterHeight + lMatchPaginationHeight + 15));
        //uAnalysisMatchesListHolder = lDetailHeight - (lMatchFilterHeight + lMatchPaginationHeight + 10);
    }

    var lWindowWidth = $(window).width(),
            lWindowHeight = $(window).height(),
            lMapWidth = $('#uMapPanel').width(),
            lMapHeight = $('#uMapPanel').height(),
            lMapOffset = $('#uMapPanel').offset(),
            lNotificationWidth = $('#uMapNotificationPanel').width(),
            lLocateRight,
            lLocateBottom;

    if (!isNullOrUndefined(lMapOffset)) {
        lLocateRight = lWindowWidth - (lMapWidth + lMapOffset.left);
        lLocateBottom = lWindowHeight - (lMapHeight + lMapOffset.top);
        //if (lLocateRight > 180 && lLocateBottom > 0) {
        $('#uLocateMapHolder').css('right', (lLocateRight).toString() + 'px')
                                    .css('bottom', (lLocateBottom).toString() + 'px')
                                    .show();
        $('#uDistanceToolHolder').css('right', (lLocateRight + 230).toString() + 'px')
                                    .css('bottom', (lLocateBottom + 15).toString() + 'px');
        $('#uMapNotificationPanel').css('bottom', (lLocateBottom).toString() + 'px');
       // } else {
           // $('#uLocateMapHolder').hide();
     //   }
        $('#uMapNotificationPanel').css('margin-left', ((lMapWidth - lNotificationWidth) / 2).toString() + 'px');
    }
}

//-----------------------
// State Manager Handlers
//-----------------------
function mStateManagerAnalysis_Init(aPrevious, aCurrent) {
    "use strict";
    if (applyUserPermissionsNavigation(gPageClassManager.System, aCurrent.Tab)) {
        $('#uMasterMenuPanel').show();
        var lLayout = aCurrent.Tab + '.Layout.htm';
        populateElement('uMasterContentHolder', lLayout, mStateManagerAnalysis_OnComplete);
    }
}

function mStateManagerAnalysisLayout_PreInit(aSender, aCacheItem, aCurrent) {
    "use strict";
    mCache.unbind('Incidentsupdated', mStateManagerAnalysisLayout_PreInit);
    mCache.bind('Incidentsupdated', analysisIncidentsDataItem_Updated, null);
    mStateManagerAnalysisLayout_Init(null, aCurrent);
}

function mStateManagerAnalysisLayout_Init(aPrevious, aCurrent) {
    "use strict";
    var lLayout = aCurrent.Tab + '.' + aCurrent.Settings[0] + '.Layout.htm';
    if (applyUserPermissionsNavigation(gPageClassManager.Analysis, aCurrent.Settings[0])) {
        $('.LayoutTab.Selected').removeClass('Selected');
        $('#u' + aCurrent.Tab + 'LayoutTab' + aCurrent.Settings[0]).addClass('Selected');
        populateElement('uAnalysisContentHolder', lLayout, mStateManagerAnalysisLayout_OnComplete);
        $('#uAnalysisLayoutTabSpatial').hide();
        if (gUserDetails.Role == 2) {
            systemCacheItems_Init();
            $('#uAnalysisLayoutTabSpatial').hide();
        }
        //if (aCurrent.Settings[0] === 'Incidents') {
        //    $('#uAnalysisListCell').show();
        //} else {
        //    $('#uAnalysisListCell').hide();
        //}
    }
}

function mStateManagerAnalysisPrimary_Init(aPrevious, aCurrent, aData) {
    "use strict";
    var lLayout = aCurrent.Tab + '.' + aCurrent.Settings[0] + '.' + aCurrent.Settings[1] + '.Layout.htm';
    var lState = getViewState('TravelBackFromEnrolleesTile');

    uAnalysisExitEditMode();
    if (!isNullOrUndefined(lState)) {
       if (lState.Value) {
           ChangeHashSettings(1, 'Map');
           deleteViewState('TravelBackFromEnrolleesTile');
       }
    } else {
        if (aCurrent.Settings[0] === 'Incidents') {
            $('#uAnalysisListCell').hide();
            $('#uExportKmlIncidents').show();
        } else {
            $('#uAnalysisListCell').show();
        }
        $('#uAnalysisMainMenuPanel .Selected').removeClass('Selected');
        $('#uAnalysisMainMenuPanel .' + aCurrent.Settings[1] + 'Tab').addClass('Selected');
        populateElement('uAnalysisMainContentPanel', lLayout, mStateManagerAnalysisPrimary_OnComplete);
  }
}

function mStateManagerAnalysisSecondary_Init(aPrevious, aCurrent) {
    "use strict";
    if (!isNullOrUndefined(aCurrent.Settings[2]) && aCurrent.Settings[2] !== 'null') {
        mAnalysisData.FilterId = aCurrent.Settings[2];
        mStateManager.ChangeSettings(2, null);
        if (mAnalysisControls.CardViewFilter) {
            mAnalysisControls.CardViewFilter.filter();
        }
    }
    // localize here
    veritracks.localization.localizeTitle();
}

function mStateManagerAnalysisTertiary_Init(aPrevious, aCurrent) {
    "use strict";
}

//--------------
// Load Complete
//--------------
function mStateManagerAnalysis_OnComplete() {
    "use strict";
    applyUserPermissions([4, 5, 6]);
    analysisCache_Init(mStateManager.Hash());
    $(window).resize();
    //analysisDataListConverter(aSender, aCacheItem, aNotificationId);
    //mStateManagerAnalysisLayout_Init(null, mStateManager.Hash());
}

function mStateManagerAnalysisLayout_OnComplete() {
    "use strict";
    applyUserPermissions([4, 5, 6]);
    if (mStateManager.Settings()[0] === 'History') {
        analysisIncident_Init();
        analysisDataListConverter();
        analysisCardViewFilter_Init();
        analysisCardViewPaginator_Init();
    } else {
        if (mAnalysisData.SpatialMatchIncident) {
            $('#uSpatialMapResults').removeClass('HideItem');
            
        } else {
            ChangeHashSettings(1, 'Details');
            $('#uSpatialMapResults').addClass('HideItem');
        }
    }

    mStateManagerAnalysisPrimary_Init(null, mStateManager.Hash());
}

function mStateManagerAnalysisPrimary_OnComplete() {
    "use strict";
    var getSpatialState,
        lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable'),
        lAnalysisRadius = veritracks.system.clientSetting('incidenthitdistance');

    if (lAnalysisRadius) {
        mAnalysisData.SpatialRadius = lAnalysisRadius;
    }
    applyUserPermissions([5, 6]);

    //if (mStateManager.Settings()[1] === 'Map') {
        mAnalysisControls.NotificationPanel = new SumoActivityNotification('uMapNotificationPanel', 'uAnalysisMapPanel', 50, { 'allowClose': true });
        mAnalysisControls.NotificationPanel.render();
   // }
    uAnalysisMap_Init();
    $(window).resize();
    mAnalysisData.AddressCards = null;
    mAnalysisData.EnrolleeMGAPCards = null;
    if (mStateManager.Settings()[0] === 'Incidents') {
        if (mStateManager.Settings()[1] === 'Details') {
            if (mAnalysisData.SpatialMatchIncident) {
                $('#uSpatialMapResults').removeClass('HideItem');
            } else {
                $('#uSpatialMapResults').addClass('HideItem');
            }
            InitializeSpatialView();

        } else {
            analysisMatchesCardViewFilter_Init();
            analysisMatchesCardViewPaginator_Init();
            analysisIncidentMatches_Init();
            analysisSpatialDetailsFormat();
            if (mAnalysisData.SpatialMatchIncident) {
                $('#uSpatialMapResults').removeClass('HideItem');
                $('#uSaveSpatialIncidentButton').show();
                $('#uEditSpatialIncidentButton').show();
                $('#uExportKmlIncidents').show();
                $('#uAddressSpatial').show();
                
            } else {
                $('#uSpatialMapResults').addClass('HideItem');
                $('#uSaveSpatialIncidentButton').hide();
                $('#uEditSpatialIncidentButton').hide();
                $('#uExportKmlIncidents').hide();
                $('#uAddressSpatial').hide();
            }
            analysisSpatialMatchesFilter();
        }
    } else if (mStateManager.Settings()[0] === 'History') {
        if (mStateManager.Settings()[1] === 'Details') {
            analysisIncidentsDetailsPopulate();
        } else {
            //$('#uExportKmlIncidents').hide();
            analysisMatchesCardViewFilter_Init();
            analysisMatchesCardViewPaginator_Init();
            analysisIncidentMatches_Init();
            analysisIncidentsMapPopulate();
        }
    }

    mStateManagerAnalysisSecondary_Init(null, mStateManager.Hash());
    $(window).resize();
    mAnalysisControls.MapLocate = new sumo.maps.Locate('uMapLocate', 'uLocateMapHolder', mAnalysisControls.Map, {});
    mAnalysisControls.MapLocate.bind('complete', analysisPlaces_OnComplete);
    uAnalysisCardViewSortOnViewState();
    uAnalysisIncidentMatchCardViewSortOnViewState();
}

//------
// Leave
//------
function mStateManagerAnalysis_Leave(aPrevious, aCurrent) {
    "use strict";
    mCache.RemoveItem('Incidents');
    // mAnalysisData.SpatialMatchIncident = null;
    mStateManagerAnalysisLayout_Leave(aPrevious, aCurrent);
    mCache.unbind('Incidentsupdated', analysisIncidentsDataItem_Updated);
}

function mStateManagerAnalysisLayout_Leave(aPrevious, aCurrent) {
    "use strict";

    if (!isNullOrUndefined(mAnalysisControls.CardView)) {
        mAnalysisControls.CardView.dispose();
        mAnalysisControls.CardView = null;
    }
    if (!isNullOrUndefined(mAnalysisControls.CardViewFilter)) {
        mAnalysisControls.CardViewFilter.dispose();
        mAnalysisControls.CardViewFilter = null;
    }
    if (!isNullOrUndefined(mAnalysisControls.CardViewPaginator)) {
        mAnalysisControls.CardViewPaginator.dispose();
        mAnalysisControls.CardViewPaginator = null;
    }
    mCache.unbind('Incidentsupdated', analysisIncidentsDataItem_Updated);

    mAnalysisData.DistanceToolActive = false;

    mAnalysisData.RequestId = -1;
    if (!isNullOrUndefined(mAnalysisControls.NotificationPanel)) {
        mAnalysisControls.NotificationPanel.dispose();
        mAnalysisControls.NotificationPanel = null;
    }
    mStateManagerAnalysisPrimary_Leave(aPrevious, aCurrent);
    mAnalysisData.DistanceToolActive = false;
}

function mStateManagerAnalysisPrimary_Leave(aPrevious, aCurrent) {
    "use strict";
    if (!isNullOrUndefined(mAnalysisControls.Map)) {
        mAnalysisControls.Map.dispose();
        mAnalysisControls.Map = null;
    }
    if (aPrevious.Settings[1] === 'Map') {
        mAnalysisData.AddressCards = null;
        mAnalysisData.EnrolleeMGAPCards = null;
        $('#uPopupContent2').html('');
        if (!isNullOrUndefined(mAnalysisControls.MatchesCardView)) {
            mAnalysisControls.MatchesCardView.dispose();
            mAnalysisControls.MatchesCardView = null;
        }
        if (!isNullOrUndefined(mAnalysisControls.MatchesCardViewFilter)) {
            mAnalysisControls.MatchesCardViewFilter.dispose();
            mAnalysisControls.MatchesCardViewFilter = null;
        }
        if (!isNullOrUndefined(mAnalysisControls.MatchesCardViewPaginator)) {
            mAnalysisControls.MatchesCardViewPaginator.dispose();
            mAnalysisControls.MatchesCardViewPaginator = null;
        }
        if (aCurrent.Tab !== 'Analysis') {
            mCache.unbind('Incidentsupdated', analysisIncidentsDataItem_Updated);
        }
    } else if (aPrevious.Settings[0] === 'Spatial') {
        if (!isNullOrUndefined(mAnalysisControls.SpatialCardView)) {
            mAnalysisControls.SpatialCardView.dispose();
            mAnalysisControls.SpatialCardView = null;
        }

        if (!isNullOrUndefined(mAnalysisControls.SpatialCardViewPaginator)) {
            mAnalysisControls.SpatialCardViewPaginator.dispose();
            mAnalysisControls.SpatialCardViewPaginator = null;
        }
    }
}

// Spatial initializer
function InitializeSpatialView() {
    "use strict";
    var lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable');

    //set placeholder
    $('#uMapSpatialLocation').attr('placeholder', localizeText('cAnalysisAddressEnter'));
    uSpatialMapSearch_Init();
    uSpatialMapSearchTimezone_Init();
    $('.MapStartDateFilter').hide();
    $('.MapEndDateFilter').hide();
    if (lStartDateFilterEditable) {
        populateDateView('#uMapStartDatePicker', uAnalysisMapPopulate_GetDateRange);
        $('#uMapStartDatePicker').val(displayShortDate(new Date()));
        $('.TimePicker').ptTimeSelect({
            'zIndex': 100000,
            'onFocusDisplay': true,
            'onClose': uAnalysisMapPopulate_GetDateRange
        });
    } else {
        populateDateView('#uMapDatePicker', uAnalysisMapPopulate_GetDateRange);
        $('#uMapDatePicker').val(displayShortDate(new Date()));
        $('.TimePicker').ptTimeSelect({
            'zIndex': 100000,
            'onFocusDisplay': true,
            'onClose': uAnalysisMapPopulate_GetDateRange
        });
    }
    //populateDateView('#uIncidentDetailClearedDateUTCEdit', analysisIncidentDatePicker_OnChange);
    $('.TimePicker').ptTimeSelect({
        'zIndex': 100000,
        'onFocusDisplay': true
    });
    $('.AddressRequired').keyup(function () {
        $('#uSaveIncidentButton').hide();
    });
    uRunSpatialQuery_OnClick();
}

function setSpatialTimeFilter(aSpatialDates) {
    "use strict";
    var lStart = moment(aSpatialDates.StartDateUTC);
    var lEnd = moment(aSpatialDates.EndDateUTC);

    if (lStart.isDST()) {
        lStart.add(1, 'hours');
    }
    if (lEnd.isDST()) {
        lEnd.add(1, 'hours');
    }
    var lDifference = moment.duration(lEnd.diff(lStart)).asHours();
    var lSelected = Math.round(lDifference / 24 * 24);

    var lSelectFilter = $('#uAnalysisSpatialMapTimeFilter');


    lSelectFilter.val(lSelected);
}

function uSpatialMapSearchTimezone_Init() {
    var lSelectTimezone = $('#uAnalysisSpatialTimeZone'),
        lBuilder = new SumoPredicateBuilder(),
        lKey,
        lTimeZone,
        lTimeZones = [];

    lBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lAgent = query(getDataItems('Agents'), lBuilder.RootExpression);
    if (lAgent.length == 0) {
        lAgent = query(getDataItems('AgentsStop'), lBuilder.RootExpression);
    }
    for (var lKey in lAgent) {
        if (lAgent.hasOwnProperty(lKey)) {
            lTimeZone = getDataItem(lAgent[lKey].TimeZoneId, 'TimeZone');
            if (lTimeZones.indexOf(lTimeZone) == -1) {
                lTimeZones.push(lTimeZone);
            }
        }
    }


    for (lKey in lTimeZones) {
        if (lTimeZones.hasOwnProperty(lKey)) {
            lSelectTimezone.append($("<option/>").attr("value", lTimeZones[lKey].TimeZoneName).attr("code", lTimeZones[lKey].TimeZoneCode).attr("id", lTimeZones[lKey].Id).text(lTimeZones[lKey].Name));
        }
    }

    lSelectTimezone.val(moment.tz.guess());
}

function uSpatialMapSearch_Init() {
    var lSelectFilter = $('#uAnalysisSpatialMapTimeFilter'),
        lDuration = [],
        lKey;


    // id is hours value is minutes option is text
    lDuration.push({ "id": "1", "value": "60", "option": localizeText('c1hour') },
        { "id": "2", "value": "120", "option": localizeText('c2hours') },
        { "id": "4", "value": "240", "option": localizeText('c4hours') },
        { "id": "8", "value": "480", "option": localizeText('c8hours') },
        { "id": "12", "value": "720", "option": localizeText('c12hours') },
        { "id": "24", "value": "1440", "option": localizeText('c1day') },
        { "id": "48", "value": "2880", "option": localizeText('c2days') },
        { "id": "72", "value": "4320", "option": localizeText('c3days') },
        { "id": "96", "value": "5760", "option": localizeText('c4days') },
        { "id": "120", "value": "7200", "option": localizeText('c5days') },
        { "id": "168", "value": "10080", "option": localizeText('c1week') });


    for (lKey in lDuration) {
        if (lDuration.hasOwnProperty(lKey)) {
            lSelectFilter.append($("<option/>").attr("value", lDuration[lKey].id).text(lDuration[lKey].option));
        }
    }

    lSelectFilter.val(24);

}
$(document).on("keyup", "#uMapSpatialLocation", function (e) {
    if (e.which == 13) {
        uAnalysisSpatialLocateButton_OnClick();
    }
});

function uAnalysisSpatialLocateButton_OnClick() {
    "use strict";
    var lValue = $('#uMapSpatialLocation').val();

    mActivityNotification.addNotification(localizeWrapper('cFinding'));
    if (lValue) {
        mAnalysisControls.MapLocate.Search(lValue);
    }
}
//---------
// CardView
//---------
function analysisDataListConverter(aSender, aCacheItem, aNotificationId) {
    "use strict";
    var lCardList = [],
        lMatchesList = [],
        lAgents = getDataItems('Agents'),
        lAgent,
        lCard = new AnalysisCardView(),
        lItem,
        lMatch,
        lIncidents = getDataItems('Incidents'),
        lKey,
        lSortState = getViewState('AnalysisCardViewSort'),
        lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('Id', 0, false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lIncidents = query(lIncidents, lBuilder.RootExpression);

    for (lKey in lIncidents) {
        if (lIncidents.hasOwnProperty(lKey)) {
            lItem = lIncidents[lKey];
            lCard = new AnalysisCardView();
            lCard.Id = lItem.Id;
            if (lItem.TimeZoneId > 0) {
                lItem.StartDateUTC = displayDateByTimeZoneId(lItem.StartDateUTCString, lItem.TimeZoneId);
                lItem.EndDateUTC = displayDateByTimeZoneId(lItem.EndDateUTCString, lItem.TimeZoneId);
            } else {
                lItem.StartDateUTC = lItem.StartDateUTC;
                lItem.EndDateUTC = lItem.EndDateUTC;
            }
            lCard.StartDateUTC = lItem.StartDateUTC;
            lCard.StartDateDisplay = DisplayShortDateTime(lItem.StartDateUTC);
            lCard.EndDateUTC = lItem.EndDateUTC;
            lCard.EndDateDisplay = DisplayShortDateTime(lItem.EndDateUTC);

            lCard.IncidentNumber = lItem.IncidentNumber;
            lCard.OrganizationId = lItem.OrganizationId;
            lCard.PrimaryOffenseId = lItem.PrimaryOffense;
            lCard.Disposition = lItem.Disposition;
            lCard.CaseNumber = lItem.CaseNumber;
            lCard.Status = lItem.Status;
            lAgent = lAgents[lItem.AgentId];
            if (!isNullOrUndefined(lAgent)) {
                lCard.AgentName = lAgent.FullName;
            }
            lCard.Data = lItem;
            lCardList.push(lCard);
        }
    }
    mAnalysisData.IncidentClean = lCardList;
    mAnalysisData.IncidentSort = null;
    if (!isNullOrUndefined(lSortState)) {
        mAnalysisData.IncidentSort = lSortState.Value.sort(mAnalysisData.IncidentClean);
    }
}

function analysisIncidentsDataItem_Updated(aCache, aData) {
    "use strict";
    var aCache = aCache,
        lData = aData;

    if (!isNullOrUndefined(mAnalysisControls.CardView)) {
        analysisDataListConverter();
        if (UpdateViewOnNewData(lData, mAnalysisData.IncidentPaginated)) {
            mAnalysisControls.CardView.setUpdated(true);
        }
    }
}

function analysisMatchesDataListConverter(aData) {
    "use strict";
    var lMatchesList = [],
        lEnrollees = getDataItems('Enrollees'),
        lAgents = getDataItems('Agents'),
        lEnrollee,
        lMatch,
        lKey,
        lMatchesCard,
        lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric')),
        lAdvancedPermission = CheckUserHasPermission(45),
        lAgent,
        lSortState = getViewState('AnalysisIncidentMatchCardViewSort');

    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lMatch = aData[lKey];
            lMatchesCard = new AnalysisMatchesCardView();
            lMatchesCard.Id = lMatch.Id;
             if (lDoMetric) {
                lMatchesCard.Distance = convertFeetToMeters(lMatch.Distance);
                lMatchesCard.DistanceMeasurement = "meters";
            } else {
                lMatchesCard.Distance = lMatch.Distance;
            }
            if (lMatch.Distance == 0) {
                lMatchesCard.DistanceDisplayView = 'none';
                lMatchesCard.ScoreView = 'none';
            }


            lEnrollee = GetEnrollee(lMatch.EnrolleeId);

            lMatchesCard.EnrolleeId = lMatch.EnrolleeId;

            if (lAdvancedPermission) {
                lMatchesCard.EnrolleeName = lMatch.EnrolleeName;
                lMatchesCard.PrimaryId = lMatch.PrimaryId;
                if (lEnrollee) {
                    lMatchesCard.RiskLevelId = lEnrollee.RiskLevelId;
                    lMatchesCard.OrganizationId = lEnrollee.OrganizationId;
                }
                lMatchesCard.AgentId = lMatch.AgentId;
                lMatchesCard.Agent = lMatch.AgentName;
            } else {
                if (lEnrollee) {
                    lMatchesCard.EnrolleeName = lEnrollee.FullName;
                    lMatchesCard.PrimaryId = lEnrollee.PrimaryId;
                }
            }

            lAgent = lAgents[lMatch.AgentId];

            if (!isNullOrUndefined(lAgent)) {
                lMatchesCard.AgentId = lAgent.Id;
                lMatchesCard.Agent = lAgent.FullName;
                lMatchesCard.AgentPrimaryEmail = lAgent.PrimaryEmail;
            } else if (!lAdvancedPermission) {
                lMatchesCard.Agent = '- unknown -';

            }


            if (lMatchesCard.PrimaryId != lMatch.PrimaryId) {
                lMatchesCard.DisplayNavigateEnrollee = 'none';
            }

            lMatchesCard.DistanceDisplay = (Math.round(lMatch.Distance * 100) / 100).toString();
            lMatchesCard.StartDateUTC = lMatch.StartDateUTC;
            lMatchesCard.EndDateUTC = lMatch.EndDateUTC;
            lMatchesCard.StartDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lMatch.StartDateUTCString, lEnrollee));
            lMatchesCard.EndDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lMatch.EndDateUTCString, lEnrollee));
            lMatchesCard.Detail = localizeText('cEnrolleesMappingStart') + ' ' + lMatchesCard.StartDateDisplay;
            lMatchesCard.Detail2 = localizeText('cEnrolleesMappingEnd') + ' ' + lMatchesCard.EndDateDisplay;
            lMatchesCard.Score = lMatch.Score;
            lMatchesCard.TrackpointCount = lMatch.TrackpointCount;
            lMatchesCard.TimeZoneId = lEnrollee ? lEnrollee.TimeZoneId : -1; //artf86873
            lMatchesCard.Data = lMatch;
            lMatchesCard.TrackingDeviceSerialNumber = lMatch.SerialNumber;
            lMatchesList.push(lMatchesCard);
        }
    }

    mAnalysisData.IncidentMatchesClean = lMatchesList;

    mAnalysisData.IncidentMatchSort = null;
    if (!isNullOrUndefined(lSortState)) {
        mAnalysisData.IncidentMatchSort = lSortState.Value.sort(mAnalysisData.IncidentMatchesClean);
    }

    analysisMatchesCardViewPaginator_Init();
}


// simple expand all method.
function analysisExpandAllButton_OnClick() {
    "use strict";
    var lIsExpanded = false,
        lKey;
    if ($('#uSpatialExpandAllButton').hasClass('Selected')) {
        $('#uSpatialExpandAllButton').removeClass('Selected');
    }
    else {
        $('#uSpatialExpandAllButton').addClass('Selected');
        lIsExpanded = true;
    }

    for (lKey in mAnalysisData.EnrolleeSpatialMatches) {
        if (mAnalysisData.EnrolleeSpatialMatches.hasOwnProperty(lKey)) {
            mAnalysisData.EnrolleeSpatialMatches[lKey].IsExpanded = lIsExpanded;
        }
    }
    analysisSpatialMatchesFilter();
}

function analysisExpandButton_OnClick() {
    "use strict";
    var lSelected = mAnalysisControls.SpatialCardView.selectedDataItem(),
        lKey,
        lExpand = true;

    if (lSelected.IsExpanded) {
        lExpand = false;
    }
    for (lKey in mAnalysisData.EnrolleeSpatialMatches) {
        if (mAnalysisData.EnrolleeSpatialMatches.hasOwnProperty(lKey)) {
            if (mAnalysisData.EnrolleeSpatialMatches[lKey].Id == lSelected.Id) {
                mAnalysisData.EnrolleeSpatialMatches[lKey].IsExpanded = lExpand;
            }
        }
    }
    analysisSpatialMatchesFilter();
}

function uIncidentsPaginator_OnPageChanged(aSender, aNewPage, aData) {
    "use strict";
    if (!isNullOrUndefined(mAnalysisData.IncidentDirty)) {
        mAnalysisData.IncidentPaginated = aSender.paginate(mAnalysisData.IncidentDirty);
        mAnalysisControls.CardView.setDataSource(mAnalysisData.IncidentPaginated);
    }
    setViewState('AnalysisSelectedPage', aNewPage);
}

function analysisCardViewPaginator_Init() {
    "use strict";
    var lAnalysisIncidentState = getViewState('AnalysisSelectedIncident'),
        lPageState = getViewState('AnalysisSelectedPage');
    if (isNullOrUndefined(mAnalysisControls.CardViewPaginator)) {
        mAnalysisControls.CardViewPaginator = new sumo.controls.Paginator('uAnalysisCardViewPaginator', 'uAnalysisPagerHolder', {
            'ItemCount': count(mAnalysisData.IncidentDirty),
            'ItemsPerPage': gPaginationSettings.AnalysisIncidentsItems
        });
        if (!isNullOrUndefined(lAnalysisIncidentState) && !isNullOrUndefined(lPageState)) {
            mAnalysisControls.CardViewPaginator.setPage(lPageState.Value);
        }
        mAnalysisControls.CardViewPaginator.bind('pagechanged', uIncidentsPaginator_OnPageChanged);
    } else {
        mAnalysisControls.CardViewPaginator.render();
    }
    mAnalysisControls.CardViewFilter.filter();
}

function analysisMatchesCardViewPaginator_Init() {
    "use strict";
    if (isNullOrUndefined(mAnalysisControls.MatchesCardViewPaginator)) {
        mAnalysisControls.MatchesCardViewPaginator = new sumo.controls.Paginator('uAnalysisMatchesCardViewPaginator', 'uAnalysisMatchesPagerHolder', {
            'ItemCount': count(mAnalysisData.IncidentMatchesDirty),
            'ItemsPerPage': gPaginationSettings.AnalysisIncidentsMatchItems
        });
        mAnalysisControls.MatchesCardViewPaginator.bind('pagechanged', uMatchesPaginator_OnPageChanged);
    } else {
        mAnalysisControls.MatchesCardViewPaginator.render();
    }
}

function uIncidentsCardViewFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lNameExpression = null,
        lFullExpression,
        lIsEmpty,
        lSortState = getViewState('AnalysisCardViewSort');

    function evaluate(aEvaluateExpression) {
        if (aEvaluateExpression.Name === 'EnrolleeName') {
            lNameExpression = aEvaluateExpression;
        } else {
            lBuilder.AddConditional(aEvaluateExpression);
        }
    }

    function evaluateExpression(aEvaluateExpression) {
        if (aEvaluateExpression.__type === 'ExpressionBinary:www.sumosoftware.com/Expressions') {
            evaluateExpression(aEvaluateExpression.LeftOperand);
            evaluateExpression(aEvaluateExpression.RightOperand);
        } else {
            evaluate(aEvaluateExpression);
        }
    }

    function populate(aExpression) {
        mAnalysisData.IncidentDirty = query(mAnalysisData.IncidentSort, aExpression);
        if (isNullOrUndefined(mAnalysisControls.CardViewPaginator)) {
            analysisCardViewPaginator_Init();
        }
        lIsEmpty = (mAnalysisData.IncidentDirty.length === 0);
        veritracks.system.applyFilterState('AnalysisIncidents', lIsEmpty);
        if (isNullOrUndefined(lSortState)) {
            mAnalysisData.IncidentDirty = AnalysisIncidentFormatter(mAnalysisData.IncidentDirty);
        }
        mAnalysisData.IncidentPaginated = mAnalysisControls.CardViewPaginator.paginate(mAnalysisData.IncidentDirty);
        mAnalysisControls.CardView.setDataSource(mAnalysisData.IncidentPaginated);
    }

    function success(aParams, aData)
    {
        var lSuccessBuilder = new SumoPredicateBuilder(),
            lIdList = [],
            lItem,
            lKey,
            lId;

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                lIdList.push(lItem.IncidentId);
            }
        }

        if (lIdList.length > 0) {
            lSuccessBuilder.AddNewExpressionConditional('Id', lIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        }
        lSuccessBuilder.AddConditional(aParams.Expression);
        populate(lSuccessBuilder.RootExpression);
    }

    if (isNullOrUndefined(mAnalysisData.IncidentSort)) {
        mAnalysisData.IncidentSort = mAnalysisData.IncidentClean;
    }
    if (mAnalysisData.FilterId !== -1) {
        lBuilder.AddNewExpressionConditional('Id', mAnalysisData.FilterId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        mAnalysisData.FilterId = -1;
        populate(lBuilder.RootExpression);
    } else {

        if (!isNullOrUndefined(aExpression)) {
            evaluateExpression(aExpression);
        }

        if (isNullOrUndefined(lNameExpression)) {
            populate(lBuilder.RootExpression);
        } else {
            mAnalysisControls.CardViewPaginator.paginate([]);
            mAnalysisControls.CardView.setDataSource([]);
            lFullExpression = lBuilder.RootExpression;
            lBuilder.Clear();
            lNameExpression.Value = '%' + lNameExpression.Value.toUpperCase() + '%';
            lBuilder.AddConditional(lNameExpression);
            lBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

            ReadMultiple(gObjectList.IncidentSearch.AssemblyQualifiedName, lBuilder.RootExpression, 0, success, null, { 'Expression': lFullExpression }, null, 0, false);
            // big difficult stuff
        }
    }
}

function selectNavigateBackAnalysisEnrollee() {
    "use strict";
    var lEnrolleeViewState = getViewState('AnalysisEnrolleeReturn');

    if (lEnrolleeViewState && lEnrolleeViewState.Value) {
        mAnalysisControls.MatchesCardView.selected(lEnrolleeViewState.Value);
    }
}
function uIncidentsMatchesCardViewFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lList = [];
    var lKey;



    if (mStateManager.Settings()[0] == 'History') {
        if (!isNullOrUndefined(mAnalysisData.IncidentMatchSort)) {
            mAnalysisData.IncidentMatchesDirty = query(mAnalysisData.IncidentMatchSort, aExpression);
       } else {
            mAnalysisData.IncidentMatchesDirty = query(mAnalysisData.IncidentMatchesClean, aExpression);
       }
    } else {
        mAnalysisData.IncidentMatchesDirty = query(mAnalysisData.SpatialMatchesList, aExpression);
    }

    mAnalysisData.IncidentMatchesPaginated = $.extend([], mAnalysisData.IncidentMatchesDirty);

    lList = lList.concat(mAnalysisData.IncidentMatchesDirty);

    if ($('#uAddressSpatial').hasClass('Selected')) {
        lList = lList.concat(mAnalysisData.AddressCards);
    }
    if ($('#uAddressSpatialEnrolleeMatch').hasClass('Selected')) {
        lList = lList.concat(mAnalysisData.EnrolleeMGAPCards);
    }
    mAnalysisControls.MatchesCardView.setDataSource(lList);

    selectNavigateBackAnalysisEnrollee();

    if (lList.length > 0) {
        $('#uAnalysisMapNoMatchesMessage').hide();
        $('.AnalysisMatchesEmptyListUnavailable').show();
        AnalysisDeleteSpatialCards();
    } else {
        $('#uAnalysisMapNoMatchesMessage').show();
        veritracks.system.applyFilterState('AnalysisMatches', true);
    }

    veritracks.localization.localizeTitle('#uAnalysisMatchesListHolder');
}

function analysisCardViewFilter_Init() {
    "use strict";
    if (isNullOrUndefined(mAnalysisControls.CardViewFilter)) {
        var lRiskLevels = RiskLevelFormatter(),
            lBuilder = new SumoPredicateBuilder(),
            lUserPreferences = getUserPreferences(1),
            lParams,
            lOrganizations = [],
            lKey;

        lBuilder.AddNewExpressionConditional('Id', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lOrganizations = query(OrganizationSortFormatter(), lBuilder.RootExpression);
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('Id', 1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        lRiskLevels = query(lRiskLevels, lBuilder.RootExpression);

        lParams = {
            'Title': localizeWrapper('cAnalysisFindIncidents'),
            'Content': '',
            'CssClass': 'DefaultFilter',
            'HideOnFilter': true,
            'OnFilter': uIncidentsCardViewFilter_OnFilter,
            'Columns': [
                    { 'Id': 'OrganizationId', 'Title': localizeWrapper('cEnrolleeOrganization'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': lOrganizations, 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
                    { 'Id': 'CaseNumber', 'Title': localizeWrapper('cAnalysisCaseNumber'), 'Type': 'Text', 'DataField': 'CaseNumber' },
                    { 'Id': 'IncidentNumber', 'Title': localizeWrapper('cAnalysisIncidentNumber'), 'Type': 'Text', 'DataField': 'IncidentNumber' },
                    { 'Id': 'EnrolleeName', 'Title': localizeWrapper('cEnrollee'), 'Type': 'Text', 'DataField': 'EnrolleeName' },
                    { 'Id': 'PrimaryOffenseId', 'Title': localizeWrapper('cEnrolleePrimaryOffense'), 'Type': 'Dropdown', 'DataField': 'PrimaryOffenseId', 'DataSource': getDataItems('Offense'), 'LocaleName':'Offense', 'DataValueField': 'Id', 'DataTextField': 'Description', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
                    { 'Id': 'Disposition', 'Title': localizeWrapper('cAnalysisDisposition'), 'Type': 'Dropdown', 'DataField': 'Disposition', 'DataSource': getDataItems('Disposition'), 'LocaleName': 'Disposition', 'DataValueField': 'Id', 'DataTextField': 'Description', 'InsertBlank': true, 'BlankText': localizeText('cAll') }
            ],
            'Settings': null,
            'UserPreferences': lUserPreferences,
            'UserId': gUserDetails.UserId,
            'UserPreferenceType': 1,
            'LocalizableMethod': localizeDataItem
        };

        mAnalysisControls.CardViewFilter = gFilterFactory.createControl('uIncidentsCardViewFilter', 'uAnalysisListFilterHolder', lParams);
    } else {
        mAnalysisControls.CardViewFilter.render();
    }
    mAnalysisControls.CardViewFilter.filter();
}

function uIncidentMatchesFilterOrganization_OnChange(aSender, aData, aParams) {
    "use strict";
    var lOrganizationId = aData.currentTarget.value,
        lRiskLevels = RiskLevelFormatter(),
        lBuilder = new SumoPredicateBuilder(),
        lRiskLevel,
        lRiskLevelList = [],
        lItems = [],
        lKey;

    for (lKey in lRiskLevels) {
        if (lRiskLevels.hasOwnProperty(lKey)) {
            lRiskLevel = lRiskLevels[lKey];
            lItems[lRiskLevel.Id] = lRiskLevel;
        }
    }
    if (lOrganizationId !== '') {
        lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lRiskLevels = query(lRiskLevels, lBuilder.RootExpression);
    } else {
        lRiskLevels = lItems;
    }
    mAnalysisControls.MatchesCardViewFilter.setColumnDataSource('RiskLevel', lRiskLevels);
}

function IncidentMatchesCardViewriskLevelsFilter_DataListConverter() {
    "use strict";
    var lRiskLevels = RiskLevelFormatter(),
        lRiskLevel,
        lItems = [],
        lKey;


    for (lKey in lRiskLevels) {
        if (lRiskLevels.hasOwnProperty(lKey)) {
            lRiskLevel = lRiskLevels[lKey];
            lItems[lRiskLevel.Id] = lRiskLevel;
        }
    }
    return lItems;
}


function analysisMatchesCardViewFilter_Init() {
    "use strict";
    if (isNullOrUndefined(mAnalysisControls.MatchesCardViewFilter)) {
        var lRiskLevels = riskLevelsFilter_DataListConverter(),
            lBuilder = new SumoPredicateBuilder(),
            lUserPreferences = getUserPreferences(1),
            lParams;

        lParams = {
            'Title': localizeWrapper('cAnalysisFindMatches'),
            'Content': '',
            'CssClass': 'DefaultFilter',
            'Alignment': 'FilterLeftAlignment',
            'HideOnFilter': true,
            'OnFilter': uIncidentsMatchesCardViewFilter_OnFilter,
            'Columns': [
                    { 'Id': 'EnrolleeName', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'EnrolleeName' },
                    { 'Id': 'OrganizationId', 'Title': localizeWrapper('cEnrolleeOrganization'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': getDataItems('Organizations'), 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
                    { 'Id': 'RiskLevel', 'Title': localizeWrapper('cEnrolleeRiskLevel'), 'Type': 'Dropdown', 'DataField': 'RiskLevelId', 'DataSource': lRiskLevels, 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll') }
            ],
            'Settings': null,
            'UserPreferences': lUserPreferences,
            'UserId': gUserDetails.UserId,
            'UserPreferenceType': 1
        };
        mAnalysisControls.MatchesCardViewFilter = gFilterFactory.createControl('uIncidentsMatchesCardViewFilter', 'uAnalysisMatchesListFilterHolder', lParams);
    } else {
        mAnalysisControls.MatchesCardViewFilter.render();
    }

    mAnalysisControls.MatchesCardViewFilter.bind('OrganizationIdchanged', uIncidentMatchesFilterOrganization_OnChange);
}

function analysisCache_Init(aCurrent) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    lBuilder.AddConditional(gNonErrorBuilder.RootExpression);

    lBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Id', -1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    mCache.bind('Incidentsupdated', mStateManagerAnalysisLayout_PreInit, aCurrent);
    mCache.AddUpdatableItem('Incidents',
                            gObjectList.Incident.AssemblyQualifiedName,
                            lBuilder.RootExpression,
                            gCacheSettings.IncidentsUpdateInterval,
                            null,
                            null,
                            true,
                            null);
}

function analysisIncidentsDetailsPopulate() {
    "use strict";
    var lCard = mAnalysisControls.CardView.selectedDataItem(),
    lMarker;
    if (!isNullOrUndefined(lCard)) {
        $('#uAddIncidentButton').show();
        if (lCard.Data.Street1 && lCard.Data.Street1.indexOf(lCard.Data.StreetAddressNumber) !== -1) {
            lCard.Data.StreetAddressNumber = '';
        } else {
            lCard.Data.Street1 = '';
        }
        PopulateDetailView(lCard.Data, {
            'OrganizationId': OrganizationNameFormatter,
            'StartDateUTC': DisplayShortDateTime,
            'EndDateUTC': DisplayShortDateTime,
            //'ClearedDateUTC': displayShortDate,
            'Status': processStatusFormatter,
            'TimeZoneId': spatialTimezoneCodeFormatter,
            'Disposition': dispositionFormatter,
            'ClearedException': clearedExceptionFormatter,
            'PrimaryOffense': offenseFormatter
        }, 'uIncidentDetail');
        if (!isNullOrUndefined(mAnalysisControls.Map)) {
        //    if (mStateManager.Settings()[1] == 'Details' && mAnalysisData.SpatialMatchIncident) {
                analysisSetViewZone(lCard.Data.Latitude, lCard.Data.Longitude, lCard.Data.Radius);
       //     }
            mAnalysisControls.Map.layerHide('address');
            mAnalysisControls.Map.layerShow('Incidents');
            setIncidentMarker(lCard);
            mAnalysisControls.Map.zoom(17);
            mAnalysisControls.Map.setCenter(lCard.Data.Latitude, lCard.Data.Longitude);
        }
    }

    //support for all data access permission
    // dont want to show button until cache object for devices is fully loaded.
    if (CheckUserHasPermission(45)) {
        checkUniversalDevicesCache();
    } else {
        $('#uAddSpatialQueryButton').show();
    }
}

function rerunMatches() {
    var lCard = mAnalysisControls.CardView.selectedDataItem();
    mAnalysisData.RequestId = gRequestManager.getRequestId();

    var lMatchInterval = setInterval(function () {
        if (mAnalysisControls.MatchesCardView.getDataSource().length > 0) {
            clearInterval(lMatchInterval);
        } else {
            mActivityNotification.addNotification('Searching for results....');
            veritracks.mapping.getIncidentMatches(lCard.Data.Id, analysisIncidentMatch_OnSuccess, Sad, { requestId: mAnalysisData.RequestId, intervalId: lMatchInterval });
        }
    }, 3000);
}
function analysisIncidentMatch_OnSuccess(aParams, aData) {
    "use strict";
    var lMatch,
        lCleanData = [],
        lEnrolleeIds = [],
        lSort = new SortExpression();
    if (mAnalysisData.RequestId === aParams.requestId) {
        FixDates(aData);

        if (aData.length == 0) {
            if (aParams.intervalId == 0)
                rerunMatches();

        }
        lSort.addAscendingColumn('Distance');
        aData = lSort.sort(aData);

        for (var lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lMatch = aData[lKey];
                lCleanData.push(lMatch);
            }
        }
        if (lCleanData.length == 0) {
            lCleanData = aData;
        }
        if (lCleanData.length > 0) {
            clearInterval(aParams.intervalId);
        }
        analysisMatchesDataListConverter(lCleanData);
        if (!isNullOrUndefined(mAnalysisControls.MatchesCardViewFilter)) {
            mAnalysisControls.MatchesCardViewFilter.filter();
        }

    } else {
        clearInterval(aParams.intervalId);
    }
}
function analysisIncidentsMapPopulate() {
    "use strict";
    var lCard = null,
        lBuilder = new SumoPredicateBuilder();

    if (!isNullOrUndefined(mAnalysisControls.CardView)) {
        lCard = mAnalysisControls.CardView.selectedDataItem();
    }
    if (!isNullOrUndefined(lCard)) {
        lBuilder.AddNewExpressionConditional('IncidentId', lCard.Data.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        if (!isNullOrUndefined(mAnalysisControls.MatchesCardView)) {
            mAnalysisControls.MatchesCardView.setDataSource([]);
        }
        if (!isNullOrUndefined(mAnalysisControls.Map)) {
            mAnalysisControls.Map.layerSetDataSource('Places', []);
        }
        getIncidentMatches(lCard.Data.Id);
        //veritracks.mapping.getIncidentMatches(lCard.Data.Id, analysisIncidentMatch_OnSuccess, Sad, mAnalysisData.RequestId);
        //ReadMultiple(gObjectList.IncidentMatch.AssemblyQualifiedName, lBuilder.RootExpression, 0, analysisIncidentMatch_OnSuccess, Sad, mAnalysisData.RequestId, null, 0);
        if (!isNullOrUndefined(mAnalysisControls.Map)) {
            analysisSetViewZone(lCard.Data.Latitude, lCard.Data.Longitude, lCard.Data.Radius);
            setIncidentMarker(lCard);
        }
    }


}

function getIncidentMatches(aIncidentId) {
    mAnalysisData.RequestId = gRequestManager.getRequestId();
    veritracks.mapping.getIncidentMatches(aIncidentId, analysisIncidentMatch_OnSuccess, Sad, { requestId: mAnalysisData.RequestId, intervalId: 0 });
}

function uAnalysisCardView_OnSelectChange(aSender, aId, aData) {
    "use strict";
    if (!isNullOrUndefined(mAnalysisControls.PlaybackControl)) {
        if (mAnalysisData.PlaybackStatus === 'Playing') {
            uAnalysisMapPlaybackStopButton_OnClick();
        }
    }
    var lCard = mAnalysisControls.CardView.selectedDataItem();
    if (mStateManager.Settings()[1] === 'Details') {
        uAnalysisExitEditMode();
        analysisIncidentsDetailsPopulate();
    } else {
        if (!isNullOrUndefined(mAnalysisControls.NotificationPanel)) {
            mAnalysisControls.NotificationPanel.clearNotifications();
        }
        $('#uAddressSpatialEnrolleeMatch').removeClass('Selected');
        $('#uAddressSpatial').removeClass('Selected');
        mAnalysisData.AddressCards = null;
        mAnalysisData.EnrolleeMGAPCards = null;
        if (!isNullOrUndefined(mAnalysisControls.Map)) {
            mAnalysisControls.Map.layerSetDataSource('EnrolleeMGAP', []);
            mAnalysisControls.Map.layerSetDataSource('EnrolleeMGAPLabels', []);
            mAnalysisControls.Map.layerSetDataSource('Address', []);
            mAnalysisControls.Map.layerSetDataSource('AddressLabels', []);
        }
        analysisIncidentsMapPopulate();
        if (!isNullOrUndefined(mAnalysisControls.Map) && !isNullOrUndefined(lCard)) {
            mAnalysisControls.Map.setCenter(lCard.Data.Latitude, lCard.Data.Longitude);
        }
    }
    if (!isNullOrUndefined(lCard)) {
        setViewState('AnalysisSelectedIncident', lCard.Id);
    }

}

function analysisIncidentMatchTrackpoint_OnSuccess(aParams, aData) {
    "use strict";
    if (!isNullOrUndefined(mAnalysisControls.Map)) {
        var lTrackpoint,
            lSort = new SortExpression(),
            lKey,
            lCount = 1,
            lTrackItem,
            lLabelList = [],
            lTrackList = [];
            FixDates(aData);

        lSort.addAscendingColumn('TrackDate');
        aData = lSort.sort(aData);

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lTrackItem = aData[lKey];
                if (lTrackItem.Latitude !== 0 && lTrackItem.Longitude !== 0) {
                    lTrackList.push(veritracks.mapping.prepareTrackpointMarkerItem_dep({ 'Latitude': lTrackItem.Latitude, 'Longitude': lTrackItem.Longitude, 'TrackTypeId': 1, 'TrackDate': lTrackItem.TrackDate, 'TrackDateUTC': lTrackItem.TrackDateUTC }));
                    lTrackItem.DisplayName = '(T' + lCount++ +')';
                    lLabelList.push(lTrackItem);
                }
            }
        }
        mAnalysisControls.Map.layerSetDataSource('MatchTrackPoints', lTrackList);
        mAnalysisControls.Map.layerSetDataSource('Labels', veritracks.mapping.prepareTrackpointDetailCardLabelOverlayData(lLabelList));
        if($('#uAnalysisLabelToggle').hasClass('Selected')){
            mAnalysisControls.Map.layerShow('Labels');
        }else{
            mAnalysisControls.Map.layerHide('Labels');
        }
        mAnalysisControls.Map.fitBounds();

        mAnalysisData.TrackPointMatches = lTrackList;
    }
}

function uAnalysisEnrollee_OnClick(aMatchId) {
    "use strict";
    var lMatchId = aMatchId.replace(/\D/g, '');
    var lButtonBar = GenerateButtonCommandBar();
    var lCard = mAnalysisControls.MatchesCardView.selectedDataItem();
    var lEnrollee = GetEnrollee(lCard.EnrolleeId);
    GenerateButton(localizeWrapper('cEnrolleeGoEnrollee'), 'EnrolleesButton', uAnalysisIncidentMatchDetails_OnClick).appendTo(lButtonBar);
    GenerateButton(localizeWrapper('cEnrolleeClose'), 'Cancel', ClosePopup).appendTo(lButtonBar);
    DisplayPopup(EnrolleeTypeFormatter(lEnrollee.EnrolleeType) + ' - ' + lEnrollee.FullName + ' (' + lEnrollee.PrimaryId + ')', '<div id="uAnalysisEnrolleePopupHolder" style="max-height:700px"></div>', lButtonBar, false, false);
    //// calls main timeline popup that will hold tabs --- go to timelinePopulate_Init
    if (lEnrollee.EnrolleeType == 1) {
        populateElement('uAnalysisEnrolleePopupHolder', 'Enrollees.Offenders.Profile.Incidents.Layout.htm', analysisLoadOffender_Init);
    } else {
        populateElement('uAnalysisEnrolleePopupHolder', 'Enrollees.Victims.Profile.Layout.htm', analysisLoadVictim_Init);
    }
}

function offenderCategoryReadIncident_OnComplete(aParams, aData) {
    "use strict";
    if (aParams === mEnrolleesData.OffenderCurrentId && !isNullOrUndefined(aData)) {
        var lKey, lCategory, lHtml = [];

        mEnrolleesData.OffenderProfileCategories = aData;
        for (lKey in mEnrolleesData.OffenderProfileCategories) {
            lCategory = mEnrolleesData.OffenderProfileCategories[lKey];
            if (lCategory.IsActive) {
                lHtml.push('<div>');
                lHtml.push(dataItemFormatter('MetaEnrolleeCategory', 'Description', '', mEnrolleesData.OffenderProfileCategories[lKey].MetaEnrolleeCategoryId));//getDataItem(mEnrolleesData.OffenderProfileCategories[lKey].MetaEnrolleeCategoryId, 'MetaEnrolleeCategory').Description);
                lHtml.push('</div>');
            }
        }
        $('#uOffenderProfileIncidentCategoryList').html(lHtml.join(''));

    }
}

function offenderSexOffenseReadIncident_OnComplete(aParams, aData) {
    "use strict";
    if (aParams === mEnrolleesData.OffenderCurrentId && !isNullOrUndefined(aData)) {
        var lKey, lItem, lHtml = [];
        mEnrolleesData.OffenderProfileSexOffenses = aData;
        for (lKey in mEnrolleesData.OffenderProfileSexOffenses) {
            if (mEnrolleesData.OffenderProfileSexOffenses.hasOwnProperty(lKey)) {
                lItem = mEnrolleesData.OffenderProfileSexOffenses[lKey];
                if (lItem.IsActive) {
                    lHtml.push('<div>');
                    lHtml.push(dataItemFormatter('SexOffense', 'Description', '', mEnrolleesData.OffenderProfileSexOffenses[lKey].SexOffenseId));// getDataItem(mEnrolleesData.OffenderProfileSexOffenses[lKey].SexOffenseId, 'SexOffense').Description);
                    lHtml.push('</div>');
                }
            }
        }
        $('#uOffenderProfileIncidentSexOffenseList').html(lHtml.join(''));
    }
}

function PopulateEMAProfileViewsIncident(aParams, aData) {
    var lEMAData = {
        HasEnrolleeMobileApp: 'No',
        CellPhoneNumber: '',
        CellPhoneNumberEdit: ''
    };


    $('#OffenderProfileIncidentCellPhoneNumber').show();

    if (aData[0] && aData[0].EMAFlag === 1) {
        $('#uOffenderProfileIncidentHasEnrolleeMobileApp').show();
        if (aData[0].HasEnrolleeMobileApp !== undefined && aData[0].HasEnrolleeMobileApp === 1) {
            $('#uEnrolleesMobileAppIncident').show();
            lEMAData.HasEnrolleeMobileApp = "Yes";
            $('#uEMAHasEnrolleeMobileAppIncidentEdit').prop('checked', true);
            $('#uEMAHasEnrolleeMobileAppIncident').val('Yes');
            $('#uEMACellPhoneNumberIncidentEdit').addClass("ValidateRequired");

        } else {
            lEMAData.HasEnrolleeMobileApp = "No";
            $('#uEnrolleesMobileAppIncident').hide();
            $('#uEMAHasEnrolleeMobileAppIncidentEdit').prop('checked', false);
            $('#uEMAHasEnrolleeMobileAppIncident').val('No');
            $('#uEMACellPhoneNumberIncidentEdit').removeClass("ValidateRequired");

        }
        if (aData[0].CellPhoneNumber !== undefined && aData[0].CellPhoneNumber !== "") {
            lEMAData.CellPhoneNumber = aData[0].CellPhoneNumber;
            lEMAData.CellPhoneNumberEdit = aData[0].CellPhoneNumber;
            $('#uEMACellPhoneNumberIncidentEdit').val(aData[0].CellPhoneNumber);
            $('#uEMAIncidentCellPhoneNumber').val(aData[0].CellPhoneNumber);
        } else {
            $('#uEMACellPhoneNumberIncidentEdit').val("");
            $('#uEMACellPhoneNumberIncident').val("");
        }
        PopulateDetailView(lEMAData, {
            'CellPhoneNumber': CellPhoneNumberFormatter,
            'CellPhoneNumberEdit': CellPhoneNumberFormatter,
        }, 'uEMAIncident');
    } else if (aData[0] && aData[0].EMAFlag === 0) {

        $('#uOffenderProfileIncidentHasEnrolleeMobileApp').hide();
        lEMAData.HasEnrolleeMobileApp = "No";

        $('#uEnrolleesMobileAppIncident').hide();
        $('#uEMAHasEnrolleeMobileAppIncident').val('No');
        $('#uEMACellPhoneNumberIncidentEdit').removeClass("ValidateRequired");
        $('#uEMAHasEnrolleeMobileAppIncidentEdit').prop('checked', false);
        if (aData[0].CellPhoneNumber !== undefined && aData[0].CellPhoneNumber !== "") {
            lEMAData.CellPhoneNumber = aData[0].CellPhoneNumber;
            lEMAData.CellPhoneNumberEdit = aData[0].CellPhoneNumber;
            $('#uEMACellPhoneNumberIncidentEdit').val(aData[0].CellPhoneNumber);
            $('#uEMAIncidentCellPhoneNumber').val(aData[0].CellPhoneNumber);
        } else {
            $('#uEMACellPhoneNumberIncidentEdit').val("");
            $('#uEMAIncidentCellPhoneNumber').val("");
        }
        PopulateDetailView(lEMAData, {
            'CellPhoneNumber': CellPhoneNumberFormatter,
            'CellPhoneNumberEdit': CellPhoneNumberFormatter,
        }, 'uEMAIncident');
    }
}

function offenderProfilePopulateIncident(aId, aCallback) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId;
    var lCallback = offenderProfileRead_OnComplete; //default callback

    if (aCallback) {
        lCallback = aCallback;
    }
    if (aId) {
        lEnrolleeId = aId;
    }

    GetEMAEnrolleeStatus(lEnrolleeId, PopulateEMAProfileViewsIncident, Sad, null);
    lBuilder.AddNewExpressionConditional('Id', lEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.OffenderProfile.AssemblyQualifiedName, lBuilder.RootExpression, 0, lCallback, offenderProfileRead_OnFailure, mEnrolleesData.OffenderCurrentId, null, 0);


    ReadMultiple(gObjectList.OffenderCategory.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderCategoryReadIncident_OnComplete, offenderCategoryRead_OnFailure, mEnrolleesData.OffenderCurrentId, null, 0);
    ReadMultiple(gObjectList.OffenderSexOffense.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderSexOffenseReadIncident_OnComplete, offenderSexOffenseRead_OnFailure, mEnrolleesData.OffenderCurrentId, null, 0);

    enrolleesOffenderImageUpload_Reset();
}

function analysisLoadOffender_Init() {
    "use strict";
    var lCard = mAnalysisControls.MatchesCardView.selectedDataItem();
    //$('#uOffenderProfileButtonBar').hide();
    offenderProfilePopulateIncident(lCard.EnrolleeId, analysisEnrolleeOnClickLoad_Success);
}

function analysisEnrolleeOnClickLoad_Success(aParams, aData) {
    var lCard = mAnalysisControls.MatchesCardView.selectedDataItem();
    var lBuilder = new SumoPredicateBuilder();

    offenderProfileRead_OnCompleteIncident(aParams, aData);

    if (CheckUserHasPermission(45)) {
        $('#uOffenderProfileIncidentAgentId').text(lCard.Agent);
        lBuilder.AddNewExpressionConditional('Id', lCard.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.Organization.AssemblyQualifiedName, lBuilder.RootExpression, 0, analysisLoadOrganizationName, Sad, null);
    }
    function analysisLoadOrganizationName(aParams, aData) {
        var lOrganization = aData[0];

        $('#uOffenderProfileIncidentOrganizationId').text(lOrganization.Name);
    }

}

function offenderEnrolleePopulateIncident(aId) {
    "use strict";
    var lOffender;
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId;
    var lBuilder = new SumoPredicateBuilder();

    if (aId) {
        lEnrolleeId = aId;
    }

    lOffender = GetEnrollee(lEnrolleeId);

    // temporary localization for arkansas
    if (lOffender) {
        if (checkOrganizationProperty(lOffender.OrganizationId, 'is_arkansas_th') == "Y") {
            tempLocalizationOffenderProfile_Arkansas(lOffender.OrganizationId);
        } else {
            removeTempLocalizationOffenderProfile_Arkansas(lOffender.OrganizationId);
        }
    }

    PopulateDetailView(lOffender, {
        'AgentId': AgentNameFormatter,
        'OrganizationId': OrganizationNameFormatter,
        'RiskLevelId': EnrolleeRiskLevelFormatter,
        'Birthdate': BirthDateStringFormatter,
        'ReferralDate': dateSelectorFormatter,
        'OffenderPayFlag': EnrolleeAlcoholFlagFormatter,
        'AlcoholDeviceFlag': EnrolleeAlcoholFlagFormatter
    }, 'uOffenderProfileIncident');

}

function updatePhotoIncidentNumbers(aNumber) {
    "use strict";

    if (!isNullOrUndefined(aNumber)) {
        $("#uCurrentIncidentPhotoIndex").html(aNumber);
    } else if (mEnrolleesData.OffenderPhotos.length == 0) {
        $("#uCurrentIncidentPhotoIndex").html(mEnrolleesData.OffenderPhotoIndex);
    } else {
        $("#uCurrentIncidentPhotoIndex").html(mEnrolleesData.OffenderPhotoIndex + 1);
    }

    $("#uTotalIncidentPhotoIndex").html(mEnrolleesData.OffenderPhotos.length);
}

function uGoToNextOffenderIncidentPhoto(aDirection) {
    "use strict";
    var lNextOffender,
        lCurrentOffender,
        lFoundOffender = false;


    if (aDirection == 1 && mEnrolleesData.OffenderPhotoIndex == mEnrolleesData.OffenderPhotos.length - 2) {
        mEnrolleesData.OffenderPhotoIndex++;
        lNextOffender = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex];
        if (lNextOffender.PhotoTypeId == 5) {
            if (lNextOffender.PhotoUri === "") {
                $("#uOffenderProfileIncidentPhotoUri").attr("src", "Images/NoPhoto.png");
            } else {
                $("#uOffenderProfileIncidentPhotoUri").attr("src",  MUGSHOTS + lNextOffender.PhotoUri);
            }
        } else {
            $("#uOffenderProfileIncidentPhotoUri").attr("src",  MUGSHOTS + lNextOffender.PhotoUri);
        }
        $("#uOffenderProfileIncidentPhotoUri").attr("title", lNextOffender.PhotoDescription);
        $("#uNextOffenderIncidentPhotoButton").hide();
        $("#uNextOffenderIncidentPhotoButtonContainer").show();
        $("#uPreviousOffenderIncidentPhotoButton").show();
        $("#uPreviousOffenderIncidentPhotoButtonContainer").hide();
    } else if (aDirection == -1 && mEnrolleesData.OffenderPhotoIndex == 1) {
        mEnrolleesData.OffenderPhotoIndex--;
        lNextOffender = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex];
        if (lNextOffender.PhotoTypeId == 5) {
            if (lNextOffender.PhotoUri === "") {
                $("#uOffenderProfileIncidentPhotoUri").attr("src", "Images/NoPhoto.png");
            } else {
                $("#uOffenderProfileIncidentPhotoUri").attr("src",  MUGSHOTS + lNextOffender.PhotoUri);
            }
        } else {
            $("#uOffenderProfileIncidentPhotoUri").attr("src",  MUGSHOTS + lNextOffender.PhotoUri);
        }
        $("#uOffenderProfileIncidentPhotoUri").attr("title", lNextOffender.PhotoDescription);
        $("#uPreviousOffenderIncidentPhotoButton").hide();
        $("#uPreviousOffenderIncidentPhotoButtonContainer").show();
        $("#uNextOffenderIncidentPhotoButton").show();
        $("#uNextOffenderIncidentPhotoButtonContainer").hide();
    } else {
        mEnrolleesData.OffenderPhotoIndex = mEnrolleesData.OffenderPhotoIndex + aDirection;
        lNextOffender = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex];
        if (lNextOffender.PhotoTypeId == 5) {
            if (lNextOffender.PhotoUri === "") {
                $("#uOffenderProfileIncidentPhotoUri").attr("src", "Images/NoPhoto.png");
            } else {
                $("#uOffenderProfileIncidentPhotoUri").attr("src",  MUGSHOTS + lNextOffender.PhotoUri);
            }
        } else {
            $("#uOffenderProfileIncidentPhotoUri").attr("src",  MUGSHOTS + lNextOffender.PhotoUri);
        }
        $("#uOffenderProfileIncidentPhotoUri").attr("title", lNextOffender.PhotoDescription);
        $("#uPreviousOffenderIncidentPhotoButton").show();
        $("#uPreviousOffenderIncidentPhotoButtonContainer").hide();
        $("#uNextOffenderIncidentPhotoButton").show();
        $("#uNextOffenderIncidentPhotoButtonContainer").hide();
    }



    mEnrolleesData.OffenderPhotoDescription = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoDescription;
    $("#uPhotoIncidentType").val(mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoTypeId);

    if (isNullOrUndefined(mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoUri) || mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoUri == "") {
        $("#uOffenderProfileIncidentPhotoUri").attr("src", "Images/NoPhoto.png");
    }


    updatePhotoIncidentNumbers();

}

function offenderIncidentPhoto_OnSuccess(aParams, aData) {
    "use strict";
    var lSort = new SortExpression();

    lSort.addAscendingColumn("PhotoOrderNo");

    if (!aData.hasOwnProperty("Data") && aData.length != 0) {
        mEnrolleesData.OffenderPhotos = lSort.sort(aData);
        mEnrolleesData.OffenderPhotoIndex = 0;
        if (mEnrolleesData.OffenderPhotos[0].PhotoTypeId == 5) {
            if (mEnrolleesData.OffenderPhotos[0].PhotoUri === "") {
                $('#uOffenderProfileIncidentPhotoUri').attr('src', 'Images/NoPhoto.png');
            } else {
                $("#uOffenderProfileIncidentPhotoUri").attr("src",  MUGSHOTS + mEnrolleesData.OffenderPhotos[0].PhotoUri);
            }
        } else {
            $("#uOffenderProfileIncidentPhotoUri").attr("src",  MUGSHOTS + mEnrolleesData.OffenderPhotos[0].PhotoUri);
        }
        $("#uOffenderProfileIncidentPhotoUri").attr("title", mEnrolleesData.OffenderPhotos[0].PhotoDescription);
        $("#uOffenderProfileIncidentPhotoUri").css("width", "auto");
        $("#uPreviousOffenderIncidentPhotoButton").hide();
        if (aData.length == 1) {
            $("#uPreviousOffenderIncidentPhotoButtonContainer").hide();
            $("#uNextOffenderIncidentPhotoButton").hide();
            $("#uNextOffenderIncidentPhotoButtonContainer").hide();
        } else {
            $("#uPreviousOffenderIncidentPhotoButtonContainer").show();
        }

        $("#uPhotoIncidentType").val(mEnrolleesData.OffenderPhotos[0].PhotoTypeId);
        $("#uPhotoIncidentNumberContainer").show();

        updatePhotoIncidentNumbers();

    } else {
        mEnrolleesData.OffenderPhotos = [];
        $('#uOffenderProfileIncidentPhotoUri').attr('src', 'Images/NoPhoto.png');
        $("#uOffenderProfileIncidentPhotoUri").css("width", "97px");
        $("#uOffenderProfileIncidentPhotoUri").attr("title", "Enrollee Photo");
        $("#uPreviousOffenderIncidentPhotoButton").hide();
        $("#uPreviousOffenderIncidentPhotoButtonContainer").hide();
        $("#uNextOffenderIncidentPhotoButton").hide();
        $("#uNextOffenderIncidentPhotoButtonContainer").hide();
        $("#uPhotoIncidentTypeContainer").hide();
        $("#uPhotoIncidentNumberContainer").hide();
    }

    if (aData.length > 1) {
        $("#uNextOffenderIncidentPhotoButton").show();
        $("#uNextOffenderIncidentPhotoButtonContainer").hide();
    }
}

function offenderProfileRead_OnCompleteIncident(aParams, aData) {

    var lDetailsOptions = {
        'SupervisionBeginDate': dateSelectorFormatter,
        'SupervisionEndDate': dateSelectorFormatter,
        'DailyRate': displayDailyRate,
        'TimeZoneCode': timezoneCodeFormatter,
        'GenderId': genderFormatter,
        'RaceId': raceFormatter,
        'HairColorId': colorFormatter,
        'EyeColorId': colorFormatter,
        'Height': displayHeight,
        'Weight': displayWeight,
        'PrimaryOffenseId': offenseFormatter,
        'SupervisionTypeId': offenderSupervisionTypeFormatter,
        'VehicleYear': vehicleYearFormatter,
        'VehicleMake': vehicleMakeFormatter,
        'VehicleColor': vehicleColorFormatter,
        'IsSexOffender': displayBoolean,
        'LanguageId': offenderLanguageFormatter,
        'SecurusEnrolleePayId': OffenderPayFlagFormatter
    };

    if (aParams === mEnrolleesData.OffenderCurrentId && !isNullOrUndefined(aData[0])) {
        mEnrolleesData.OffenderProfileCurrent = aData[0];
        var lOffender = GetEnrollee(mEnrolleesData.OffenderProfileCurrent.Id);
        FixDates(aData);
        offenderEnrolleePopulateIncident(lOffender.Id);
        if (checkOrganizationProperty(lOffender.OrganizationId, 'is_arkansas_all') == "Y") {
            lDetailsOptions['OrganizationAddressId'] = OrganizationAddressTitleformatter;
        }
        PopulateDetailView(mEnrolleesData.OffenderProfileCurrent, lDetailsOptions, 'uOffenderProfileIncident');

        loadEnrollePhotos(aData[0].Id, offenderIncidentPhoto_OnSuccess);
    }
    if (!isNullOrUndefined(mEnrolleesData.OffenderProfileCurrent) && mEnrolleesData.OffenderProfileCurrent.Height === 0) {
        $('#uOffenderProfileIncidentHeight').hide();
    }
    //isAssignedCheck();
}

function analysisLoadVictim_Init() {
    "use strict";
    var lCard = mAnalysisControls.MatchesCardView.selectedDataItem();
    $('#uVictimProfileButtonBar').hide();
    Victim.victimProfilePopulate(lCard.EnrolleeId);
}

function uAnalysisIncidentMatchDetails_OnClick() {
    "use strict";
    var lMatchCard = mAnalysisControls.MatchesCardView.selectedDataItem(),
        lPreference = new UserPreference(),
        lTimeFrame,
        lEnrollee = getDataItem(lMatchCard.EnrolleeId, 'Enrollees'),
        lAdvancedPermissions = CheckUserHasPermission(45),
        lMissingEnrollee = false,
        lDropdownValue = 5,
        lMaxDurationSetting = veritracks.system.clientSetting('searchablemaxduration');

    if (lAdvancedPermissions) {
        if (isNullOrUndefined(lEnrollee)) {
            lMissingEnrollee = true;
        }
    }

    if (PopupIsOpen()) {
        ClosePopup();
    }

    function complete() {
        var lMoment = moment();

        setViewState('AnalysisEnrolleeReturn', lMatchCard.Id);
        if (moment(lMatchCard.EndDateUTC) < lMoment.add(100, 'day')) {
            lMatchCard.Data.EnrolleeId = lMatchCard.Data.Id;
            var lEndDate = moment(lMatchCard.EndDateDisplay);
            setViewState('AnalysisMatchEndDate', lEndDate);
        } else {
            setViewState('AnalysisMatchEndDate', lMoment._d);
        }
        if (mStateManager.Settings()[0] == 'Incidents') {
            setViewState('AnalysisView', 'Incidents');
        } else {
            var lCard = mAnalysisControls.CardView.selectedDataItem();
            setViewState('AnalysisView', 'History');
            setViewState('SpatialMatchesEnrollee', lCard);
        }

        if (!lMissingEnrollee) {
            if (lEnrollee && lEnrollee.EnrolleeType == 1) {
                ClosePopup();
                window.location.hash = 'Enrollees.Offenders.Map.Events.' + lMatchCard.EnrolleeId.toString();
            }
            else if (lEnrollee && lEnrollee.EnrolleeType == 2) {
                ClosePopup();
                window.location.hash = 'Enrollees.Victims.Map.Events.' + lMatchCard.EnrolleeId.toString();
            } else {
                mActivityNotification.addNotification(localizeWrapper('cEnrolleeUnknownEnrollee'));
            }
        }
        else {
            EnrolleesAdvancedDataPermissions('Enrollees.Offenders.Map.Events', lMatchCard.EnrolleeId);
        }
    }

    if (!isNullOrUndefined(lMatchCard)) {
        lTimeFrame = lMatchCard.EndDateUTC - lMatchCard.StartDateUTC;
        lTimeFrame = lTimeFrame / (1000 * 60); // ms to minutes

        if (lTimeFrame > 7200) { // five days
            lDropdownValue = 10080;
        } else if (lTimeFrame > 5760) { // four days
            lDropdownValue = 7200;
        } else if (lTimeFrame > 4320) { // three days
            lDropdownValue = 5760;
        } else if (lTimeFrame > 2880) { // two days
            lDropdownValue = 4320;
        } else if (lTimeFrame > 1440) { // one day
            lDropdownValue = 2880;
        } else if (lTimeFrame > 720) { // twelve hours
            lDropdownValue = 1440;
        } else if (lTimeFrame > 480) { // eight hours
            lDropdownValue = 720;
        } else if (lTimeFrame > 240) { // four hours
            lDropdownValue = 480;
        } else if (lTimeFrame > 120) { // two hours
            lDropdownValue = 240;
        } else if (lTimeFrame > 60) { // one hour
            lDropdownValue = 120;
        } else if (lTimeFrame > 30) { // thirty minutes
            lDropdownValue = 60;
        } else if (lTimeFrame > 15) { // fifteen minutes
            lDropdownValue = 30;
        } else if (lTimeFrame > 10) { // ten minuties
            lDropdownValue = 15;
        } else if (lTimeFrame > 5) { // five minutes
            lDropdownValue = 10;
        }

        /* Dropdown greater than MaxDurationSetting FIX #6*/
        if (lMaxDurationSetting) {
            var lMaxDuration = lMaxDurationSetting * 60;
            if (lDropdownValue > lMaxDuration) {
                lDropdownValue = lMaxDuration;
            }
        }


        mActivityNotification.addNotification(lDropdownValue, null, gSystemSettings.IsDebug);

        lPreference.ColumnName = 'MapTimeSpan';
        lPreference.Id = gUserDetails.UserId;
        lPreference.UserPreferenceType = 4;
        lPreference.Value = lDropdownValue;
        writeUserPreferences([lPreference], complete);

    }
}

function uAnalysisMatchesCardView_OnSelectChange(aSender, aId, aData) {
    "use strict";
    var lCard = mAnalysisControls.MatchesCardView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder(),
        lTrackItem,
        lFilename,
        lTrackpointList;
    mAnalysisControls.Map.layerSetDataSource('MatchTrackPoints', []);
    mAnalysisControls.Map.layerSetDataSource('Labels', []);
    mAnalysisControls.Map.layerSetDataSource('Selected', []);
    if (!isNullOrUndefined(lCard)) {
        if (mAnalysisData.PlaybackStatus === 'Playing') {
            uAnalysisMapPlaybackStopButton_OnClick();
        }
        if (lCard.Type == 2) {
            mAnalysisControls.Map.locate(lCard.TrackItem.latitude.toString() + ', ' + lCard.TrackItem.longitude.toString(), null);
            lTrackItem = $.extend({}, lCard.TrackItem);
            lFilename = lTrackItem.iconUri.substring(0, lTrackItem.iconUri.length - 4) + 'Selected.png';
            lTrackItem.iconUri = lFilename;
            mAnalysisControls.Map.layerSetDataSource('Selected', [lTrackItem]);
            veritracks.enrollees.mapping.zoomOut(mAnalysisControls.Map.getMap(), 2);
        } else {
            if (lCard.SpatialMatchSearch) {
                // stored in local object
                if (lCard.IsDeleted) {
                    if (!$('.DeletableButton').hasClass('AddableButton')) {
                        $('.DeletableButton').addClass('AddableButton');
                        $('.DeletableButton').attr('title', 'enable enrollee');
                    }
                } else {
                    if ($('.DeletableButton').hasClass('AddableButton')) {
                        $('.DeletableButton').removeClass('AddableButton');
                        $('.DeletableButton').attr('title', 'delete enrollee');
                    }
                }
                lBuilder.AddNewExpressionConditional('GroupId', lCard.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lTrackpointList = query(mAnalysisData.SpatialMatches, lBuilder.RootExpression);
                analysisIncidentMatchTrackpoint_OnSuccess(null, lTrackpointList);
            } else {
                getIncidentMatchTrackpointsProcedure(analysisIncidentMatchTrackpoint_OnSuccess, [lCard.Data.Id]);
                //lBuilder.AddNewExpressionConditional('IncidentMatchId', lCard.Data.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                //ReadMultiple(gObjectList.IncidentMatchTrackpoint.AssemblyQualifiedName, lBuilder.RootExpression, 0, analysisIncidentMatchTrackpoint_OnSuccess, Sad, lCard.Data.Id, null, 0);
            }
        }
    }
    applyUserPermissions([12, 18, 21]);
    if (!isNullOrUndefined(lCard)) {
        setViewState('AnalysisSelectedIncidentResult', lCard.Id);
    }

}

function analysisIncident_OnSuccess(aParams, aData) {
    "use strict";
    var lSortState = getViewState('AnalysisCardViewSort');
    $('#uAddIncidentButton').show();
    $('#uSaveIncidentButton').hide();
    FixDates(aData);
    if (isNullOrUndefined(lSortState)) {
        aData = AnalysisIncidentFormatter(aData);
    }
    mAnalysisControls.CardView.setDataSource(aData);
}

function uAnalysisIncidentsCardView_OnUpdate() {
    "use strict";
    mAnalysisControls.CardViewFilter.filter();
}

function uAnalysisIncidentsCardView_OnDataBind(aSender, aParams, aData) {
    "use strict";
    mAnalysisControls.CardView.unbind('databind', uAnalysisIncidentsCardView_OnDataBind);
    mAnalysisControls.CardView.bind('databind', cardView_OnDataBind);
    mAnalysisControls.CardView.selected(aData);
}

function uAnalysisIncidentMatchCardViewSortOnViewState() {
    "use strict";
    var lSortState = getViewState('AnalysisIncidentMatchCardViewSort');

    if (!isNullOrUndefined(lSortState)) {

        mAnalysisControls.MatchesCardView.sortExpression(lSortState.Value);
    }
}

function uAnalysisCardViewSortOnViewState() {
    "user strict";
    var lSortState = getViewState('AnalysisCardViewSort');

    if (!isNullOrUndefined(lSortState)) {

        mAnalysisControls.CardView.sortExpression(lSortState.Value);
    }
}

function uAnalysisCardView_OnSort(aParams, aSort) {
    "use strict";
    var lIncidents = mAnalysisData.IncidentClean,
        lIncidentsListSorted = [];
    var lEnrolleeViewState = getViewState('AnalysisEnrolleeReturn');

    if (lEnrolleeViewState && lEnrolleeViewState.Value) {
    } else {

        lIncidentsListSorted = aSort.sort(lIncidents);
        mAnalysisData.IncidentSort = lIncidentsListSorted;
        mAnalysisControls.CardViewFilter.filter();
        setViewState('AnalysisCardViewSort', aSort);
    }
}

function analysisIncident_Init() {
    "use strict";
    var lViewState = getViewState('AnalysisSelectedIncident');
    if (isNullOrUndefined(mAnalysisControls.CardView)) {
        mAnalysisControls.CardView = new sumo.controls.CardView('uAnalysisCardView', 'uAnalysisListHolder', { 'cardTemplate': 'Interface/Analysis.Incidents.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': false, 'cssClass': 'VeritracksCardView', 'keyField': 'Id', 'isSortable': true, 'Columns': [
            { 'id': 'IncidentNumber', 'title': localizeWrapper('cAnalysisIncidentNumber')},
            { 'id': 'StartDate', 'title': localizeWrapper('cEventStartDate') },
            { 'id': 'EndDate', 'title': localizeWrapper('cEnrolleeEndDate') }
        ]
        });
        mAnalysisControls.CardView.bind('selectedchanged', uAnalysisCardView_OnSelectChange);
        mAnalysisControls.CardView.bind('databind', cardView_OnDataBind);
        mAnalysisControls.CardView.bind('update', uAnalysisIncidentsCardView_OnUpdate);
        mAnalysisControls.CardView.bind('sort', uAnalysisCardView_OnSort);
    }
    if (!isNullOrUndefined(lViewState)) {
        mAnalysisControls.CardView.bind('databind', uAnalysisIncidentsCardView_OnDataBind, lViewState.Value);
    } else {
        mAnalysisControls.CardView.bind('databind', cardView_OnDataBind);
    }
}

function uAnalysisMatchesCardView_OnDataBind(aSender, aParams, aData) {
    "use strict";
    mAnalysisControls.MatchesCardView.unbind('databind', uAnalysisMatchesCardView_OnDataBind);
    mAnalysisControls.MatchesCardView.bind('databind', cardView_OnDataBind);
    mAnalysisControls.MatchesCardView.selected(aData);
    if (isNullOrUndefined(mAnalysisControls.MatchesCardView.selectedDataItem())) {
        cardView_OnDataBind(aSender, aParams, aData);
    }
    AnalysisDeleteSpatialCards();
}


function analysisIncidentMatches_Init() {
    "use strict";
    var lViewState = getViewState('AnalysisSelectedIncidentResult');

    if (isNullOrUndefined(mAnalysisControls.MatchesCardView)) {
        mAnalysisControls.MatchesCardView = new sumo.controls.CardView('uAnalysisMatchesCardView', 'uAnalysisMatchesListHolder', {
            'cardTemplate': 'Interface/Analysis.Matches.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': false, 'cssClass': 'VeritracksCardView', 'keyField': 'Id', 'keyFieldType': 'number', 'IgnoreOnClick': 'DeletableButton',
            'isSortable': true, 'Columns': [
                { 'id': 'EnrolleeName', 'title': localizeWrapper('cEnrolleeName') },
                { 'id': 'PrimaryId', 'title': localizeWrapper('cEnrolleePrimaryId') }
            ]
        });
        mAnalysisControls.MatchesCardView.bind('selectedchanged', uAnalysisMatchesCardView_OnSelectChange);
        mAnalysisControls.MatchesCardView.bind('sort', uAnalysisMatchesCardView_OnSort);
       //mAnalysisControls.MatchesCardView.bind('databind', cardView_OnDataBind);

    }

    if (!isNullOrUndefined(lViewState)) {
        mAnalysisControls.MatchesCardView.bind('databind', uAnalysisMatchesCardView_OnDataBind, lViewState.Value);
    } else {
        mAnalysisControls.MatchesCardView.bind('databind', cardView_OnDataBind);
    }
    if (isNullOrUndefined(mAnalysisControls.Map)) {
        uAnalysisMap_Init();
    }
}

function uAnalysisMatchesCardView_OnSort(aParams, aSort) {
    "use strict";
    var lIncidentsMatch,// = mAnalysisData.IncidentMatchesClean,
        lIncidentsMatchListSorted = [];
    var lEnrolleeViewState = getViewState('AnalysisEnrolleeReturn');


    if (mStateManager.Settings()[0] == 'History') {
        lIncidentsMatch = mAnalysisData.IncidentMatchesClean;
        lIncidentsMatchListSorted = aSort.sort(lIncidentsMatch);
        mAnalysisData.IncidentMatchSort = lIncidentsMatchListSorted;
    } else {
        lIncidentsMatch = mAnalysisData.SpatialMatchesList;
        mAnalysisData.SpatialMatchesList = aSort.sort(lIncidentsMatch);
    }

    if (lEnrolleeViewState && lEnrolleeViewState.Value) {
    } else {
        mAnalysisControls.MatchesCardViewFilter.filter();
        setViewState('AnalysisIncidentMatchCardViewSort', aSort);
    }
}

function uAgentContact_OnClick(aEnrolleeId) {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar(),
        lTextArea = $('<textarea/>', { 'id': 'uAgentContactTextArea', 'class': 'AgentContactTextArea', 'width': '490px', 'onkeyup': '' });

    function uAgentContactSend_OnSuccess(aParams, aData) {
        ClosePopup();
        mActivityNotification.addNotification(localizeWrapper('cAgentMessageSent'));
    }

    function uAgentContactSend_OnFailure() {
        alert('Fail');
    }

    function uAgentContactSendButton_OnClick() {
        var lMessage = $('#uAgentContactTextArea').val(),
            lCurrentUserId = gUserDetails.UserId,
            lAgentContact = new AgentContact();

        lAgentContact.Subject = 'VeriTracks Enrollee Analysis Contact';
        lAgentContact.Id = aEnrolleeId;
        lAgentContact.UserId = lCurrentUserId;
        lAgentContact.Message = lMessage;
        WriteSingle(lAgentContact, uAgentContactSend_OnSuccess, uAgentContactSend_OnFailure, null, true);
    }
    GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup();').appendTo(lButtonCommandBar);
    GenerateButton(localizeWrapper('cAgentSend'), '', uAgentContactSendButton_OnClick).appendTo(lButtonCommandBar);
    DisplayPopup(localizeWrapper('cAgentContactAgent'), lTextArea, lButtonCommandBar, false, true);
}

function uAnalysisMapPopulate_GetDateRange(aStartDate, aEndDate) {
    "use strict";
    var lDateSelector = {},
        lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable'),
        lSearchTime = $('#uAnalysisSpatialMapTimeFilter').val(),
        lSearchTimeZoneCode = $('#uAnalysisSpatialTimeZone').find(':selected').attr('code'),
        lSearchTimeZoneId = $('#uAnalysisSpatialTimeZone').find(':selected').attr('id');

    if (lStartDateFilterEditable) {
        lDateSelector.StartDate = new Date($('#uMapStartDatePicker').val() + ' ' + $('#uMapSpatialStartTimePicker').val());
        lDateSelector.EndDate = new Date(lDateSelector.StartDate);
        lDateSelector.EndDate.addHours(parseInt(lSearchTime));
        $('#uMapEndDate').html(' - ' + DisplayShortDateTime(lDateSelector.EndDate));
    } else {
        lDateSelector.EndDate = new Date($('#uMapDatePicker').val() + ' ' + $('#uMapSpatialTimePicker').val());
        lDateSelector.StartDate = new Date(lDateSelector.EndDate);
        lDateSelector.StartDate.addHours(0 - lSearchTime);
        $('#uMapStartDate').html(DisplayShortDateTime(lDateSelector.StartDate) + ' - ');
    }

    updateSpatialRadiusLimit(true);

    return { 'StartDate': lDateSelector.StartDate, 'EndDate': lDateSelector.EndDate, 'TimeZoneCode' : lSearchTimeZoneCode, 'TimeZoneId': lSearchTimeZoneId };
}

function updateSpatialRadiusLimit(notice) {
    "use strict";

    if (!mAnalysisData.EditItem) return


    var lIndex = $('#uAnalysisSpatialMapTimeFilter').prop('selectedIndex');
    var SpatialRadiusForSearch = veritracks.system.clientSetting('spatialradiusforsearch');
    var lat = mAnalysisData.EditItem.CenterLatitude;
    var lng = mAnalysisData.EditItem.CenterLongitude;

    if (SpatialRadiusForSearch) {
        var val = SpatialRadiusForSearch.split(',')[lIndex];
        mAnalysisData.SpatialMatchRadius = parseInt(val)
        if (mAnalysisData.EditItem.Radius > mAnalysisData.SpatialMatchRadius) {
            mAnalysisData.EditItem.Radius = mAnalysisData.SpatialMatchRadius
            if (notice)
            mActivityNotification.addNotification("Spatial Radius reduced to avoid performance issues");
        } else {
            if (notice)
            mActivityNotification.addNotification("Spatial Radius has been increased");
        }
    }

    analysisSetViewZone(lat, lng, mAnalysisData.EditItem.Radius, 1)


}

function analysisPlaybackControl_OnSelectChange(aSender, aEvent, aData) {
    "use strict";

    switch (aEvent.state) {
        case 0: //stopped
            mAnalysisData.PlaybackStatus = 'Stopped';
            //$('#uAnalysisMapPlaybackPreviousCell').show();
            //$('#uAnalysisMapPlaybackPlayButton').show();
            //$('#uAnalysisMapPlaybackPauseButton').hide();
            //$('#uAnalysisMapPlaybackStopCell').hide();
            //$('#uAnalysisMapPlaybackFastForwardCell').hide();
            //$('#uAnalysisMapPlaybackNextCell').show();
            //hide incorrect active buttons
            $('#uAnalysisMapPlaybackStopButton').hide();
            $('#uAnalysisMapPlaybackPauseButton').hide();
            $('#uAnalysisMapPlaybackFastForwardButton').hide();

            //show correct disabled buttons in their place
            $('#uAnalysisMapPlaybackStopButtonDisabled').show();
            $('#uAnalysisMapPlaybackFastForwardButtonDisabled').show();
            $('#uAnalysisMapPlaybackSlowDownButtonDisabled').show();

            //hide incorrect disabled buttons
            $('#uAnalysisMapPlaybackPreviousButtonDisabled').hide();
            $('#uAnalysisMapPlaybackPlayButtonDisabled').hide();
            $('#uAnalysisMapPlaybackNextButtonDisabled').hide();
            $('#uAnalysisMapPlaybackSlowDownButton').hide();

            //show correct active buttons in their place
            $('#uAnalysisMapPlaybackPreviousButton').show();
            $('#uAnalysisMapPlaybackPlayButton').show();
            $('#uAnalysisMapPlaybackNextButton').show();


            // show map command cell
            $('.MapCommandCell').show('slow');
            break;
        case 1: //playing
            mAnalysisData.PlaybackStatus = 'Playing';
            //$('#uAnalysisMapPlaybackPreviousCell').hide();
            //$('#uAnalysisMapPlaybackPlayButton').hide();
            //$('#uAnalysisMapPlaybackPauseButton').show();
            //$('#uAnalysisMapPlaybackStopCell').show();
            //$('#uAnalysisMapPlaybackFastForwardCell').show();
            //$('#uAnalysisMapPlaybackNextCell').hide();

            //hide incorrect active buttons
            $('#uAnalysisMapPlaybackPreviousButton').hide();
            $('#uAnalysisMapPlaybackPlayButton').hide();
            $('#uAnalysisMapPlaybackNextButton').hide();

            //show correct disabled buttons in their place
            $('#uAnalysisMapPlaybackPreviousButtonDisabled').show();
            $('#uAnalysisMapPlaybackNextButtonDisabled').show();

            //hide incorrect disabled buttons
            $('#uAnalysisMapPlaybackStopButtonDisabled').hide();
            $('#uAnalysisMapPlaybackFastForwardButtonDisabled').hide();
            $('#uAnalysisMapPlaybackSlowDownButtonDisabled').hide();

            //show correct active buttons in their place
            $('#uAnalysisMapPlaybackPauseButton').show();
            $('#uAnalysisMapPlaybackStopButton').show();
            $('#uAnalysisMapPlaybackFastForwardButton').show();
            $('#uAnalysisMapPlaybackSlowDownButton').show();


            // show map command cell
            $('.MapCommandCell').hide('slow');
            break;
        case 2: //paused
            mAnalysisData.PlaybackStatus = 'Paused';
            //$('#uAnalysisMapPlaybackPreviousCell').show();
            //$('#uAnalysisMapPlaybackPlayButton').show();
            //$('#uAnalysisMapPlaybackPauseButton').hide();
            //$('#uAnalysisMapPlaybackStopCell').show();
            //$('#uAnalysisMapPlaybackFastForwardCell').hide();
            //$('#uAnalysisMapPlaybackNextCell').show();

            //hide incorrect active buttons
            $('#uAnalysisMapPlaybackPauseButton').hide();
            $('#uAnalysisMapPlaybackFastForwardButton').hide();
            $('#uAnalysisMapPlaybackSlowDownButton').hide();

            //show correct disabled buttons in their place
            $('#uAnalysisMapPlaybackFastForwardButtonDisabled').show();
            $('#uAnalysisMapPlaybackSlowDownButtonDisabled').show();

            //hide incorrect disabled buttons
            $('#uAnalysisMapPlaybackPreviousButtonDisabled').hide();
            $('#uAnalysisMapPlaybackStopButtonDisabled').hide();
            $('#uAnalysisMapPlaybackNextButtonDisabled').hide();

            //show correct active buttons in their place
            $('#uAnalysisMapPlaybackPreviousButton').show();
            $('#uAnalysisMapPlaybackPlayButton').show();
            $('#uAnalysisMapPlaybackStopButton').show();
            $('#uAnalysisMapPlaybackNextButton').show();
            break;
    }
    $('#uMapPlaybackStatus').html(localizeText('cEnrollee' + mAnalysisData.PlaybackStatus));
}

function uIncidentAddressEditMap_OnDragEnd(aOverlay, aEvent) {
    "use strict";
    $('#uIncidentsAddressLatitudeEdit').val(aEvent.latLng.lat());
    $('#uIncidentsAddressLongitudeEdit').val(aEvent.latLng.lng());
}

function uOldIncidentAddressEditMap_OnDragEnd(aOverlay, aEvent) {
    uIncidentAddressEditMap_OnDragEnd(aOverlay, aEvent);
    mActivityNotification.addNotification("Updating location");
}

function analysisPlacesMarker_OnClick(aSender, aMouseEvent) {
    "use strict";
    veritracks.mapping.placesDetailGenerator(mAnalysisControls.NotificationPanel, aSender);
}

function uAnalysisMap_Init() {
    "use strict";
    var lUserPreferences = getUserPreferences(4),
        lSystemPreferences = getUserPreferences(10),
        lDisplayType = 'roadmap',
        layerAdd,
        lLayerOptions;

    if (!isNullOrUndefined(lSystemPreferences['MapDisplayType'])) {
        lDisplayType = lSystemPreferences['MapDisplayType'].Value;
    }
    mAnalysisControls.Map = new sumo.maps.GoogleMapControl('uAnalysisDetailsMap', 'uMapPanel',
        {
            'displayType': lDisplayType,
            'mapTypeId_OnChange': mapDisplayType_OnChange,
            'OnClick': analysisCalculateDistance_OnClick,
            'OnRightClick': updateAnalysisZoneLocation_OnRightClick
        });

    mAnalysisControls.Map.layerAdd('Incidents', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'dragEndEventHandler': uIncidentAddressEditMap_OnDragEnd,
        'zIndexStart': 1700000
    });

    mAnalysisControls.Map.layerAdd('MatchTrackPoints', {
        'renderType': 'marker',
        'doesPlayback': true,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1600000
    });

    mAnalysisControls.Map.layerAdd('Spatial', {
        'renderType': 'geometry',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1000000,
        'shapeChangeHandler': analysisSpatialMapShape_OnChange
    });

    // added radius to show user the total diameter of there circle
    mAnalysisControls.Map.layerAdd('SpatialRadius', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 2000000,
    });

    mAnalysisControls.Map.layerAdd('SpatialTrackPoint', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1400000
    });

    mAnalysisControls.Map.layerAdd('LabelsSelected', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 5500000
    });

    mAnalysisControls.Map.layerAdd('Selected', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 2000000
    });

    mAnalysisControls.Map.layerAdd('DistancePoints', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1300000,
        'markerImageSize': { 'width': 32, 'height': 32 }
    });


    mAnalysisControls.Map.layerAdd('DistanceLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 2000000
    });

    mAnalysisControls.Map.layerAdd('ConnectedDistancePoints', {
        'renderType': 'linesegment',
        'doesPlayback': true,
        'isVisible': true,
        'isClickable': false,
        'clickEventHandler': null,
        'zIndexStart': 700000
    });

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'dragEndEventHandler': null,
        'clickEventHandler': null,
        'zIndexStart': 1000000
    };
    mAnalysisControls.Map.layerAdd('address', lLayerOptions);

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'dragEndEventHandler': null,
        'clickEventHandler': null,
        'zIndexStart': 1000000
    };

    mAnalysisControls.Map.layerAdd('Address', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': spatialAddressMarkerClick,
        'zIndexStart': 160000
    });

    mAnalysisControls.Map.layerAdd('AddressLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 160000
    });

    mAnalysisControls.Map.layerAdd('EnrolleeMGAP', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': spatialEnrolleeMGAPMarkerClick,
        'zIndexStart': 160000
    });

    mAnalysisControls.Map.layerAdd('EnrolleeMGAPLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 160000
    });


    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': analysisPlacesMarker_OnClick,
        'zIndexStart': -10000,
        'markerImageSize': { 'width': 32, 'height': 32 }
    };
    mAnalysisControls.Map.layerAdd('Places', lLayerOptions);

    lLayerOptions = {
        'renderType': 'label',
        'doesPlayback': true,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 85000
    };
    mAnalysisControls.Map.layerAdd('Labels', lLayerOptions);

    $('#uSlider').slider({ 'min': 0, 'max': 99, 'slide': matchSlider_OnSlide });
    mAnalysisControls.PlaybackControl = mAnalysisControls.Map.getPlaybackController('MatchTrackPoints');
    mAnalysisControls.PlaybackControl.bind('statechange', analysisPlaybackControl_OnSelectChange);
    mAnalysisControls.PlaybackControl.bind('progressed', uAnalysisMapPlayback_OnProgressed);
    mAnalysisControls.PlaybackControl.bind('completed', uAnalysisMapPlayback_OnCompleted);
}

function analysisPlaces_OnComplete(aSender, aPlaceList) {
    "use strict";
    var lEditItem,
        lLocation,
        lLatitude,
        lLongitude;

    mAnalysisControls.NotificationPanel.clearNotifications();
    if (aPlaceList.length === 1) {
        lLocation = aPlaceList[0];
        lLatitude = lLocation.geometry.location.lat();
        lLongitude = lLocation.geometry.location.lng();
        if (!isNullOrUndefined(mAnalysisData.EditShape)) {
            if (veritracks.mapping.localityTypeMatch(lLocation.types[0])) {
                aPlaceList.shift();
                mAnalysisControls.Map.layerSetDataSource('Places', veritracks.mapping.preparePlacesData(aPlaceList));
                mAnalysisControls.Map.setCenter(lLatitude, lLongitude);
                lEditItem = veritracks.mapping.moveZoneCenter(mAnalysisData.EditItem, mAnalysisData.EditShape, lLatitude, lLongitude);
                analysisSetViewZoneRadius(lLatitude, lLongitude, mAnalysisData.EditItem.Radius);
                mAnalysisControls.Map.layerSetDataSource('Spatial', veritracks.mapping.prepareZoneData([mAnalysisData.EditItem]));
                mAnalysisData.EditShape = mAnalysisControls.Map.layerGetShape('Spatial', mAnalysisData.EditItem.Id);
                if (!isNullOrUndefined(mAnalysisData.EditShape)) {
                    mAnalysisData.EditShape.setEditable(true);
                }
                mAnalysisControls.Map.fitBounds();
                mAnalysisControls.Map.zoom(17);
            }
            else {
                mAnalysisControls.Map.layerSetDataSource('Places', veritracks.mapping.preparePlacesData(aPlaceList));
                mAnalysisControls.Map.setCenter(lLatitude, lLongitude);
                mAnalysisControls.Map.zoom(17);
            }
        } else {
            mAnalysisControls.Map.layerSetDataSource('Places', veritracks.mapping.preparePlacesData(aPlaceList));
            mAnalysisControls.Map.setCenter(lLatitude, lLongitude);
            mAnalysisControls.Map.zoom(17);
        }
    } else if (aPlaceList.length >= 1) {
        lLocation = aPlaceList[0];
        lLatitude = lLocation.geometry.location.lat();
        lLongitude = lLocation.geometry.location.lng();
        mAnalysisControls.Map.layerSetDataSource('Places', veritracks.mapping.preparePlacesData(aPlaceList));
        mAnalysisControls.Map.setCenter(lLatitude, lLongitude);
        mAnalysisControls.Map.zoom(14);
    } else {
        mAnalysisControls.Map.layerSetDataSource('Places', veritracks.mapping.preparePlacesData(aPlaceList));
    }
}

function uCancelIncidentButton_OnClick() {
    "use strict";
    var lIsEmpty,
        lCard = mAnalysisControls.CardView.selectedDataItem();

    mAnalysisControls.Validator.dispose();
    mAnalysisControls.Validator = null;
    lIsEmpty = (mAnalysisData.IncidentDirty.length === 0);
    veritracks.system.applyFilterState('AnalysisIncidents', lIsEmpty);

    if (!isNullOrUndefined(mAnalysisControls.Map) && lCard) {
        analysisSetViewZone(lCard.Data.Latitude, lCard.Data.Longitude, lCard.Data.Radius);
        mAnalysisControls.Map.layerShow('Incidents');
    }

    uAnalysisExitEditMode();
}

/* SPATIAL FEATURE */
function preChangeHashAnalysisCheck(aTab, aTabName) {
    if (aTabName == 'Map') {
       // mAnalysisData.SpatialMatchIncident = null;
    }
    ChangeHashSettings(aTab, aTabName);
}
/* RUNNING A SPATIAL QUERY */
function uRunSpatialQuery_OnClick() {
    "use strict";
    if (!$('#uAddSpatialQueryButton').hasClass('Disabled')) {
        var lSearchTime = $('#uAnalysisSpatialMapTimeFilter').val();
        var lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable');
        var lDate = new Date();
        if (lStartDateFilterEditable) {
            lDate = lDate.addHours(-parseInt(lSearchTime));
            $('#uMapStartDatePicker').val(displayShortDate(lDate));
            $('#uMapSpatialStartTimePicker').val($.format.date(lDate, "h:mm a"));
        } else {
            $('#uMapDatePicker').val(displayShortDate(lDate));
            $('#uMapSpatialTimePicker').val($.format.date(lDate, "h:mm a"));
        }
        uAnalysisMapPopulate_GetDateRange();
        uRunSpatialQuery();
    } else {
        mActivityNotification.addNotification(localizeWrapper('cAnalysisSpatialQueryLoading'));
    }
}

function uRunSpatialQuery() {
    $('#uAnalysisIncidentDetailHolder').hide();
    $('#uAddIncidentButton').hide();
    $('#uAddSpatialQueryButton').hide();

    uDisplayEditSpatialControls()
    resetContentHolders();
    mAnalysisControls.Map.resize();
    uEnterSpatialEditMode();
}

function uDisplayEditSpatialControls() {
    "use strict";
    var lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable');

    if (lStartDateFilterEditable) {
        $('.MapStartDateFilter').show();
    } else {
        $('.MapEndDateFilter').show();
    }
    //$('#uMapDatePicker').show();
    //$('#uMapSpatialTimePicker').show();
    $('#uSearchSpatialButton').show();
    $('#uAnalysisSpatialMapTimeFilter').show();
    $('#uCancelSpatialQueryButton').show();
    if(mStateManager.Settings()[0] == "Incidents")
        $('#uAnalysisListCell').hide();
}

function uEditSpatialQuery_OnClick() {
    "use strict";
    $('#uEditSpatialQueryButton').hide();

    uDisplayEditSpatialControls();
    mAnalysisData.EditShape.setEditable(true);

}

function uCancelSpatialQuery_OnClick() {
    "use strict";
    var lIsEmpty;
    var lCard = mAnalysisControls.CardView.selectedDataItem();

    $('#uAnalysisListCell').show();
    mAnalysisData.SpatialMatchIncident = null;
    if (!isNullOrUndefined(mAnalysisControls.Map) && lCard) {
        analysisSetViewZone(lCard.Data.Latitude, lCard.Data.Longitude, lCard.Data.Radius);
        mAnalysisControls.Map.layerShow('Incidents');
    } else if(!isNullOrUndefined(mAnalysisControls.Map)) {
        mAnalysisControls.Map.layerHide('Spatial');
        mAnalysisControls.Map.layerHide('SpatialRadius');
    }
    uAnalysisExitEditMode();
    lIsEmpty = (mAnalysisData.IncidentDirty.length === 0);
    veritracks.system.applyFilterState('AnalysisIncidents', lIsEmpty);

}

function uAnalysisSpatialQueryRunningPopup() {
    "use strict";
    var lBodyHtml = [],
      lButtonBar = GenerateButtonCommandBar();

    GenerateButton(localizeWrapper('cEnrolleeEdit'), 'Edit', 'ClosePopup();').appendTo(lButtonBar);

    lBodyHtml.push('<div>');
    lBodyHtml.push('<div id="uSpatialQueryLoading">' + localizeWrapper('cIncidentsRunningSpatialQuery') + '</div>');
    lBodyHtml.push('<div id="uSpatialQueryNoResults" style="display:none">' + localizeWrapper('cIncidentsSpatialQueryNoResults') + '</div>');
    lBodyHtml.push('<div id ="gifContainer" style="display:none; padding-top: 40px;">');
    lBodyHtml.push('<div id="gif" class="loadingGif"></div>');
    lBodyHtml.push('</div>');
    DisplayPopup(localizeWrapper('cIncidentsSpatialSearch'), lBodyHtml.join(''), lButtonBar, false);

    $('.ButtonCommandBar').hide();
    $('#gifContainer').show();
}

function uSearchSpatialButton_OnClick() {
    "use strict";
    var lCenterLatitude = mAnalysisData.EditShape.center.lat(),
        lCenterLongitude = mAnalysisData.EditShape.center.lng(),
        lNauticalMileRadius = sumo.geo.conversion.metersToNauticalMiles(mAnalysisData.EditShape.radius), // nautical miles is not the same size as a mile.
        lRadius = sumo.geo.conversion.metersToFeet(mAnalysisData.EditShape.radius),
        lDateSelector = {},
        lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable'),
        lSearchTime = $('#uAnalysisSpatialMapTimeFilter').val(),
        lTimezoneSelected = $('#uAnalysisSpatialTimeZone').find(':selected').attr('value');


        //lBuilder = new SumoPredicateBuilder();

    if (lRadius > mAnalysisData.SpatialMatchRadius) {
        mActivityNotification.addNotification('The radius must be under 0.5 miles. Your current radius is ' + RoundNumber(sumo.geo.conversion.feetToStatuteMiles(lRadius), 2) + ' miles.'); //localize issue
    } else {
        uAnalysisSpatialQueryRunningPopup();
        mActivityNotification.addNotification(localizeWrapper('cAnalysisSpatialQueryWait'));
        $('#uAnalysisSpatialMatchesLoadingBar').show();

        if (lStartDateFilterEditable) {
            lDateSelector.StartDate = new Date($('#uMapStartDatePicker').val() + ' ' + $('#uMapSpatialStartTimePicker').val());
            lDateSelector.EndDate = new Date(lDateSelector.StartDate);
            lDateSelector.EndDate.addHours(parseInt(lSearchTime));

            $('.MapStartDateFilter').hide();
        } else {
            lDateSelector.EndDate = new Date($('#uMapDatePicker').val() + ' ' + $('#uMapSpatialTimePicker').val());
            lDateSelector.StartDate = new Date(lDateSelector.EndDate);
            lDateSelector.StartDate.addHours(- parseInt(lSearchTime));

            $('.MapEndDateFilter').hide();
        }

        $('#uSearchSpatialButton').hide();
        $('#uCancelSpatialQueryButton').hide();
        $('#uEditSpatialButton').show();
        $('#uAnalysisSpatialMapTimeFilter').hide();

        mAnalysisData.RequestId = gRequestManager.getRequestId();
       // lBuilder.AddNewExpressionConditional('StartDate', lDateSelector.EndDate, false, mRelationalOperatorEnum.LessThan(), mLogicalOperatorEnum.And());
        var lStart = getMomentInTimeZone(lDateSelector.StartDate, lTimezoneSelected);
        var lEnd = getMomentInTimeZone(lDateSelector.EndDate, lTimezoneSelected);
        var lRadiusInFeet = sumo.geo.conversion.metersToFeet(mAnalysisData.EditShape.radius);
        veritracks.mapping.getTrackpoints(lNauticalMileRadius, lCenterLatitude, lCenterLongitude, lStart, lEnd, uSearchSpatial_OnSuccess, uSearchSpatial_OnFailure, { "RequestId": mAnalysisData.RequestId, "aStart": lStart, "aEnd": lEnd, "TimeZoneName": lTimezoneSelected });
        mAnalysisData.EditShape.setEditable(false);
        //mAnalysisData.EditShape = null;
        uAnalysisMapPopulate_GetDateRange();
    }

}

function uSearchSpatial_OnSuccess(aParams, aData) {
    "use strict";
    var lSpatialTrackPointList = [],
        lKey,
        lData = [],
        lSpatialTrackItem,
        lSearchDate = uAnalysisMapPopulate_GetDateRange(),
        lSearchStartDate = aParams.aStart,
        lSearchEndDate = aParams.aEnd,
        lSearchTimeZoneName = aParams.TimeZoneName,
        lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable'),
        lRequestId = gRequestManager.getRequestId();

    if (aData.ResponseData) {
        lData = aData.ResponseData.DataItem.Trackpoints;
    } else {
        lData = aData;
    }
    if (mAnalysisData.RequestId === aParams.RequestId) {
        if (!isNullOrUndefined(lData)) {
            if (!isNullOrUndefined(lData)) {
                if (lData.length > 0) {
                    setViewState('SpatialEnrolleeMatch', true);
                    if (mAnalysisData.EditShape) {
                        mAnalysisData.SpatialMatchIncident = new Incident();
                        mAnalysisData.SpatialMatchIncident.StartDateUTC = lSearchStartDate;
                        mAnalysisData.SpatialMatchIncident.EndDateUTC = lSearchEndDate;
                        mAnalysisData.SpatialMatchIncident.Latitude = mAnalysisData.EditShape.center.lat();
                        mAnalysisData.SpatialMatchIncident.Longitude = mAnalysisData.EditShape.center.lng();
                        mAnalysisData.SpatialMatchIncident.TimeZoneName = lSearchTimeZoneName;
                        mAnalysisData.SpatialMatchIncident.TimeZoneCode = lSearchDate.TimeZoneCode;
                        mAnalysisData.SpatialMatchIncident.TimeZoneId = lSearchDate.TimeZoneId;
                        mAnalysisData.SpatialMatchIncident.Radius = RoundNumber(mAnalysisData.EditShape.radius, 3);
                    } else {
                        mAnalysisData.SpatialMatchIncident.Radius = RoundNumber(sumo.geo.conversion.feetToMeters(mAnalysisData.SpatialMatchIncident.Radius), 3);
                    }
                    uSearchSpatialResults(lData);
                    ClosePopup();
                    $('.ButtonCommandBar').show();
                } else {
                    mAnalysisData.SpatialMatchIncident = null;
                    if (lStartDateFilterEditable) {
                        $('.MapStartDateFilter').show();
                    } else {
                        $('.MapEndDateFilter').show();
                    }
                    if(mAnalysisData.EditShape){
                        mAnalysisData.EditShape.setEditable(true);
                    }
                    $('#uSearchSpatialButton').show();
                    $('#uCancelSpatialQueryButton').show();
                    $('#uEditSpatialButton').hide();
                    $('#uAnalysisSpatialMapTimeFilter').show();
                    $('#uSpatialQueryLoading').hide();
                    $('#uSpatialQueryNoResults').show();
                    $('#gifContainer').hide();
                    $('.ButtonCommandBar').show();
                    $('#uSpatialMapResults').addClass('HideItem');
                    mActivityNotification.addNotification(localizeWrapper('cAnalysisSpatialQueryNoResults'));
                }
            }
        } else if (lData.Status == 'fail') {
            mAnalysisData.EditShape.setEditable(true);
            $('#uSearchSpatialButton').show();
            $('#uCancelSpatialQueryButton').show();
            $('#uEditSpatialButton').hide();
            $('#uAnalysisSpatialMapTimeFilter').show();
            $('#uSpatialQueryLoading').hide();
            $('#uSpatialQueryNoResults').show();
            $('#gifContainer').hide();
            $('.ButtonCommandBar').show();
            $('#uSpatialMapResults').addClass('HideItem');
        }
    } else {
        $('#uSpatialMapResults').addClass('HideItem');
        alert('Gothim Failure');
    }
    uAnalysisMapPopulate_GetDateRange();
}

function uSearchSpatialResults(aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lDeviceIds,
        lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable'),
        lSpatialData;

    //support for all data access permission
    if (CheckUserHasPermission(45)) {
        lDeviceIds = gDeviceIds.concat(gUniversalDeviceIds)
    } else {
        lDeviceIds = gDeviceIds;
    }
    lBuilder.AddNewExpressionConditional('DeviceId', lDeviceIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lSpatialData = aData;// query(aData, lBuilder.RootExpression);
    if (lSpatialData.length > 0) {
        analysisSpatialMatchesDataListConverter(lSpatialData);
    } else {
        if (mAnalysisData.EditShape) {
            mAnalysisData.EditShape.setEditable(true);
        }
        if (lStartDateFilterEditable) {
            $('.MapStartDateFilter').show();
        } else {
            $('.MapEndDateFilter').show();
        }
        $('#uSearchSpatialButton').show();
        $('#uCancelSpatialQueryButton').show();
        $('#uEditSpatialButton').hide();
        $('#uAnalysisSpatialMapTimeFilter').show();
        $('#uSpatialQueryLoading').hide();
        $('#uSpatialQueryNoResults').show();
        $('#uSpatialMapResults').addClass('HideItem');
        mActivityNotification.addNotification(localizeWrapper('cDefaultNoResultsFound'));
    }
}

function uSearchSpatial_OnFailure() {
    "use strict";
    var lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable');
    ClosePopup();
    if (lStartDateFilterEditable) {
        $('.MapStartDateFilter').show();
    } else {
        $('.MapEndDateFilter').show();
    }
    mAnalysisData.EditShape.setEditable(true);
    $('#uSearchSpatialButton').show();
    $('#uCancelSpatialQueryButton').show();
    $('#uEditSpatialButton').hide();
    $('#uAnalysisSpatialMapTimeFilter').show();
    $('#uSpatialQueryLoading').hide();
    $('#uSpatialQueryNoResults').show();
    $('#gifContainer').hide();
    $('.ButtonCommandBar').show();
    mActivityNotification.addNotification(localizeWrapper('cAnalysisSpatialQueryFailed'));
}


/// REPLACE LATER
function GetLastIncidentLocation() {
    "use strict";
    var lIncidents = getDataItems('Incidents');
    var lIncident;
    var lKey;

    for (lKey in lIncidents) {
        if (lIncidents.hasOwnProperty(lKey)) {
            lIncident = lIncidents[lKey];
        }
    }


    return lIncident;
}
function uEnterSpatialEditMode() {
    "use strict";
    var lCenter = mAnalysisControls.Map.getCenter(),
        lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable'),
        lShape = 1;
    $('#uAnalysisSpatialNoMatchesMessage').hide();

    mAnalysisControls.Map.layerHide('Incidents');
    mAnalysisControls.Map.layerShow('Spatial');
    mAnalysisData.EditItem = new Spatial();
    if (mAnalysisData.SpatialMatchIncident) {
        if (mAnalysisData.SpatialMatchIncident.Radius == 0) {
            mAnalysisData.SpatialMatchIncident.Radius = 457.2;
        }
        mAnalysisData.EditItem.Radius = sumo.geo.conversion.metersToFeet(mAnalysisData.SpatialMatchIncident.Radius);
        mAnalysisData.EditItem.CenterLatitude = mAnalysisData.SpatialMatchIncident.Latitude;
        mAnalysisData.EditItem.CenterLongitude = mAnalysisData.SpatialMatchIncident.Longitude;

        var lTimeZone = getTimezone(mAnalysisData.SpatialMatchIncident.TimeZoneId);
        var start = convertLocalThenTimeZone(mAnalysisData.SpatialMatchIncident.StartDateUTC, lTimeZone);
        var end = convertLocalThenTimeZone(mAnalysisData.SpatialMatchIncident.EndDateUTC, lTimeZone);

        if (lStartDateFilterEditable) {
            $('#uMapStartDatePicker').val(displayShortDate(start));

            $('#uMapSpatialStartTimePicker').val($.format.date(new Date(start), "h:mm a"));

            $('#uMapEndDate').html('-' + DisplayShortDateTime(new Date(end)));
        } else {
            $('#uMapDatePicker').val(displayShortDate(end));

            $('#uMapSpatialTimePicker').val($.format.date(new Date(end), "h:mm a"));

            $('#uMapStartDate').html(DisplayShortDateTime(new Date (start)));
        }

        setSpatialTimeFilter(mAnalysisData.SpatialMatchIncident);
        mAnalysisControls.Map.setCenter(mAnalysisData.SpatialMatchIncident.Latitude, mAnalysisData.SpatialMatchIncident.Longitude);
        mAnalysisControls.Map.zoom(16);
    }
    else {
        var lGetLatestIncidentLocation = GetLastIncidentLocation();
        mAnalysisData.EditItem.Radius = mAnalysisData.SpatialRadius;
        if (lGetLatestIncidentLocation) {
            mAnalysisData.EditItem.CenterLatitude = lGetLatestIncidentLocation.Latitude;
            mAnalysisData.EditItem.CenterLongitude = lGetLatestIncidentLocation.Longitude;
        } else {
            mAnalysisData.EditItem.CenterLatitude = lCenter.lat();
            mAnalysisData.EditItem.CenterLongitude = lCenter.lng();
        }
        mAnalysisControls.Map.setCenter(mAnalysisData.EditItem.CenterLatitude, mAnalysisData.EditItem.CenterLongitude);
        mAnalysisControls.Map.zoom(16);
    }
    mAnalysisControls.Map.layerSetDataSource('Spatial', veritracks.mapping.prepareZoneData([mAnalysisData.EditItem]));
    mAnalysisData.EditShape = mAnalysisControls.Map.layerGetShape('Spatial', mAnalysisData.EditItem.Id);
    mAnalysisData.EditShape.setEditable(true);
    analysisSpatialEnterEditMode();
    //$('#uMapStartDate').show();
    uAnalysisMapPopulate_GetDateRange();
    if (lStartDateFilterEditable) {
        $('.MapStartDateFilter').show();
    } else {
        $('.MapEndDateFilter').show();
    }
    //$('#uMapEndDate').hide();
    //$('#uMapDatePicker').show();
    $('#uAnalysisSpatialMapTimeFilter').show();
    //$('#uMapSpatialTimePicker').show();
    updateSpatialRadiusLimit(false)
}

function analysisSpatialEnterEditMode() {
    "use strict";
    $('#uEditSpatialButton').hide();
    $('#uSearchSpatialButton').show();
}

function analysisSetViewZoneRadius(aLatitude, aLongitude, aRadius) {
    var lLabel = { 'Latitude': '', 'Longitude': aLongitude, 'Name': RoundNumber(aRadius, 2) + ' ft' },
        lCssClass = 'NumericLabelCenter';

    lLabel.Latitude = aLatitude + sumo.geo.conversion.feetToDegreeLatitude(aRadius);
    // check if radius bigger than half a mile
    if (aRadius > mAnalysisData.SpatialMatchRadius) {
        lCssClass = 'NumericLabelRed';
        mActivityNotification.addNotification(localizeWrapper('cAnalysisSpatialQueryRadiusLarge'));
    }
    mAnalysisControls.Map.layerSetDataSource('SpatialRadius', veritracks.mapping.prepareSuggestionLabelOverlayData([lLabel], lCssClass, { VerticalOffset: -40, HorizontalOffset: -40 }));
    mAnalysisControls.Map.layerShow('SpatialRadius');
}

// use feet instead of meters
function analysisSetViewZone(aLatitude, aLongitude, aRadius, aType) {
    var lZone = new Zone;

    if (aRadius == 0) {
        mAnalysisControls.Map.layerHide('SpatialRadius');
        mAnalysisControls.Map.layerHide('Spatial');
        return;
    }

    if (aType) {
        lZone.Type = aType;
    } else {
        lZone.Type = 3; // view only
    }

    lZone.CenterLatitude = aLatitude;
    lZone.CenterLongitude = aLongitude;
    lZone.Radius = aRadius;

    mAnalysisControls.Map.layerShow('Spatial');
    mAnalysisControls.Map.layerSetDataSource('Spatial', veritracks.mapping.prepareZoneData([lZone]));
    analysisSetViewZoneRadius(aLatitude, aLongitude, aRadius);

    if (lZone.Type == 1) {
        if (mAnalysisData.EditItem) {
            mAnalysisData.EditShape = mAnalysisControls.Map.layerGetShape('Spatial', mAnalysisData.EditItem.Id);
            mAnalysisData.EditShape.setEditable(true);
        }
    }
}

function setIncidentMarker(aCard) {
    "use strict";
    var lCard = aCard;
    var lType = 13;
    if (lCard.Data.Radius == 0) {
        lType = 18;
    }
    mAnalysisControls.Map.layerSetDataSource('Incidents', [veritracks.mapping.prepareTrackpointMarkerItem_dep({ 'Latitude': lCard.Data.Latitude, 'Longitude': lCard.Data.Longitude, 'TrackTypeId': lType })]);
}

function analysisSpatialMatchesDataListConverter(aData) {
    "use strict";
    var lSpatialMatchesList = [],
        lMatchData = aData,
        lMatch,
        lKey,
        lDevices,
        lDevice,
		lPastDeviceId = 0,
        lSort = new SortExpression(),
        lBuilder = new SumoPredicateBuilder();

    lSort.addAscendingColumn('TrackDate');
   // lSort.addAscendingColumn('FullName');
    lMatchData = lSort.sort(lMatchData);
    if (ObjectLength(lMatchData) > 0) {
        for (lKey in lMatchData) {
            if (lMatchData.hasOwnProperty(lKey)) {
                //// get unique list of deviceIds
                mAnalysisData.DeviceIdList.push(lMatchData[lKey].DeviceId);
                lDevice = GetDevice(lMatchData[lKey].DeviceId);
                lSpatialMatchesList.push(generateAnalysisSpatialMatchesTrack(lMatchData[lKey], lDevice));
            }
        }
        mAnalysisData.SpatialMatches = lSpatialMatchesList;
        if (mAnalysisData.DeviceIdList.length > 0) {
            mAnalysisData.DeviceIdList = mAnalysisData.DeviceIdList.unique();
          //  lBuilder.AddNewExpressionConditional('Id', mAnalysisData.DeviceIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        }
        //using all items including unassigned. currently only using assigned enrollees for spatial search
        //lBuilder.AddNewExpressionConditional('StartDate', convertTimeToUTC(mAnalysisData.SpatialMatchIncident.EndDateUTC), false, mRelationalOperatorEnum.LessThan(), mLogicalOperatorEnum.And());
        //lBuilder.AddNewExpressionConditional('EndDate', convertTimeToUTC(mAnalysisData.SpatialMatchIncident.StartDateUTC), false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
        //ReadMultiple(gObjectList.DeviceAssignment.AssemblyQualifiedName, lBuilder.RootExpression, 0, AnalysisDeviceAssignmentRead_OnSuccess, Sad, null, null, 0);

        veritracks.data.controller.readDeviceAssignments(
            new Date(mAnalysisData.SpatialMatchIncident.StartDateUTC),
            new Date(mAnalysisData.SpatialMatchIncident.EndDateUTC),
            mAnalysisData.DeviceIdList.join(','),
            AnalysisDeviceAssignmentRead_OnSuccess,
            Sad, null);
        }

}

function AnalysisDeviceAssignmentRead_OnSuccess(aParams, aData) {
    "use strict";

    var lDeviceAssignments,
        lEnrollees,
        lDevices,
        lEnrolleeCardList = [],
        lDevice,
        lEnrollee,
        lMatch,
        lKey;
    var lBuilder = new SumoPredicateBuilder();
    var lEnrolleeIdList = [];
    FixDates(aData);
    lDeviceAssignments = aData;

    for (lKey in lDeviceAssignments) {
        if (lDeviceAssignments.hasOwnProperty(lKey)) {
            lEnrolleeIdList.push(lDeviceAssignments[lKey].EnrolleeId);
        }
    }

    if (lEnrolleeIdList.length == 0) {
        NoSpatialResultsFound();
        return;
    }

    lBuilder.AddNewExpressionConditional('Id', lEnrolleeIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.Enrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, GetSpatialEnrollees_OnSuccess, Sad);

    function GetSpatialEnrollees_OnSuccess(aParams, aData){
        var lEnrolleeArray = [];

        for (var lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lEnrolleeArray[aData[lKey].Id] = aData[lKey];
            }
        }

        if (CheckUserHasPermission(45)) {
            lBuilder.Clear();
            var lAgentIds = getArrayByValue(aData, 'AgentId');
            lBuilder.AddNewExpressionConditional('Id', lAgentIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.Agent.AssemblyQualifiedName, lBuilder.RootExpression, 0, GetSpatialAgents_OnSuccess, Sad, lEnrolleeArray);
        } else {
            GetSpatialAgents_OnSuccess(lEnrolleeArray, []);
        }
    }

    function GetSpatialAgents_OnSuccess(aParams, aData) {
        var lAgentArray = [];
        var lEnrolleeArray = aParams;
        var lMyEnrollee = true;
        var lAgent;
        for (var lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lAgentArray[aData[lKey].Id] = aData[lKey];
            }
        }

        for (lKey in lDeviceAssignments) {
            if (lDeviceAssignments.hasOwnProperty(lKey)) {
                lMatch = lDeviceAssignments[lKey];
                lEnrollee = GetEnrollee(lMatch.EnrolleeId);
                if (!lEnrollee) {
                    lEnrollee = lEnrolleeArray[lMatch.EnrolleeId];
                    lMyEnrollee = false;
                } else {
                    lMyEnrollee = true;
                }
                lDevice = GetDevice(lMatch.Id);
                lAgent = lAgentArray[lEnrollee.AgentId];
                lEnrolleeCardList.push(generateAnalysisEnrolleesSpatialMatchesCard(lMatch, lEnrollee, lDevice, lKey, lMyEnrollee, lAgent));
            }
        }

        //if going to combine same enrollees with same device ids do it here, combine them add the start date from earliest card and end date from older card remove one card

        mAnalysisData.EnrolleeSpatialMatches = lEnrolleeCardList;

        if (mAnalysisData.EnrolleeSpatialMatches.length > 0) {
            SpatialResultsFinalized();
        } else {
            NoSpatialResultsFound();
        }
    }
}

function NoSpatialResultsFound() {
    "use strict";
    $('#gifContainer').hide();
    $('.ButtonCommandBar').show();
    uDisplayEditSpatialControls();
    mActivityNotification.addNotification(localizeWrapper('cDefaultNoResultsFound'));
}

/* END RUNNING A SPATIAL QUERY */

/* DISPLAYING SPATIAL QUERY */

function generateAnalysisSpatialMatchesTrack(aMatch, aDevice) {
    "use strict";
    var lSpatialMatchesCard = new AnalysisSpatialMatchesTrack(),
        lMatch = aMatch,
        lDevice = aDevice;

    lSpatialMatchesCard.TrackDate = convertMomentFromStringOffset(lMatch.TrackDate);
    lSpatialMatchesCard.TrackDateUTC = lMatch.TrackDateUTC;
    lSpatialMatchesCard.Longitude = lMatch.Longitude;
    lSpatialMatchesCard.Latitude = lMatch.Latitude;
    if (!isNullOrUndefined(lDevice)) {
        lSpatialMatchesCard.DeviceId = lDevice.Id;
        lSpatialMatchesCard.DeviceSerialNumber = lDevice.SerialNumber;
    } else {
        lSpatialMatchesCard.DeviceId = aMatch.DeviceId;
    }
    lSpatialMatchesCard.TrackTypeId = lMatch.TrackTypeId;
    //lSpatialMatchesCard.Data = lMatch;
    //lSpatialMatchesCard.EnrolleeSpatialView = 'none';
    //lSpatialMatchesCard.TrackItem = veritracks.mapping.prepareTrackpointMarkerItem(lMatch, 1);

    return lSpatialMatchesCard;
}

function generateAnalysisEnrolleesSpatialMatchesCard(aMatch, aEnrollee, aDevice, aRandom, aEnrolleeFound, aAgent) {
    "use strict";
    var lEnrolleeCard = new AnalysisMatchesCardView(),
        lMatch = aMatch,
        lEnrollee = aEnrollee,
        lAgent,
        lDevice = aDevice;

    if (lEnrollee) {
        lAgent = getDataItem(aEnrollee.AgentId, 'Agents');
    }

    if (!lAgent) {
        lAgent = aAgent;
    }

    lEnrolleeCard.Id = aRandom.toString() + lEnrollee.Id.toString();
    lEnrolleeCard.TrackingDeviceSerialNumber = (lDevice ? lDevice.SerialNumber : lMatch.SerialNumber);
    lEnrolleeCard.TrackingDeviceId = (lDevice ? lDevice.Id : lMatch.Id);
    lEnrolleeCard.StartDateUTC = lMatch.StartDate;
    lEnrolleeCard.StartDateUTCString = lMatch.StartDateUTC;
    lEnrolleeCard.EndDateUTC = lMatch.EndDate;
    lEnrolleeCard.EndDateUTCString = lMatch.EndDateUTC;

    if (aEnrolleeFound) {
        lEnrolleeCard.Data = lEnrollee;
        lEnrolleeCard.EnrolleeId = lEnrollee.Id;
        lEnrolleeCard.EnrolleeName = lEnrollee.FullName;
        lEnrolleeCard.RiskLevelId = lEnrollee.RiskLevelId;
        lEnrolleeCard.PrimaryId = lEnrollee.PrimaryId;
        lEnrolleeCard.OrganizationId = lEnrollee.OrganizationId;
        lEnrolleeCard.AgentId = lEnrollee.AgentId;
    } else {
        lEnrolleeCard.DisplayNavigateEnrollee = 'none';
    }
    lEnrolleeCard.TimeZoneId = lEnrollee.TimeZoneId;

    if (!isNullOrUndefined(lAgent)) {
        lEnrolleeCard.Agent = lAgent.FullName;
        lEnrolleeCard.AgentPrimaryEmail = lAgent.PrimaryEmail;
    }
    // look at SpatialMatches object to retrieve points.
    lEnrolleeCard.SpatialMatchSearch = 1;
    lEnrolleeCard.DistanceDisplayView = 'none';
    lEnrolleeCard.ScoreView = 'none';
    lEnrolleeCard.IsDeletableClass = 'DeletableButton';
    
    return lEnrolleeCard;
}

function FixStartEndDateDisplayEnrolleeCard(aEnrollee, aCards, aTimeZone) {
    "use strict";
    var lTimeZoneName = '';
    if (aTimeZone) {
        lTimeZoneName = aTimeZone.TimeZoneName;
    }
    aEnrollee.EndDateDisplay = DisplayShortDateTime(displayFixedTimeZoneTime(aCards[0].TrackDateUTC, lTimeZoneName));
    aEnrollee.EndDateUTC = aCards[0].TrackDate;
    aEnrollee.EndMoment = moment(aCards[0].TrackDateUTC);

    if (aCards.length == 1) {
        aEnrollee.StartDateDisplay = DisplayShortDateTime(displayFixedTimeZoneTime(aCards[0].TrackDateUTC, lTimeZoneName));
        aEnrollee.StartDateUTC = aCards[0].TrackDate;
        aEnrollee.StartMoment = moment(aCards[0].TrackDateUTC);
    }
    else {
        aEnrollee.StartDateDisplay = DisplayShortDateTime(displayFixedTimeZoneTime(aCards[aCards.length - 1].TrackDateUTC, lTimeZoneName));
        aEnrollee.StartDateUTC = aCards[aCards.length - 1].TrackDate;
        aEnrollee.StartMoment = moment(aCards[aCards.length - 1].TrackDateUTC);

    }
    aEnrollee.Detail = localizeText('cEnrolleesMappingStart') + ' ' + aEnrollee.StartDateDisplay;
    aEnrollee.Detail2 = localizeText('cEnrolleesMappingEnd') + ' ' + aEnrollee.EndDateDisplay;
}

function SpatialResultsFinalized() {
    "use strict";
    var lSort = new SortExpression(),
    lBuilder = new SumoPredicateBuilder(),
    lMatchesCardList = [],
    lEnrolleeCardList = mAnalysisData.EnrolleeSpatialMatches.slice(),
    lCleanCardList = [],
    lEnrolleeCard,
    lSpatialTrackPointList = [],
    lSpatialLastLocationList = [],
    lSpatialTrackItem,
    lCardList = [],
    lTimeZone,
    lSort = new SortExpression();

    lSort.addDescendingColumn('TrackDate');
    for (var lKey in lEnrolleeCardList) {
        if (lEnrolleeCardList.hasOwnProperty(lKey)) {
            lEnrolleeCard = lEnrolleeCardList[lKey];
            lTimeZone = getTimezone(lEnrolleeCard.TimeZoneId);
            lMatchesCardList = [];

            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional('DeviceId', lEnrolleeCard.TrackingDeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('TrackDateUTC', lEnrolleeCard.StartDateUTCString, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('TrackDateUTC', lEnrolleeCard.EndDateUTCString, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
            lMatchesCardList = query(mAnalysisData.SpatialMatches, lBuilder.RootExpression);
            lMatchesCardList = lSort.sort(lMatchesCardList);
            lEnrolleeCard.TrackpointCount = (ObjectLength(lMatchesCardList));
            if (!isNullOrUndefined(lMatchesCardList[0])) {
                FixStartEndDateDisplayEnrolleeCard(lEnrolleeCard, lMatchesCardList, lTimeZone);
            }
            if (lEnrolleeCard.TrackpointCount > 0) {
                lCleanCardList.push(lEnrolleeCard);
            }
            for (var lKeyB in lMatchesCardList) {
                if (lMatchesCardList.hasOwnProperty(lKeyB)) {
                    lMatchesCardList[lKeyB].GroupId = lEnrolleeCard.Id;
                    lMatchesCardList[lKeyB].EnrolleeId = lEnrolleeCard.EnrolleeId;
                }
            }
        }
    }

    var lSort = new SortExpression();

    lSort.addAscendingColumn('EnrolleeName');


    mAnalysisData.SpatialMatchesList = lSort.sort(lCleanCardList);
   // mAnalysisData.IncidentMatchesClean = lCleanCardList;

    if (mAnalysisData.SpatialMatchesList.length > 0) {
        if (mStateManager.Settings()[0] == 'History') {
            window.location.hash = 'Analysis.Incidents.Map';
        } else {
            ChangeHashSettings(1, 'Map');
        }
    }else{
        NoSpatialResultsFound();
    }
}


// old spatial function modified to support being on incident maps.
function analysisSpatialMatchesFilter() {
    "use strict";
    if (mAnalysisData.SpatialMatchIncident) {
        analysisSetViewZone(mAnalysisData.SpatialMatchIncident.Latitude, mAnalysisData.SpatialMatchIncident.Longitude, sumo.geo.conversion.metersToFeet(mAnalysisData.SpatialMatchIncident.Radius));
        mAnalysisData.EditItem = null;
        mAnalysisData.EditShape = null;

        mAnalysisControls.MatchesCardViewFilter.filter();
    }
}

/* END DISPLAYING A SPATIAL QUERY */

/* VIEWING AND SAVING A SPATIAL QUERY */

function AnalysisDeleteSpatialCards() {
    "use strict";
    if (mStateManager.Settings()[0] == 'Incidents') {
        MarkSpatialMatchesAsDisabled();
    }
}
// delete enrollee card by graying out, allow undelete.
function MarkSpatialMatchesAsDisabled() {
    "use strict";
    var lSpatialMatches = mAnalysisControls.MatchesCardView.getDataSource(),
        lBuilder = new SumoPredicateBuilder(),
        lDeletedList,
        lKey;

    for (lKey in lSpatialMatches) {
        if (lSpatialMatches.hasOwnProperty(lKey)) {
            if (lSpatialMatches[lKey] && lSpatialMatches[lKey].IsDeleted) {
                DisableSpatialCard(lSpatialMatches[lKey]);
            }
        }
    }

    // remove save button if all matches "deleted"
    lBuilder.AddNewExpressionConditional('IsDeleted', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lDeletedList = query(mAnalysisData.IncidentMatchesDirty, lBuilder.RootExpression);
    if (ObjectLength(mAnalysisData.IncidentMatchesDirty) == ObjectLength(lDeletedList)) {
        mActivityNotification.addNotification(localizeWrapper('cAnalysisNoMatchesNoSave'));
        $('#uSaveSpatialIncidentButton').hide();
    } else {
        $('#uSaveSpatialIncidentButton').show();
    }

}

function DisableSpatialCard(aCard) {
    aCard.IsDeleted = true;
    mAnalysisControls.MatchesCardView.markItemAsDisabled(aCard);
    $('.DeletableButton').attr('title', localizeText('cAnalysisEnableEnrollee'));
    $('.DeletableButton').addClass('AddableButton');
}

function uSpatialMatchDelete_OnClick(aId) {
    "use strict";
    var lSelectedCard = mAnalysisControls.MatchesCardView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder(),
        lDeletedList;

    if (!lSelectedCard.IsDeleted) {
        mActivityNotification.addNotification(localizeWrapper('cAnalysisDeleteEnrolleeMatch') + lSelectedCard.EnrolleeName);
        DisableSpatialCard(lSelectedCard)
    } else {
        lSelectedCard.IsDeleted = false;
        mActivityNotification.addNotification(localizeWrapper('cAnalysisEnableEnrolleeMatch') + lSelectedCard.EnrolleeName);
        mAnalysisControls.MatchesCardView.markItemAsEnabled(lSelectedCard);
        $('.DeletableButton').attr('title', localizeText('cAnalysisDeleteEnrollee'));
        $('.DeletableButton').removeClass('AddableButton');
    }

    // remove save button if all matches "deleted"
    lBuilder.AddNewExpressionConditional('IsDeleted', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lDeletedList = query(mAnalysisData.IncidentMatchesDirty, lBuilder.RootExpression);
    if (ObjectLength(mAnalysisData.IncidentMatchesDirty) == ObjectLength(lDeletedList)) {
        mActivityNotification.addNotification(localizeWrapper('cAnalysisNoMatchesNoSave'));
        $('#uSaveSpatialIncidentButton').hide();
    } else {
        $('#uSaveSpatialIncidentButton').show();
    }

}

function uAnalysisExitEditMode(){
    "use strict";
    var lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable');
    ExitEditMode('uAnalysisDetailsPanel');
    $('#uAddIncidentButton').show();
    if (CheckUserHasPermission(45)) {
        checkUniversalDevicesCache();
    } else {
        $('#uAddSpatialQueryButton').show();
    }
    $('#uAnalysisIncidentDetailHolder').show();
    $('#uSaveIncidentButton').hide();
    $('#uCancelIncidentButton').hide();

    if (lStartDateFilterEditable) {
        $('.MapStartDateFilter').hide();
    } else {
        $('.MapEndDateFilter').hide();
    }
    $('#uSearchSpatialButton').hide();
    $('#uAnalysisSpatialMapTimeFilter').hide();
    if ($('#uCancelSpatialQueryButton').is(":visible")) {
        mAnalysisData.EditShape.setVisible(false);
        mAnalysisData.EditShape.setEditable(false);
    }
    $('#uEditSpatialQueryButton').hide();
    $('#uCancelSpatialQueryButton').hide();
    ClearAnalysisAddressInputFields();
    resetContentHolders();
    if (mAnalysisControls.Map) {
        mAnalysisControls.Map.resize();
    }
}

function ClearAnalysisAddressInputFields() {
    "use strict";

    $('#uIncidentDetailAddressStreetEdit').val('');
    $('#uIncidentDetailAddressStreet2Edit').val('');
    $('#uIncidentDetailAddressCityEdit').val('');
    $('#uIncidentDetailAddressStateEdit').val('');
    $('#uIncidentDetailAddressZipcodeEdit').val('');
    $('#uIncidentDetailAddressCountryEdit').val('');
}

function uSaveSpatialIncidentPopup_OnClick() {
    "use strict";
    if (ObjectLength(mAnalysisControls.MatchesCardView.getDataSource()) > 0) {
        var lGeocodeString = mAnalysisData.SpatialMatchIncident.Latitude.toString() + ', ' + mAnalysisData.SpatialMatchIncident.Longitude.toString(),
            lTimeZone = getTimezone(mAnalysisData.SpatialMatchIncident.TimeZoneId),
            lDefaultCaseNumber = moment().valueOf().toString();
        uSaveSpatialIncidentPopup();

        mAnalysisData.SpatialMatchIncident.IncidentNumber = lDefaultCaseNumber;
        // complete
        mAnalysisData.SpatialMatchIncident.Status = 5;

        $('#uSpatialIncidentNumberEdit').val(lDefaultCaseNumber.substr(lDefaultCaseNumber.length - 11));
        $('#uSpatialStartDate').text(convertLocalThenTimeZone(mAnalysisData.SpatialMatchIncident.StartDateUTC, lTimeZone));
        $('#uSpatialEndDate').text(convertLocalThenTimeZone(mAnalysisData.SpatialMatchIncident.EndDateUTC, lTimeZone));

        // reverse geocode here
        mAnalysisControls.Map.geocode(lGeocodeString, spatialMatch_OnGeocode, null);
    } else {
        mActivityNotification.addNotification(localizeWrapper('cAnalysisNoResultsFoundEditSearch'));
    }
}


function spatialMatch_OnGeocode(aResult, aStatus, aParams) {
    var lResult,
        lItem,
        lStreetNumber = '',
        lStreet1 = '',
        lStreet2 = '',
        lCity = '',
        lState = '',
        lZipcode = '',
        lKey,
        lCountry = '';

    if (aStatus === 'OK' && aResult) {
        lResult = Array.isArray(aResult)?aResult[0]:aResult;
        var AddressSearch = new Address(lResult);
        if (lStreetNumber !== '') {
            $('#uSpatialAddressStreet1Edit').val(AddressSearch.Street1);
        }
        else {
            $('#uSpatialAddressStreet1Edit').val(AddressSearch.Street1);
            lStreetNumber = '123';
        }


        $('#uSpatialAddressCityEdit').val(AddressSearch.City);
        $('#uSpatialAddressZipEdit').val(AddressSearch.ZipCode);
        $('#uSpatialAddressStateEdit').val(AddressSearch.State);
        $('#uSpatialAddressCountryEdit').val(AddressSearch.Country);

        mAnalysisData.SpatialMatchIncident.StreetAddressNumber = AddressSearch.StreetNumber;
        mAnalysisData.SpatialMatchIncident.Street1 = AddressSearch.Street1;
        mAnalysisData.SpatialMatchIncident.Street2 = lStreet2;
        mAnalysisData.SpatialMatchIncident.City = AddressSearch.City;
        mAnalysisData.SpatialMatchIncident.State = AddressSearch.State;
        mAnalysisData.SpatialMatchIncident.Zipcode = AddressSearch.ZipCode;
        mAnalysisData.SpatialMatchIncident.Country = AddressSearch.Country;

        mAnalysisControls.Validator.IsValid();
    }
}

function uSaveSpatialIncidentPopup() {
    "use strict";
    // save
    var lBodyHtml = [],
        lHeight = $(window).height(),
        lOffenses = getDataItems('Offense'),
        lOrganizations = OrganizationSortFormatter(),
        lItem,
        lButtonCommandBar = GenerateButtonCommandBar();

    if (lHeight < 800) {
        lBodyHtml.push('<div style="height:500px; overflow-y:scroll">');
    }
    lBodyHtml.push('<table>');
    lBodyHtml.push('<tr><td colspan="2"><h2>'+localizeWrapper('cEnrolleeDetails')+'</h2></td></tr>');
    lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cAnalysisIncidentNumber') + '</td>');
    lBodyHtml.push('<td class="FormField"><input type="text" id="uSpatialIncidentNumberEdit" class="Validate ValidateRequired ValidateLength Validate30Length" /></td></tr>');
    lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleePrimaryOffense') + '</td>');
    lBodyHtml.push('<td class="FormField"><select id="uSpatialPrimaryOffenseEdit">');
    for (var lKey in lOffenses) {
        if (lOffenses.hasOwnProperty(lKey)) {
            lItem = lOffenses[lKey];
            lBodyHtml.push('<option value="');
            lBodyHtml.push(lItem.Id);
            lBodyHtml.push('">');
            lBodyHtml.push(localizeDataItem('Offense', lItem.Description));
            lBodyHtml.push('</option>');
        }
    }
    lBodyHtml.push('</select></td>');

    // I think we do not need to let them edit this. If we do then do we need to run spatial query again?
    lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEventStartDate') + '</td>');
    lBodyHtml.push('<td class="FormField"><span id="uSpatialStartDate"/></td></tr>');
    //lBodyHtml.push('<td class="FormField"><input type="text" id="uSpatialStartDateEdit" class="Validate ValidateRequired EnrolleeAddressMustGeocode ValidateLength Validate100Length" /></td></tr>');
    //lBodyHtml.push('<tr><td></td><td class="FormField"><input type="text" id="uSpatialStartTimeEdit" class="Validate ValidateRequired EnrolleeAddressMustGeocode ValidateLength Validate100Length" /></td></tr>');

    lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeEndDate') + '</td>');
    lBodyHtml.push('<td class="FormField"><span id="uSpatialEndDate"/></td></tr>');
    //lBodyHtml.push('<td class="FormField"><input type="text" id="uSpatialEndDateEdit" class="Validate ValidateRequired EnrolleeAddressMustGeocode ValidateLength Validate100Length" /></td></tr>');
    //lBodyHtml.push('<tr><td></td><td class="FormField"><input type="text" id="uSpatialEndTimeEdit" class="Validate ValidateRequired EnrolleeAddressMustGeocode ValidateLength Validate100Length" /></td></tr>');

    lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeOrganization') + '</td>');
    lBodyHtml.push('<td class="FormField"><select id="uSpatialOrganizationEdit">');
    for (var lKey in lOrganizations) {
        if (lOrganizations.hasOwnProperty(lKey)) {
            lItem = lOrganizations[lKey];
            lBodyHtml.push('<option value="');
            lBodyHtml.push(lItem.Id);
            lBodyHtml.push('">');
            lBodyHtml.push(lItem.Name);
            lBodyHtml.push('</option>');
        }
    }
    lBodyHtml.push('</select></td></tr>');
    lBodyHtml.push('<tr>');
    lBodyHtml.push('<td><h2>' + localizeWrapper('cEnrolleeAddress') + '</h2></td>');
    lBodyHtml.push('</tr>');

    lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressStreet1') + '</td>');
    //lBodyHtml.push('<td class="FormField"><span id="uSpatialAddressStreet1Edit"/></td></tr>');

    lBodyHtml.push('<td class="FormField"><input type="text" id="uSpatialAddressStreet1Edit" class="Validate ValidateRequired EnrolleeAddressMustGeocode ValidateLength Validate100Length" /></td></tr>');
    lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressStreet2') + '</td>');
    //lBodyHtml.push('<td class="FormField"><span id="uSpatialAddressStreet2Edit"/></td></tr>');
    lBodyHtml.push('<td class="FormField"><input type="text" id="uSpatialAddressStreet2Edit" class="EnrolleeAddressMustGeocode Validate ValidateLength Validate100Length" /></td></tr>');
    lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressCity') + '</td>');
    //lBodyHtml.push('<td class="FormField"><span id="uSpatialAddressCityEdit"/></td></tr>');
    lBodyHtml.push('<td class="FormField"><input type="text" id="uSpatialAddressCityEdit" class="Validate ValidateRequired EnrolleeAddressMustGeocode ValidateLength Validate50Length" /></td></tr>');
    lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressState') + '</td>');
    //lBodyHtml.push('<td class="FormField"><span id="uSpatialAddressStateEdit"/></td></tr>');
    lBodyHtml.push('<td class="FormField"><input type="text" id="uSpatialAddressStateEdit" class="Validate ValidateRequired EnrolleeAddressMustGeocode ValidateLength Validate255Length" /></td></tr>');
    lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressZipCode') + '</td>');
    //lBodyHtml.push('<td class="FormField"><span id="uSpatialAddressZipEdit"/></td></tr>');
    lBodyHtml.push('<td class="FormField"><input type="text" id="uSpatialAddressZipEdit" class="Validate EnrolleeAddressMustGeocode ValidateLength Validate10Length" /></td></tr>');
    lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressCountry') + '</td>');
    //lBodyHtml.push('<td class="FormField"><span id="uSpatialAddressCountryEdit"/></td></tr>');
    lBodyHtml.push('<td class="FormField"><input type="text" id="uSpatialAddressCountryEdit" class="Validate ValidateRequired EnrolleeAddressMustGeocode ValidateLength Validate255Length" value="USA" />');
    lBodyHtml.push('<input type="hidden" id="uOffenderAddressLatitudeEdit" value="0.0" />');
    lBodyHtml.push('<input type="hidden" id="uOffenderAddressLongitudeEdit" value="0.0" />');
    lBodyHtml.push('</td></tr>');
    lBodyHtml.push('</table>');
    if (lHeight < 500) {
        lBodyHtml.push('</div>');
    }

    GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', SaveSpatialIncident_OnClick).appendTo(lButtonCommandBar);
    GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', ClosePopup).appendTo(lButtonCommandBar);
    DisplayPopup(localizeWrapper('cIncidentAddNewSpatial'), lBodyHtml.join(''), lButtonCommandBar, false);
    mAnalysisControls.Validator = new Validator('uPopupContainer', mRegexValidation);
}

function SaveSpatialIncident_OnClick() {
    "use strict";
    var lSubstring = $('#uSpatialIncidentNumberEdit').val(),
        lBuilder = new SumoPredicateBuilder(),
        lIncident,
        lAgent,
        lTimezone;

    if (mAnalysisControls.Validator.IsValid()) {
        lIncident = new Incident();

        lIncident.City = mAnalysisData.SpatialMatchIncident.City;
        lIncident.Country = mAnalysisData.SpatialMatchIncident.Country;
        lIncident.Street1 = mAnalysisData.SpatialMatchIncident.Street1;
        lIncident.Street2 = mAnalysisData.SpatialMatchIncident.Street2;
        lIncident.StreetAddressNumber = mAnalysisData.SpatialMatchIncident.StreetAddressNumber;
        lIncident.Zipcode = mAnalysisData.SpatialMatchIncident.Zipcode;
        lIncident.State = mAnalysisData.SpatialMatchIncident.State;
        lIncident.TimeZoneCode = mAnalysisData.SpatialMatchIncident.TimeZoneCode;
        lIncident.TimeZoneId = mAnalysisData.SpatialMatchIncident.TimeZoneId;
        lIncident.ClearedException = '-1';
        lIncident.Disposition = '1';

        lIncident.IncidentNumber = lSubstring;
        lIncident.PrimaryOffense = $('#uSpatialPrimaryOffenseEdit').val();
        lIncident.OrganizationId = $('#uSpatialOrganizationEdit').val();

        lIncident.Latitude = RoundNumber(mAnalysisData.SpatialMatchIncident.Latitude, 7);
        lIncident.Longitude = RoundNumber(mAnalysisData.SpatialMatchIncident.Longitude, 7);

        lIncident.Status = 5;

        lBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('OrganizationId', lIncident.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lAgent = query(getDataItems('Agents'), lBuilder.RootExpression);
        if (lAgent.length == 0) {
            lAgent = query(getDataItems('AgentsStop'), lBuilder.RootExpression);
        }
        for (var lKey in lAgent) {
            if (lAgent.hasOwnProperty(lKey)) {
                lTimezone = getDataItem(lAgent[lKey].TimeZoneId, 'TimeZone');
                lIncident.TimeZoneCode = lTimezone.TimeZoneCode;
                lIncident.TimeZoneId = lTimezone.Id;
            }
        }

        var lStart = moment($('#uSpatialStartDate').text()).toDate();
        var lEnd = moment($('#uSpatialEndDate').text()).toDate();

        lIncident.StartDateUTC = convertTimeToUTC(lStart, lTimezone.TimeZoneName);
        lIncident.EndDateUTC = convertTimeToUTC(lEnd, lTimezone.TimeZoneName);

        lIncident.Radius = mAnalysisData.SpatialMatchIncident.Radius

        mAnalysisData.TempSpatialMatchIncident = $.extend({}, lIncident);
        lIncident.Radius = RoundNumber(sumo.geo.conversion.metersToFeet(lIncident.Radius), 2);
        //fix 3.4.03
        lIncident.ClearedDateUTC = moment()._d;
        lIncident.TransactionId = moment().format("YYYYMMDDHHmmss");
        WriteSingle(lIncident, SaveSpatialIncident_OnSuccess, SaveSpatialIncident_OnFailure, null, true);
    }
}

function SaveSpatialIncident_OnSuccess(aParams, aData){
    "use strict";
    var lMatches = mAnalysisData.IncidentMatchesDirty,
        lIncidentMatch,
        lCleanMatches = [],
        lIncidentMatches = [];

     //grab matches that need to be saved.
    if (!isNullOrUndefined(aData) && aData.Id > 0) {
        // write to incidents cache.
        FixDates(aData);
        $('#uSaveSpatialIncidentButton').hide();
        setDataItem(aData.Id, 'Incidents', aData);
        for (var lKey in lMatches) {
            if (lMatches.hasOwnProperty(lKey)) {
                if (!lMatches[lKey].IsDeleted) {
                    // needed to add extra fields so that it would update server cache.
                    var lTimeZone = getEnrolleeTimeZone(lMatches[lKey].EnrolleeId, aData.TimeZoneId);
                    lIncidentMatch = new IncidentMatch();
                    lIncidentMatch.IncidentId = aData.Id;
                    lIncidentMatch.EnrolleeId = lMatches[lKey].EnrolleeId;
                    lIncidentMatch.EnrolleeName = lMatches[lKey].EnrolleeName;
                    lIncidentMatch.Agent = lMatches[lKey].Agent;
                    lIncidentMatch.AgentPrimaryEmail = lMatches[lKey].AgentPrimaryEmail;
                    lIncidentMatch.PrimaryId = lMatches[lKey].PrimaryId
                    lIncidentMatch.AgentId = lMatches[lKey].AgentId;

                    lIncidentMatch.StartDateString = lMatches[lKey].StartMoment.tz(lTimeZone.TimeZoneName).toISOString();
                    lIncidentMatch.EndDateString = lMatches[lKey].EndMoment.tz(lTimeZone.TimeZoneName).toISOString();
                    //lIncidentMatch.StartDateUTC = convertTimeToUTC(lMatches[lKey].StartDateUTC);
                    //lIncidentMatch.EndDateUTC = convertTimeToUTC(lMatches[lKey].EndDateUTC);
                    lIncidentMatch.TrackpointCount = lMatches[lKey].TrackpointCount;
                    lMatches[lKey].IsDeletableClass = '';
                    lIncidentMatch.TransactionId = moment().format("YYYYMMDDHHmmss");
                    // sending clean matches because want to remove "deleted" matches
                    lCleanMatches.push(lMatches[lKey]);
                    lIncidentMatches.push(lIncidentMatch);
                }
            }
        }
    } else if (aData.Id == -1) {
        mActivityNotification.addNotification(localizeWrapper('cAnalysisIncidentSaveError'));
    }
    else { //Id = -2
        mActivityNotification.addNotification(localizeWrapper('cAnalysisIncidentAlreadyExists'));
    }

    // save incident matches
    if (lIncidentMatches.length > 0) {
        mActivityNotification.addNotification(localizeWrapper('cAnalysisIncidentMatchSaving') + aData.IncidentNumber + '.');
        WriteMultiple(lIncidentMatches, IncidentMatches_OnSuccess, IncidentMatches_OnFailure, lCleanMatches, true);
    }
}

function fixSpatialDate(aDate, aTimeZone) {
    "use strict";
    var lOffset = moment().zone();
    var lTimeZoneOffset = moment().tz(aTimeZone.TimeZoneName).zone();
    var lFixed = lOffset - lTimeZoneOffset;
}

function IncidentMatches_OnSuccess(aParams, aData) {
    "use strict";
    var lData = aParams;
    ClosePopup();
    mAnalysisData.SpatialMatchIncident = null;
    mAnalysisData.SpatialMatchesList = aParams;
    mAnalysisControls.MatchesCardViewFilter.filter();
    $('#uEditSpatialIncidentButton').hide();
    $('#uSaveSpatialIncidentButton').hide();
}

function IncidentMatches_OnFailure() {
    "use strict";
}

function SaveSpatialIncident_OnFailure(aParams, aData){
    "use strict";
}


function uCancelReturnSpatialIncidentButton_OnClick(aEdit) {
    "use strict";
    // cancel
    // maybe enter edit mode?
    if(!aEdit)
        mAnalysisData.SpatialMatchIncident = null;
    ChangeHashSettings(1, 'Details');
}

/* END VIEWING AND SAVING SPATIAL QUERY */

function checkUniversalDevicesCache() {
    "use strict";
    $('#uAddSpatialQueryButton').show();
    $('#uAddSpatialQueryButton').addClass('Disabled');
    if (gUniversalDeviceIds.length > 0) {
        $('#uAddSpatialQueryButton').removeClass('Disabled');
    } else {
        var universalDeviceCheck = setInterval(function () {
            if (gUniversalDeviceIds.length > 0) {
                clearInterval(universalDeviceCheck);
                $('#uAddSpatialQueryButton').removeClass('Disabled');
            }
        }, 1000)
    }
}

/* END SPATIAL FEATURE */



function uAddIncidentButton() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lOrganizations;
    var lDisplayType = 'roadmap';
    mAnalysisData.EditItem = new Incident();
    //lBuilder.AddNewExpressionConditional('Id', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    //lOrganizations = query(OrganizationSortFormatter(), lBuilder.RootExpression);
    lOrganizations = OrganizationSortFormatter();
    $('#uAddIncidentButton').hide();
    $('#uAddSpatialQueryButton').hide();
    $('#uCancelIncidentButton').show();
    EnterEditMode('uAnalysisADetailsPanel');
    populateDateView('#uIncidentOldDetailStartDateUTCEdit', analysisIncidentDatePicker_OnChange);
    populateDateView('#uIncidentOldDetailEndDateUTCEdit', analysisIncidentDatePicker_OnChange);
    $('.OldIncidentTimePicker').ptTimeSelect({
        'zIndex': 100000,
        'onFocusDisplay': true
    });
    $('#uStartEndDateError').hide();
    $('#uUniqueIncidentError').hide();
    populateEditView(mAnalysisData.EditItem, [
       { 'Id': 'PrimaryOffense', 'Type': 'Dropdown', 'DataSource': getDataItems('Offense'), 'LocaleName': 'Offense', 'DataValueField': 'Id', 'DataTextField': 'Description', 'isNullableKey': true },
       { 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': lOrganizations, 'DataValueField': 'Id', 'DataTextField': 'Name' },
       { 'Id': 'Disposition', 'Type': 'Dropdown', 'DataSource': getDataItems('Disposition'), 'LocaleName': 'Disposition', 'DataValueField': 'Id', 'DataTextField': 'Description' },
       { 'Id': 'ClearedException', 'Type': 'Dropdown', 'DataSource': getDataItems('ClearedException'), 'LocaleName': 'ClearedException', 'DataValueField': 'Id', 'DataTextField': 'Description', 'isNullableKey': true }
    ], {
        'StartDateUTC': displayShortDate,
        'EndDateUTC': displayShortDate //,
        //'ClearedDateUTC': dateSelectorFormatter
    }, 'uIncidentOldDetail', 'Edit', localizeDataItem);
    PopulateDetailView(mAnalysisData.EditItem, { 'Status': processStatusFormatter }, 'uIncidentOldDetailEdit');

    $('#uIncidentOldDetailStartTimeUTCEdit').val($.format.date(mAnalysisData.EditItem.StartDateUTC, "h:mm a"));
    $('#uIncidentOldDetailEndTimeUTCEdit').val($.format.date(mAnalysisData.EditItem.EndDateUTC, "h:mm a"));


    var tableHeight = $('#uAnalysisIncidentTableBody').height()

    $('#uIncidentMapPanel').height(tableHeight)

    mAnalysisControls.IncidentMap = new sumo.maps.GoogleMapControl('uIncidentDetailsMap', 'uIncidentMapPanel',
      {
          'displayType': lDisplayType,
          'mapTypeId_OnChange': mapDisplayType_OnChange
      });

    mAnalysisControls.IncidentMap.layerAdd('Incidents', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'dragEndEventHandler': uOldIncidentAddressEditMap_OnDragEnd,
        'zIndexStart': 1700000
    });

    mAnalysisControls.Validator = new Validator('uAnalysisADetailsPanel', mRegexValidation);

    $('.AddressRequired').keyup(function () {
        $('#uSaveIncidentButton').hide();
    });
    $('#uAnalysisIncidentTableBody').show();
    $('#uIncidentDateError').hide();
}

function uSaveIncidentButton_OnClick() {
    "use strict";

    var lStartDate = new Date($('#uIncidentOldDetailStartDateUTCEdit').val() + ' ' + $('#uIncidentOldDetailStartTimeUTCEdit').val()),
        lEndDate = new Date($('#uIncidentOldDetailEndDateUTCEdit').val() + ' ' + $('#uIncidentOldDetailEndTimeUTCEdit').val()),
        lBuilder = new SumoPredicateBuilder(),
        lAgent,
        lTimezone;

    //var lStartDate = new Date($('#uIncidentDetailStartDateUTCEdit').val()),
    //  lEndDate = new Date($('#uIncidentDetailEndDateUTCEdit').val());
    $('#uIncidentDateError').hide();
    $('#uStartEndDateError').hide();
    if (lEndDate <= lStartDate) {
        $('#uIncidentDateError').show();
    } else if (moment(lStartDate).add(2, 'days') < moment(lEndDate)){
        $('#uStartEndDateError').show();
    }
    else if (mAnalysisControls.Validator.IsValid()) {
        $('#uUniqueIncidentError').hide();
        $('#uStartEndDateError').hide();
        var lLatitude = parseFloat($('#uIncidentsAddressLatitudeEdit').val());
        var lLongitude = parseFloat($('#uIncidentsAddressLongitudeEdit').val());
        populateFromEditView(mAnalysisData.EditItem, 'uIncidentOldDetail', 'Edit');
        mAnalysisData.EditItem.TransactionId = moment().format("YYYYMMDDHHmmss");
        mAnalysisData.EditItem.Latitude = RoundNumber(lLatitude, 7);
        mAnalysisData.EditItem.Longitude = RoundNumber(lLongitude, 7);
        lBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('OrganizationId', mAnalysisData.EditItem.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lAgent = query(getDataItems('Agents'), lBuilder.RootExpression);
        if (lAgent.length == 0) {
            lAgent = query(getDataItems('AgentsStop'), lBuilder.RootExpression);
        }
        for (var lKey in lAgent) {
            if (lAgent.hasOwnProperty(lKey)) {
                lTimezone = getDataItem(lAgent[lKey].TimeZoneId, 'TimeZone');
                mAnalysisData.EditItem.TimeZoneCode = lTimezone.TimeZoneCode;
                mAnalysisData.EditItem.TimeZoneId = lTimezone.Id;
            }
        }
        mAnalysisData.EditItem.Radius = mAnalysisData.SpatialRadius;

        mAnalysisData.EditItem.StartDateUTC = new Date($('#uIncidentOldDetailStartDateUTCEdit').val() + ' ' + $('#uIncidentOldDetailStartTimeUTCEdit').val());
        mAnalysisData.EditItem.EndDateUTC =new Date($('#uIncidentOldDetailEndDateUTCEdit').val() + ' ' + $('#uIncidentOldDetailEndTimeUTCEdit').val());
        //mAnalysisData.EditItem.ClearedDateUTC = new Date(mAnalysisData.EditItem.ClearedDateUTC);
        mActivityNotification.addNotification(localizeWrapper('cAnalysisIncidentSaving') + mAnalysisData.EditItem.IncidentNumber);
        $('#uSaveIncidentButton').hide();
        $('#uCancelIncidentButton').hide();
        WriteSingle(mAnalysisData.EditItem, analysisIncidentSave_OnSuccess, analysisIncidentSave_OnFailure, null, true);
    }

}

function uDeleteIncidentButton_OnClick() {
    "use strict";
    var lIncident = getDataItem(mAnalysisControls.CardView.selectedDataItem().Id, 'Incidents');

    lIncident.IsActive = false;
    lIncident.TransactionId = moment().format("YYYYMMDDHHmmss");

    WriteSingle(lIncident, DeleteIncident_OnSuccess, Sad, null, true);

}
function DeleteIncident_OnSuccess(aParams, aData) {
    "use strict";

    setDataItem(aData.Id, 'Incidents', aData);
    analysisResetIncidentCardView();
}

function analysisIncidentDatePicker_OnChange() {
    "use strict";
    mAnalysisControls.Validator.IsValid();
}

function analysisIncidentSave_OnSuccess(aParams, aData) {
    "use strict";
    if (aData.Id === -1) {
        // stored procedure failed
        analysisIncidentSave_OnFailure(aParams, {}, '', '');
    } else if (aData.Id === -2) {
        // IncidentNumber duplicated
        mActivityNotification.addNotification('Save Failed: Duplicate Incident Number');
        $('#uSaveIncidentButton').show();
        $('#uCancelIncidentButton').show();
        $('#uUniqueIncidentError').show();
    } else {
        // standard success
        FixDates(aData);
        mActivityNotification.addNotification(localizeWrapper('cAnalysisIncidentSaved') + aData.IncidentNumber);
        setDataItem(aData.Id, 'Incidents', aData);
        ExitEditMode('uAnalysisADetailsPanel');
        mAnalysisControls.Validator.dispose();
        mAnalysisControls.Validator = null;
        ClosePopup();
        window.location.hash = 'Analysis.History.Map.' + aData.Id.toString();
    }
}

function analysisResetIncidentCardView(aSender, aId, aData) {
    "use strict";
    analysisDataListConverter();
    mAnalysisControls.CardViewFilter.filter();
}

function uAnalysisAddressEditMapLocateButton_OnClick() {
    "use strict";
    var lAddress = '';
    lAddress += $('#uIncidentOldDetailAddressStreetEdit').val();
    lAddress += ' ' + $('#uIncidentOldDetailAddressStreet2Edit').val();
    lAddress += ' ' + $('#uIncidentOldDetailAddressCityEdit').val();
    lAddress += ' ' + $('#uIncidentOldDetailAddressStateEdit').val();
    lAddress += ' ' + $('#uIncidentOldDetailAddressZipcodeEdit').val();
    lAddress += ' ' + $('#uIncidentOldDetailAddressCountryEdit').val();

    mAnalysisControls.IncidentMap.locate(lAddress, uAnalysisAddressMapLocate_OnComplete);
}

function analysisSetAddressMarker(aLatitude, aLongitude) {
    "use strict";
    var lMarkerData = [],
        lMarker;
    mAnalysisControls.IncidentMap.setCenter(aLatitude, aLongitude);
    mAnalysisControls.IncidentMap.zoom(17);
    lMarkerData.push({
        'latitude': aLatitude,
        'longitude': aLongitude,
        'anchor': { 'x': 12, 'y': 12 },
        'iconUri': 'Images/Maps/other.png',
        'doHover': false
    });
    mAnalysisControls.IncidentMap.layerShow('Incidents');
    mAnalysisControls.IncidentMap.layerSetDataSource('Incidents', lMarkerData);
}



function uAnalysisAddressMapLocate_OnComplete(aType, aLocation) {
    "use strict";
    var lItem,
        lStreetNumber = '',
        lStreet1 = '',
        lStreet2 = '',
        lCity = '',
        lState = '',
        lZipcode = '',
        lKey,
        lCountry = '';
    if (aType === 'Geocode') {
        if (aLocation !== null) {
            mActivityNotification.addNotification(localizeWrapper('cDefaultCenteringAddress') + aLocation.formated_address);
            mAnalysisData.EditItem.Latitude = aLocation.geometry.location.lat();
            mAnalysisData.EditItem.Longitude = aLocation.geometry.location.lng();
            $('#uIncidentsAddressLatitudeEdit').val(aLocation.geometry.location.lat());
            $('#uIncidentsAddressLongitudeEdit').val(aLocation.geometry.location.lng());
            analysisSetAddressMarker(aLocation.geometry.location.lat(), aLocation.geometry.location.lng());
            $('#uSaveIncidentButton').show();

            var AddressSearch = new Address(aLocation);

            if (lStreetNumber !== '') {
                $('#uIncidentOldDetailAddressStreetEdit').val(AddressSearch.Street1);
            }
            else {
                $('#uIncidentOldDetailAddressStreetEdit').val(AddressSearch.Street1);
                lStreetNumber = '123';
            }
            $('#uIncidentOldDetailAddressCityEdit').val(AddressSearch.City);
            $('#uIncidentOldDetailAddressZipcodeEdit').val(AddressSearch.ZipCode);
            $('#uIncidentOldDetailAddressStateEdit').val(AddressSearch.State);
            $('#uIncidentOldDetailAddressCountryEdit').val(AddressSearch.Country);

            mAnalysisData.EditItem.StreetAddressNumber = AddressSearch.StreetNumber;
            mAnalysisData.EditItem.Street1 = AddressSearch.Street1;
            mAnalysisData.EditItem.Street2 = lStreet2;
            mAnalysisData.EditItem.City = AddressSearch.City;
            mAnalysisData.EditItem.State = AddressSearch.State;
            mAnalysisData.EditItem.Zipcode = AddressSearch.ZipCode;
            mAnalysisData.EditItem.Country = AddressSearch.Country;

            mAnalysisControls.Validator.IsValid();
        } else {
            mActivityNotification.addNotification(localizeWrapper('cDefaultAddressNotGeocoded'));
        }
    } else {
        mActivityNotification.addNotification(localizeWrapper('cDefaultCenteringLatLong') + aLocation.Latitude + ', ' + aLocation.Longitude);
        aLocation;
    }
}

function uMatchesPaginator_OnPageChanged(aSender, aData) {
    "use strict";
    if (!isNullOrUndefined(mAnalysisData.IncidentMatchesDirty)) {
        mAnalysisData.IncidentMatchesPaginated = aSender.paginate(mAnalysisData.IncidentMatchesDirty);
        mAnalysisControls.MatchesCardView.setDataSource(mAnalysisData.IncidentMatchesPaginated);
        AnalysisDeleteSpatialCards();
    }
}

function uSpatialMatchesPaginator_OnPageChanged(aSender, aData) {
    "use strict";
    if (!isNullOrUndefined(mAnalysisData.SpatialMatches)) {
        mAnalysisData.SpatialMatchesPaginated = aSender.paginate(mAnalysisData.SpatialMatchesList);
        mAnalysisControls.SpatialCardView.setDataSource(mAnalysisData.SpatialMatchesPaginated);
        uSpatialLastLocationByCardViewFiltered();
    }
}

function analysisIncidentSave_OnFailure(aParams, a, b, c) {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cAnalysisIncidentSaveFailed'));
    $('#uSaveIncidentButton').show();
    $('#uCancelIncidentButton').show();
}

function analysisSpatialCardViewPaginator_Init() {
    "use strict";
    if (isNullOrUndefined(mAnalysisControls.SpatialCardViewPaginator)) {
        mAnalysisControls.SpatialCardViewPaginator = new sumo.controls.Paginator('uAnalysisCardViewPaginator', 'uAnalysisSpatialMatchesPagerHolder', {
            'ItemCount': count(mAnalysisData.SpatialMatches),
            'ItemsPerPage': gPaginationSettings.AnalysisSpatialItems
        });
        mAnalysisControls.SpatialCardViewPaginator.bind('pagechanged', uSpatialMatchesPaginator_OnPageChanged);
    } else {
        mAnalysisControls.SpatialCardViewPaginator.render();
    }
}

function analysisSpatialMatchesCardView_OnSelectChange(aSender, aSelected, aData) {
    "use strict";
    var lCard = mAnalysisControls.SpatialCardView.selectedDataItem(),
        lTrackItem,
        lFilename;
    if (!isNullOrUndefined(mAnalysisControls.NotificationPanel)) {
        mAnalysisControls.NotificationPanel.clearNotifications();
    }
    mAnalysisControls.Map.layerSetDataSource('Selected', []);
    if (!isNullOrUndefined(lCard)) {
        switch (lCard.Type) {
            case 1:
                lTrackItem = $.extend({}, lCard.TrackItem);
                lFilename = lTrackItem.iconUri.substring(0, lTrackItem.iconUri.length - 4) + 'Selected.png';
                lTrackItem.iconUri = lFilename;
                mAnalysisControls.Map.locate(lCard.Latitude + ', ' + lCard.Longitude, null);
                mAnalysisControls.Map.layerSetDataSource('LabelsSelected', []);
                mAnalysisControls.Map.layerSetDataSource('Selected', [lTrackItem]);
                $('#uSpatialExpandButton').hide();
                $('#uSpatialCollapseButton').hide();
                break;
            case 2:
                mAnalysisControls.Map.layerSetDataSource('Selected', []);
                var lChosenOne = { 'Latitude': lCard.Latitude, 'Longitude': lCard.Longitude, 'TrackTypeId': 12, 'Name': lCard.FullName };
                mAnalysisControls.Map.layerSetDataSource('LabelsSelected', veritracks.mapping.prepareSuggestionLabelOverlayDataSelected([lChosenOne]));
                if (lCard.IsExpanded) {
                    $('#uSpatialCollapseButton').show();
                    $('#uSpatialExpandButton').hide();
                }
                else {
                    $('#uSpatialExpandButton').show();
                    $('#uSpatialCollapseButton').hide();
                }
        }
    }
    else {
        mAnalysisControls.Map.layerSetDataSource('Selected', []);
        mAnalysisControls.Map.layerSetDataSource('LabelsSelected', []);
        $('#uSpatialExpandButton').hide();
        $('#uSpatialCollapseButton').hide();
    }
}


function analysisSpatialMatchesCardView_Init() {
    "use strict";
    if (isNullOrUndefined(mAnalysisControls.SpatialCardView)) {
        mAnalysisControls.SpatialCardView = new sumo.controls.CardView('uAnalysisCardView', 'uAnalysisSpatialMatchesListHolder', { 'cardTemplate': 'Interface/Analysis.Spatial.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': true, 'cssClass': 'VeritracksCardView' });
        mAnalysisControls.SpatialCardView.bind('databind', SpatialcardView_OnDataBind);
        mAnalysisControls.SpatialCardView.bind('selectedchanged', veritracks.security.controller.extendSession);
        mAnalysisControls.SpatialCardView.bind('selectedchanged', analysisSpatialMatchesCardView_OnSelectChange);
    }
}

function SpatialcardView_OnDataBind(aSender, aParams, aData) {
    //aSender.selectedIndex(0);
    resetContentHolders();
}

function analysisSpatialMapShape_OnChange(aShape) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
    lTrackpointList;

    if (mAnalysisData.EditItem.Shape === 1) {
        var lRadius = sumo.geo.conversion.metersToFeet(aShape.radius);

        if (lRadius > mAnalysisData.SpatialMatchRadius) {
            mActivityNotification.addNotification(localizeWrapper('cAnalysisSpatialQueryRadiusLarge'));
            // issue 1 for artf79553
            mAnalysisData.EditItem.Radius = mAnalysisData.SpatialMatchRadius;
            analysisSetViewZone(mAnalysisData.EditItem.CenterLatitude, mAnalysisData.EditItem.CenterLongitude, mAnalysisData.EditItem.Radius, 1);
            mAnalysisData.EditShape = mAnalysisControls.Map.layerGetShape('Spatial', mAnalysisData.EditItem.Id);
            mAnalysisData.EditShape.setEditable(true);
            return;
        }

        mAnalysisData.EditItem.CenterLatitude = aShape.center.lat();
        mAnalysisData.EditItem.CenterLongitude = aShape.center.lng();
        mAnalysisData.EditItem.Radius = lRadius;
        analysisSetViewZoneRadius(mAnalysisData.EditItem.CenterLatitude, mAnalysisData.EditItem.CenterLongitude, mAnalysisData.EditItem.Radius);
    } else {
        var lCenter = aShape.getCenter();
        mAnalysisData.EditItem.CenterLatitude = lCenter.lat();
        mAnalysisData.EditItem.CenterLongitude = lCenter.lng();
    }
}

function uAnalysisMapPlayback_OnProgressed(aSender, aMatch, aAnalysisData) {
    "use strict";

    var lPercentage = ((aMatch.currentIndex + 1) / aMatch.overlayCount) * 100,
        lEnrolleeCard = mAnalysisControls.MatchesCardView.selectedDataItem(),
        lTimeZone = getTimezone(lEnrolleeCard.TimeZoneId),
        lDate;

    if (aMatch.currentPoint.TrackDateUTC && lTimeZone) {
        lDate = DisplayShortDateTime(displayEnrolleeTimeZone(aMatch.currentPoint.TrackDateUTC, lTimeZone));
    } else {
        lDate = DisplayShortDateTime(aMatch.currentPoint.TrackDate);
    }
    $('#uMapPlaybackOutput').html('Trackpoint ' + (aMatch.currentIndex + 1).toString() + ' of ' + aMatch.overlayCount.toString() + ' (' + lDate + ')');
    // $('#uMapPlaybackProgressBar').width(lPercentage.toString() + '%');
    $('#uSlider').slider('option', 'value', aMatch.currentIndex);
}

function uAnalysisMapPlayback_OnCompleted(aSender, aMatch, aAnalysisData) {
    "use strict";
    uAnalysisMapPlaybackStopButton_OnClick();
}

function uAnalysisMapPlaybackNextButton_OnClick() {
    "use strict";
    if (mAnalysisData.PlaybackStatus === 'Stopped') {
        $('#uSlider').slider('option', 'max', mAnalysisControls.PlaybackControl.getOverlayCount() - 1);
    }
    //mEnrolleesData.PlaybackStatus = 'Paused';
    mAnalysisControls.PlaybackControl.next();
}

function uAnalysisMapPlaybackPreviousButton_OnClick() {
    "use strict";
    if (mAnalysisData.PlaybackStatus === 'Stopped') {
        $('#uSlider').slider('option', 'max', mAnalysisControls.PlaybackControl.getOverlayCount() - 1);
    }
    //mEnrolleesData.PlaybackStatus = 'Paused';
    mAnalysisControls.PlaybackControl.previous();
}

function uAnalysisMapPlaybackStopButton_OnClick() {
    "use strict";

    if (!isNullOrUndefined(mAnalysisControls.PlaybackControl)) {
        mAnalysisControls.PlaybackControl.stop();
    }
    mAnalysisData.PlaybackDirection = 1;
    mAnalysisData.PlaybackDivider = 1;
    $('#uMapPlaybackSpeed').html('');
    $('#uMapPlaybackOutput').html('');
    $('#uSlider').slider('option', 'value', 0);
}

function uAnalysisMapPlaybackPlayButton_OnClick() {
    "use strict";
    $('#uSlider').slider('option', 'max', mAnalysisControls.PlaybackControl.getOverlayCount() - 1);
    $('#uMapPlaybackSpeed').html('(' + mAnalysisData.PlaybackDivider + 'x)');
    mAnalysisControls.PlaybackControl.start();
}

function uAnalysisMapPlaybackPauseButton_OnClick() {
    "use strict";
    mAnalysisControls.PlaybackControl.pause();
    $('#uMapPlaybackSpeed').html('');
}

function uAnalysisMapPlaybackRewindButton_OnClick() {
    "use strict";

    if (mAnalysisData.PlaybackStatus === 'Playing' || mAnalysisData.PlaybackStatus === 'Rewinding') {
        if (mAnalysisData.PlaybackDirection === -1) {
            switch (mAnalysisData.PlaybackDivider) {
                case 1:
                    mAnalysisData.PlaybackDivider = 2;
                    break;
                case 2:
                    mAnalysisData.PlaybackDivider = 4;
                    break;
                case 4:
                    mAnalysisData.PlaybackDivider = 8;
                    break;
                case 8:
                    mAnalysisData.PlaybackDivider = 1;
                    break;
            }
        } else {
            //mAnalysisData.PlaybackStatus = 'Rewinding';
            //$('#uMapPlaybackStatus').html(mAnalysisData.PlaybackStatus);
            mAnalysisData.PlaybackDirection = -1;
            mAnalysisData.PlaybackDivider = 1;
            mAnalysisControls.PlaybackControl.direction(mAnalysisData.PlaybackDirection);
        }
        mAnalysisControls.PlaybackControl.speed(mAnalysisData.PlaybackDivider);
        $('#uMapPlaybackSpeed').html('(' + mAnalysisData.PlaybackDivider + 'x)');
    }
}

function uAnalysisMapPlaybackFastForwardButton_OnClick() {
    "use strict";

    if (mAnalysisData.PlaybackStatus === 'Playing' || mAnalysisData.PlaybackStatus === 'Rewinding') {
        if (mAnalysisData.PlaybackDirection === 1) {
            switch (mAnalysisData.PlaybackDivider) {
                case 1:
                    mAnalysisData.PlaybackDivider = 2;
                    break;
                case 2:
                    mAnalysisData.PlaybackDivider = 4;
                    break;
                case 4:
                    mAnalysisData.PlaybackDivider = 8;
                    break;
                case 8:
                    mAnalysisData.PlaybackDivider = 1;
                    break;
            }
        } else {
            //mAnalysisData.PlaybackStatus = 'Playing';
            $('#uMapPlaybackStatus').html(mAnalysisData.PlaybackStatus);
            mAnalysisData.PlaybackDirection = 1;
            mAnalysisData.PlaybackDivider = 1;
            mAnalysisControls.PlaybackControl.direction(mAnalysisData.PlaybackDirection);
        }
        mAnalysisControls.PlaybackControl.speed(mAnalysisData.PlaybackDivider);
        $('#uMapPlaybackSpeed').html('(' + mAnalysisData.PlaybackDivider + 'x)');
    }
}

// slow down function for iteration 3? use in wherever slowdown is required
function uAnalysisMapPlaybackSlowDownButton_OnClick() {
    "use strict";

    if (mAnalysisData.PlaybackStatus === 'Playing' || mAnalysisData.PlaybackStatus === 'Rewinding') {
        if (mAnalysisData.PlaybackDirection === 1) {
            switch (mAnalysisData.PlaybackDivider) {
                case 1:
                    mAnalysisData.PlaybackDivider = 0;
                    break;
                case 2:
                    mAnalysisData.PlaybackDivider = 1;
                    break;
                case 4:
                    mAnalysisData.PlaybackDivider = 2;
                    break;
                case 8:
                    mAnalysisData.PlaybackDivider = 4;
                    break;
            }
        } else {
            //mEnrolleesData.PlaybackStatus = 'Playing';
            //$('#uMapPlaybackStatus').html(mEnrolleesData.PlaybackStatus);
            mAnalysisData.PlaybackDirection = 1;
            mAnalysisData.PlaybackDivider = 1;
            mAnalysisControls.PlaybackControl.direction(mAnalysisData.PlaybackDirection);
        }
        if (mAnalysisData.PlaybackDivider == 0) {
            uAnalysisMapPlaybackPauseButton_OnClick();
            mAnalysisData.PlaybackDivider = 1;
        }
        else {
            mAnalysisControls.PlaybackControl.speed(mAnalysisData.PlaybackDivider);
            $('#uMapPlaybackSpeed').html('(' + mAnalysisData.PlaybackDivider + 'x)');
        }
    }
}

function matchSlider_OnSlide(aMatch, aUi) {
    "use strict";
    $('#uSlider').slider('option', 'max', mAnalysisControls.PlaybackControl.getOverlayCount() - 1);
    if (mAnalysisData.PlaybackStatus === 'Stopped') {
        mAnalysisControls.PlaybackControl.pause();
    }
    mAnalysisControls.PlaybackControl.setIndex(aUi.value);
}

function updateAnalysisZoneLocation_OnRightClick(aClickData) {
    "use strict";
    if (aClickData && mStateManager.Settings()[0] == 'Incidents' && mStateManager.Settings()[1] == 'Details') {
        mAnalysisData.EditItem.CenterLatitude = aClickData.latLng.lat();
        mAnalysisData.EditItem.CenterLongitude = aClickData.latLng.lng();

        veritracks.mapping.setCenter(mAnalysisControls.Map, 'Spatial', mAnalysisData.EditItem.Id, aClickData.latLng);
    }
}

function analysisDistanceToolBar_OnClick() {
    "use strict";
    if (mAnalysisData.DistanceToolActive === false) {
        mAnalysisData.DistanceToolActive = true;
        $('.DistanceToolBarButton').addClass('Selected');
    } else {
        mAnalysisData.DistanceToolActive = false;
        $('.DistanceToolBarButton').removeClass('Selected');
        mAnalysisData.DistancePoints = [];
        mAnalysisControls.Map.layerSetDataSource('DistancePoints', veritracks.mapping.prepareDistanceMarkerData([]));
        mAnalysisControls.Map.layerSetDataSource('DistanceLabels', veritracks.mapping.prepareDistanceLabelOverlayData([]));
        mAnalysisControls.Map.layerSetDataSource('ConnectedDistancePoints', veritracks.mapping.prepareTripPointLineSegmentData([]));
    }
}

function analysisCalculateDistance_OnComplete(aDistance, aLatitude, aLongitude) {
    "use strict";
    mAnalysisControls.Map.layerSetDataSource('DistanceLabels', veritracks.mapping.prepareDistanceLabelOverlayData([{ 'latitude': aLatitude, 'longitude': aLongitude, 'text': aDistance }]));
    mAnalysisControls.Map.layerSetDataSource('ConnectedDistancePoints', veritracks.mapping.prepareTripPointLineSegmentData(mAnalysisData.DistancePoints));
}

function analysisCalculateDistance_OnClick(aClickData) {
    "use strict";
    var lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric'));

    if (lDoMetric) {
        analysisCalculateDistance(aClickData, new Unit().MEASURE.METRIC);
    } else {
        analysisCalculateDistance(aClickData);
    }
}
function analysisCalculateDistance(aClickData, aUnit) {
    "use strict";
    var lLatitude = aClickData.latLng.lat(),
        lLongitude = aClickData.latLng.lng(),
        lResult,
        lCard;
    if (mAnalysisData.DistanceToolActive === true) {
        if (!isNullOrUndefined(lLatitude) && !isNullOrUndefined(lLongitude)) {
            if (mAnalysisData.DistancePoints.length >= 2) {
                mAnalysisData.DistancePoints = [];
                mAnalysisControls.Map.layerSetDataSource('DistancePoints', veritracks.mapping.prepareDistanceMarkerData([]));
                mAnalysisControls.Map.layerSetDataSource('DistanceLabels', veritracks.mapping.prepareDistanceLabelOverlayData([]));
                mAnalysisControls.Map.layerSetDataSource('ConnectedDistancePoints', veritracks.mapping.prepareTripPointLineSegmentData([]));
            }
            lCard = new DistanceCard();
            lCard.latitude = lLatitude;
            lCard.longitude = lLongitude;
            if (isNullOrUndefined(mAnalysisData.DistancePoints)) {
                mAnalysisData.DistancePoints.push(lCard);
            } else {
                mAnalysisData.DistancePoints.push(lCard);
            }
            if (mAnalysisData.DistancePoints.length > 1) {
                if (isNullOrUndefined(aUnit)) {
                    lResult = veritracks.mapping.calculateDistances(mAnalysisData.DistancePoints[0].latitude, mAnalysisData.DistancePoints[0].longitude, mAnalysisData.DistancePoints[1].latitude, mAnalysisData.DistancePoints[1].longitude, 'events');
                } else {
                    if (aUnit.name == "Metric") {
                        lResult = veritracks.mapping.calculateDistancesMetric(mAnalysisData.DistancePoints[0].latitude, mAnalysisData.DistancePoints[0].longitude, mAnalysisData.DistancePoints[1].latitude, mAnalysisData.DistancePoints[1].longitude, 'events');
                    } else {
                        lResult = veritracks.mapping.calculateDistances(mAnalysisData.DistancePoints[0].latitude, mAnalysisData.DistancePoints[0].longitude, mAnalysisData.DistancePoints[1].latitude, mAnalysisData.DistancePoints[1].longitude, 'events');
                    }
                }
                analysisCalculateDistance_OnComplete(lResult.distanceDisplay, lResult.endPoint.latitude, lResult.endPoint.longitude);
            }
            mAnalysisControls.Map.layerSetDataSource('DistancePoints', veritracks.mapping.prepareDistanceMarkerData(mAnalysisData.DistancePoints));
        }
    }
}


analysisMapsExportData = function () {
    "use strict";
    var lDataSource = mAnalysisControls.MatchesCardView.getDataSource(),
        lWriter = new XMLWriter('UTF-8', '1.0'),
        lTrackpointList = mAnalysisData.SpatialMatches,
        lTimeZone,
        lHtmlBuilder = [],
        lDetail = '',
        lNewWindow,
        lDocument,
        lHtml,
        lItem,
        lIncident,
        lKey;

    if (mStateManager.getSystemState().Layout == "Incidents") {
        lIncident = mAnalysisData.SpatialMatchIncident
    } else {
        lIncident = mAnalysisControls.CardView.selectedDataItem().Data
    }

    function buildDescription(aDataItem, aTrackpoint, aCount) {
        lHtmlBuilder = [];
        lHtmlBuilder.push('<![CDATA[ <div>');
        if (aDataItem.Type !== 6) {
            lHtmlBuilder.push('<div><span style=\"font-weight:bold;\">Enrollee:</span> ');
            lHtmlBuilder.push(aDataItem.EnrolleeName);
            lHtmlBuilder.push('</div>');
        }
        lHtmlBuilder.push('<div><span style=\"font-weight:bold;\">Location:</span> ');

        lHtmlBuilder.push(aTrackpoint.Latitude.toString());
        lHtmlBuilder.push(', ');
        lHtmlBuilder.push(aTrackpoint.Longitude.toString());

        lHtmlBuilder.push('</div>');
        lHtmlBuilder.push('<div><span style=\"font-weight:bold;\">Start Date:</span> ');
        lHtmlBuilder.push(aDataItem.StartDateDisplay);
        lHtmlBuilder.push('</div>');
        lHtmlBuilder.push('<div><span style=\"font-weight:bold;\">End Date:</span> ');
        lHtmlBuilder.push(aDataItem.EndDateDisplay);
        lHtmlBuilder.push('</div>');
        //lHtmlBuilder.push('<div><span style=\"font-weight:bold;\">Trackpoint Count:</span> ');
        //lHtmlBuilder.push('Count ' + aCount + ' of ' + aDataItem.TrackpointCount);
        //lHtmlBuilder.push('</div>');
        lHtmlBuilder.push('</div>]]>');
        return lHtmlBuilder.join('');
    }

    lWriter.writeStartDocument();

    lWriter.writeStartElement('kml');
    lWriter.writeAttributeString('xmlns', 'http://earth.google.com/kml/2.2');

    lWriter.writeStartElement('Document');

    // google specific styling
    lWriter.writeStartElement('Style');
    lWriter.writeAttributeString('id', 'oIcon');

    lWriter.writeStartElement('IconStyle');

    lWriter.writeStartElement('scale');
    lWriter.writeString('1.1');
    lWriter.writeEndElement();

    lWriter.writeStartElement('Icon');
    lWriter.writeStartElement('href');
    lWriter.writeString('/Resources/Images/Mapping/orange.png');
    lWriter.writeEndElement();
    lWriter.writeEndElement();

    lWriter.writeEndElement();

    lWriter.writeEndElement();


    var lBuilder = new SumoPredicateBuilder();

    for (lKey in lDataSource) {
        if (lDataSource.hasOwnProperty(lKey)) {
            lItem = lDataSource[lKey];
            lTimeZone = getEnrolleeTimeZone(lItem.EnrolleeId, lIncident.TimeZoneId);
            lWriter.writeStartElement('Folder');
            lWriter.writeStartElement('name');
            lWriter.writeString('Spatial Results for: ' + lItem.EnrolleeName);
            lWriter.writeEndElement();
            lWriter.writeStartElement('styleUrl');
            lWriter.writeString('#oIcon');
            lWriter.writeEndElement();

            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional('GroupId', lItem.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lTrackpointList = query(mAnalysisData.SpatialMatches, lBuilder.RootExpression);
            var lPoint;
            var lCount = 0;
            for (var lKeyB in lTrackpointList) {
                if (lTrackpointList.hasOwnProperty(lKeyB)) {
                    lPoint = lTrackpointList[lKeyB];
                    lWriter.writeStartElement('Placemark');
                    lWriter.writeStartElement('name');
                    lWriter.writeString('Track Date: ' + DisplayShortDateTime(displayFixedTimeZoneTime(lPoint.TrackDateUTC, lTimeZone.TimeZoneName)));
                    lWriter.writeEndElement();
                    lWriter.writeStartElement('description');
                    lWriter.writeString(buildDescription(lItem, lPoint, lCount++));
                    lWriter.writeEndElement();
                    lWriter.writeStartElement('Point');
                    lWriter.writeStartElement('coordinates');
                    lWriter.writeString(lPoint.Longitude + ',' + lPoint.Latitude + ',0');
                    lWriter.writeEndElement();
                    lWriter.writeEndElement();

                    lWriter.writeEndElement();

                }
            }
            lWriter.writeEndElement();
        }
    }

    lWriter.writeEndElement();

    lWriter.writeEndElement();

    lWriter.writeEndDocument();

    lWriter.formatting = 'none';
    lHtml = lWriter.flush();
    veritracks.mapping.data.ExportData = veritracks.system.encodeHtml(lHtml);
    downloadKMLFile(lHtml);
};

//Analysis Instant reporting
function analysisInstantReporting_OnClick(aReportType) {
    "use strict";
    var lIncident = mAnalysisControls.CardView.selectedDataItem(),
        lAgentId,
        lOrganizationId = 0,
        lEnrolleesFilter = 0,
        lRiskLevel = 0;


    if (!isNullOrUndefined(lIncident)) {
        lAgentId = getMyAgentIdsByOrganization(gUserDetails.UserId, [lIncident.OrganizationId])[0];

        if (aReportType == 0) {
            if (!isNullOrUndefined(mAnalysisControls.MatchesCardViewFilter)) {
                lOrganizationId = mAnalysisControls.MatchesCardViewFilter.columnValue('OrganizationId');
                if (lOrganizationId == '') {
                    lOrganizationId = 0;
                } else {
                    lOrganizationId = parseInt(lOrganizationId);
                }
            }

            if (!isNullOrUndefined(mAnalysisControls.MatchesCardView) && !isNullOrUndefined(mAnalysisControls.MatchesCardViewFilter)) {

                lEnrolleesFilter = mAnalysisControls.MatchesCardViewFilter.columnValue('EnrolleeName');
                lRiskLevel = mAnalysisControls.MatchesCardViewFilter.columnValue('RiskLevel');
            }
            CreateAnalysisResultInstantReport(lIncident.Id, lAgentId, lOrganizationId, lEnrolleesFilter, lRiskLevel);
        } else {
            //for other instant report in analysis tile
        }

    }
}

function analysisOffenderMGAPToggle_OnClick() {
    "use strict";
    var lIncident = mAnalysisData.SpatialMatchIncident;
    var lPermission = CheckUserHasPermission(45) ? 1 : 0;

    if (mAnalysisControls.CardView) {
        lIncident = mAnalysisControls.CardView.selectedDataItem().Data;
    }
    if ($('#uAddressSpatialEnrolleeMatch').hasClass('Selected')) {
        mAnalysisData.MGAPToggle = false;
        $('#uAddressSpatialEnrolleeMatch').removeClass('Selected');
        mAnalysisControls.Map.layerHide('EnrolleeMGAP');
        mAnalysisControls.Map.layerHide('EnrolleeMGAPLabels');
        mAnalysisControls.Map.layerHide('Address');
        mAnalysisControls.Map.layerHide('AddressLabels');
        uIncidentsMatchesCardViewFilter_OnFilter();
    } else {
        mAnalysisData.MGAPToggle = true;
        $('#uAnalysisMatchesLoadingBar').show('fast');
        $('#uAddressSpatialEnrolleeMatch').addClass('Selected');
        if (!mAnalysisData.EnrolleeMGAPCards) {
            mActivityNotification.addNotification(localizeText('cEnrolleeLoading') + '.....');
            veritracks.mapping.spatialEnrolleesInMGAP(lIncident.Radius,
                lIncident.Latitude,
                lIncident.Longitude,
                convertTimeToUTC(moment(lIncident.StartDateUTC).toDate()),
                convertTimeToUTC(moment(lIncident.EndDateUTC).toDate()),
                gUserDetails.OrganizationIds.join(','),
                lPermission,
                AnalysisOffenderMGAP_OnComplete);
        }
        else {
            if (mAnalysisData.EnrolleeMGAPCards.length == 0) {
                mActivityNotification.addNotification(localizeText('cAnalysisNoOffendersFoundSpatial'));
            }
            $('#uAnalysisMatchesLoadingBar').hide('fast');
            mAnalysisControls.Map.layerShow('EnrolleeMGAP');
            mAnalysisControls.Map.layerShow('EnrolleeMGAPLabels');
            uIncidentsMatchesCardViewFilter_OnFilter();
        }
    }
}

function AnalysisOffenderMGAP_OnComplete(aParams, aData) {
    "use strict";
    generateOffenderMGAPMapCards(aData);
    $('#uAnalysisMatchesLoadingBar').hide('fast');
    uIncidentsMatchesCardViewFilter_OnFilter();
}

function generateOffenderMGAPMapCards(aData) {
    "use strict";
    var lMapCards = [];
    var lMapItems = [];
    var lMapLabels = [];
    var lKey = [];
    var lCard = new AnalysisMatchesCardView();
    var lTrackItem;
    var lEnrolleeMGAPS = aData;


    if (lEnrolleeMGAPS.length == 0) {
        mActivityNotification.addNotification(localizeText('cAnalysisNoOffendersFoundSpatial'));
    }

    for (lKey in lEnrolleeMGAPS) {
        if (lEnrolleeMGAPS.hasOwnProperty(lKey)) {
            var lEnrollee = GetEnrollee(lEnrolleeMGAPS[lKey].EnrolleeId);
            if (lEnrollee) {
                var lAgent = getDataItem(lEnrollee.AgentId, 'Agents');
                if (!lAgent) {
                    lAgent = getDataItem(lEnrollee.AgentId, 'AgentsStop');
                }
                var lIconUrl = mMappingEventIcons[lEnrolleeMGAPS[lKey].MetaEventId];
                lCard = new AnalysisMatchesCardView();
                lCard.Id = 'M'+ lEnrollee.Id + lKey;
                lCard.DisplayName = formatterMetaEvent(lEnrolleeMGAPS[lKey].MetaEventId);
                lCard.EnrolleeId = lEnrollee.Id;
                lCard.EnrolleeName = lEnrollee.FullName;
                lCard.PrimaryId = lEnrollee.PrimaryId;
                if (lAgent) {
                    lCard.Agent = lAgent.FullName;
                    lCard.AgentPrimaryEmail = lAgent.PrimaryEmail;
                    lCard.AgentId = lAgent.Id;
                } else {
                    lCard.AgentId = lEnrollee.AgentId;
                }
                lCard.IconClass = 'Track' + lIconUrl.regular;
                lCard.Type = 2;
                lCard.TrackCountDisplayView = 'none';
                lCard.StartDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lEnrolleeMGAPS[lKey].StartDateUTC, lEnrollee));
                lCard.EndDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lEnrolleeMGAPS[lKey].StopDateUTC, lEnrollee));
                lCard.TrackDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lEnrolleeMGAPS[lKey].TrackDateUTC, lEnrollee));
                if (moment(lCard.StartDateDisplay) > moment(lCard.EndDateDisplay)) {
                    lCard.EndDateDisplay = localizeText('cEventInProgress');
                }
                lCard.Detail = localizeText('cEnrolleesMappingStart') + ' ' + lCard.StartDateDisplay;
                lCard.Detail2 = localizeText('cEnrolleesMappingEnd') + ' ' + lCard.EndDateDisplay;
                lCard.Detail3 = localizeText('cAnalysisTrackDate') + ' ' + lCard.TrackDateDisplay;

                var lDataHolder = $.extend({}, lEnrolleeMGAPS[lKey]);

                lDataHolder.MatchCardId = lCard.Id;
                lTrackItem = veritracks.mapping.prepareTrackpointMarkerItem_dep({ Data: lDataHolder, Latitude: lEnrolleeMGAPS[lKey].Latitude, Longitude: lEnrolleeMGAPS[lKey].Longitude, Name: lEnrollee.FullName, TrackTypeId: 14 });
                lTrackItem.iconUri = 'Images/Maps/trackpoints/' + lIconUrl.light + '.png';
                lTrackItem.Id = lCard.Id;
                lCard.TrackItem = lTrackItem;
                lMapLabels.push(lTrackItem.data);
                lMapItems.push(lTrackItem);
                lMapCards.push(lCard);
            }
        }
    }
    mAnalysisControls.Map.layerSetDataSource('EnrolleeMGAP', lMapItems);
    mAnalysisControls.Map.layerSetDataSource('EnrolleeMGAPLabels', veritracks.mapping.prepareSuggestionLabelOverlayData(lMapLabels, null, { VerticalOffset: -10, HorizontalOffset: -10 }));
    mAnalysisControls.Map.layerShow('EnrolleeMGAP');
    mAnalysisControls.Map.layerShow('EnrolleeMGAPLabels');
    mAnalysisData.EnrolleeMGAPCards = lMapCards;
}


function generateSpatialAddressMapCards(aAddresses) {
    "use strict";
    var lMapCards = [];
    var lMapItems = [];
    var lMapLabels = [];
    var lKey = [];
    var lCard = new AnalysisMatchesCardView();
    var lTrackItem;

    if (aAddresses.length == 0) {
        mActivityNotification.addNotification(localizeText('cAnalysisNoAddressesFound'));
    }
    for (lKey in aAddresses) {
        if (aAddresses.hasOwnProperty(lKey)) {
            var lEnrollee = GetEnrollee(aAddresses[lKey].EnrolleeId);

            if (lEnrollee) {
                var lAgent = getDataItem(lEnrollee.AgentId, 'Agents');

                if (!lAgent) {
                    lAgent = getDataItem(lEnrollee.AgentId, 'AgentsStop');
                }

                lCard = new AnalysisMatchesCardView();
                lCard.Id = aAddresses[lKey].Id;
                lCard.DisplayName = aAddresses[lKey].Title
                lCard.EnrolleeId = lEnrollee.Id;
                lCard.EnrolleeName = lEnrollee.FullName;
                lCard.PrimaryId = lEnrollee.PrimaryId;

                if (lAgent) {
                    lCard.Agent = lAgent.FullName;
                    lCard.AgentPrimaryEmail = lAgent.PrimaryEmail;
                    lCard.AgentId = lAgent.Id;
                } else {
                    lCard.AgentId = lEnrollee.AgentId;
                }

                lCard.IconClass = 'Track' + veritracks.mapping.prepareAddressItem(aAddresses[lKey], 1).cardViewClass;
                lCard.Type = 2;
                lCard.TrackCountDisplayView = 'none';
                lCard.Detail = addressFormatter(aAddresses[lKey]);

                lTrackItem = veritracks.mapping.prepareTrackpointMarkerItem_dep({ Data: aAddresses[lKey], Latitude: aAddresses[lKey].Latitude, Longitude: aAddresses[lKey].Longitude, Name: lEnrollee.FullName + ' - ' + aAddresses[lKey].Title, TrackTypeId: getTrackTypeIdMappingId(aAddresses[lKey].AddressTypeId) });
                lCard.TrackItem = lTrackItem;

                lMapLabels.push(lTrackItem.data);
                lMapItems.push(lTrackItem);
                lMapCards.push(lCard);
            }
        }
    }
    mAnalysisControls.Map.layerSetDataSource('Address', lMapItems);
    mAnalysisControls.Map.layerSetDataSource('AddressLabels',
        veritracks.mapping.prepareSuggestionLabelOverlayData(lMapLabels, null, { VerticalOffset: -10, HorizontalOffset: -10 }));
    mAnalysisControls.Map.layerShow('Address');
    mAnalysisControls.Map.layerShow('AddressLabels');
    mAnalysisData.AddressCards = lMapCards;
}

function spatialEnrolleeMGAPMarkerClick(aSender, aMouseEvent) {
    "use strict";
    var lPoint = aSender.sumoData;

    if (lPoint.Data) {
        mAnalysisControls.MatchesCardView.selected(lPoint.Data.MatchCardId);
        veritracks.enrollees.mapping.zoomOut(mAnalysisControls.Map.getMap(), 2);
    }
}


function analysisAddressToggle_OnClick() {
    "use strict";
    var lIncident = mAnalysisData.SpatialMatchIncident;
    var lPermission = CheckUserHasPermission(45) ? 1 : 0;

    if (mAnalysisControls.CardView) {
        lIncident = mAnalysisControls.CardView.selectedDataItem().Data;
    }
    if ($('#uAddressSpatial').hasClass('Selected')) {
        mAnalysisData.AddressesToggle = false;
        $('#uAddressSpatial').removeClass('Selected');
        mAnalysisControls.Map.layerHide('Address');
        mAnalysisControls.Map.layerHide('AddressLabels');
        uIncidentsMatchesCardViewFilter_OnFilter();
    } else {
        mAnalysisData.AddressesToggle = true;
        $('#uAnalysisMatchesLoadingBar').show('fast');
        $('#uAddressSpatial').addClass('Selected');
        if (!mAnalysisData.AddressCards) {
            mActivityNotification.addNotification(localizeText('cEnrolleeLoading') + '.....');
            veritracks.mapping.spatialAddresses(lIncident.Radius, lIncident.Latitude, lIncident.Longitude, gUserDetails.OrganizationIds.join(','), lPermission, AnalysisOffenderAddress_OnComplete);

        } else {
            if (mAnalysisData.AddressCards.length == 0) {
                mActivityNotification.addNotification(localizeText('cAnalysisNoAddressesFound'));
            }
            $('#uAnalysisMatchesLoadingBar').hide('fast');
            mAnalysisControls.Map.layerShow('Address');
            mAnalysisControls.Map.layerShow('AddressLabels');
            uIncidentsMatchesCardViewFilter_OnFilter();
        }
    }
}

function getTrackTypeIdMappingId(Id){
    "use strict"
    switch (Id){
        case 1:
            return 15;
        case 2:
            return 16;
        case 3:
            return 17;
    }
}

function AnalysisOffenderAddress_OnComplete(aParams, aData) {
    "use strict";

    generateSpatialAddressMapCards(aData);
    $('#uAnalysisMatchesLoadingBar').hide('fast');
    uIncidentsMatchesCardViewFilter_OnFilter();
}

function spatialAddressMarkerClick(aSender, aMouseEvent){
    "use strict";
    var lPoint = aSender.sumoData;

    if (lPoint.Data) {
        mAnalysisControls.MatchesCardView.selected(lPoint.Data.Id);
        veritracks.enrollees.mapping.zoomOut(mAnalysisControls.Map.getMap(), 2);
    }
}

function analysisSpatialDetailsFormat() {
    "use strict";
    var lGeocodeString = '';
    if (mAnalysisData.SpatialMatchIncident) {
        lGeocodeString = mAnalysisData.SpatialMatchIncident.Latitude.toString() + ', ' + mAnalysisData.SpatialMatchIncident.Longitude.toString();
        mAnalysisControls.Map.geocode(lGeocodeString, spatialDetails_OnGeocode, null);
    }
}

function convertLocalThenTimeZone(aDate, aTimeZone) {
    "use strict";
    var lDate = aDate;

    if(aTimeZone){
        lDate = displayEnrolleeTimeZone(lDate, aTimeZone);
    }

    return lDate;
}

function spatialDetails_OnGeocode(aResult, aStatus, aParams) {
    "use strict";
    var lResult;
    var lAddressSearch;
    var lHtml = [];

    if (aStatus === 'OK' && aResult) {
        lResult = Array.isArray(aResult)?aResult[0]:aResult;

        lAddressSearch = new Address(lResult);
        var lTimeZone = getTimezone(mAnalysisData.SpatialMatchIncident.TimeZoneId);
        lHtml.push(lAddressSearch.Description + '. ');
        lHtml.push(localizeText('cAnalysisStart') + ': ' + convertLocalThenTimeZone(mAnalysisData.SpatialMatchIncident.StartDateUTC, lTimeZone));
        lHtml.push(' - ');
        lHtml.push(localizeText('cAnalysisEnd') + ': ' + convertLocalThenTimeZone(mAnalysisData.SpatialMatchIncident.EndDateUTC, lTimeZone));
        lHtml.push('  ');
        lHtml.push(localizeText('cEnrolleeTimeZone') + ': ' + lTimeZone.Name);

        mAnalysisData.SpatialMatchIncident.Street1 = lAddressSearch.Street1;
        mAnalysisData.SpatialMatchIncident.StreetAddressNumber = lAddressSearch.StreetNumber;
        mAnalysisData.SpatialMatchIncident.Country = lAddressSearch.Country;
        mAnalysisData.SpatialMatchIncident.City = lAddressSearch.City;
        mAnalysisData.SpatialMatchIncident.Zipcode = lAddressSearch.ZipCode;

        $('#uAnalysisSpatialDetails').html(lHtml.join(''));
    }

}

function uRerunIncidentButton_OnClick() {
    "use strict";
    var lCard = mAnalysisControls.CardView.selectedDataItem();
    var lRadius;
    if (lCard) {
        mAnalysisData.SpatialMatchIncident = $.extend({}, lCard.Data);
        mAnalysisData.EditShape = null;
        mAnalysisData.RequestId = gRequestManager.getRequestId();
        lRadius = (mAnalysisData.SpatialMatchIncident.Radius != 0 ? mAnalysisData.SpatialMatchIncident.Radius : mAnalysisData.SpatialRadius);
        lRadius = sumo.geo.conversion.feetToMeters(lRadius);
        lRadius = sumo.geo.conversion.metersToNauticalMiles(lRadius);
        var lStart = getMoment(mAnalysisData.SpatialMatchIncident.StartDateUTC);
        var lEnd = getMoment(mAnalysisData.SpatialMatchIncident.EndDateUTC);
        var lTimeZone = getDataItem(lCard.Data.TimeZoneId, 'TimeZone');
        veritracks.mapping.getTrackpoints(lRadius, mAnalysisData.SpatialMatchIncident.Latitude, mAnalysisData.SpatialMatchIncident.Longitude, lStart, lEnd, uSearchSpatial_OnSuccess, uSearchSpatial_OnFailure, { "RequestId": mAnalysisData.RequestId, "aStart": lStart, "aEnd": lEnd, "TimeZoneName": lTimeZone.Name });
        mActivityNotification.addNotification(localizeWrapper('cAnalysisRerunSpatial'));
    }
}

function getIncidentMatchTrackpoints(aCallback, aIdList) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    lBuilder.AddNewExpressionConditional('IncidentMatchId', aIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.IncidentMatchTrackpoint.AssemblyQualifiedName, lBuilder.RootExpression, 0, aCallback, Sad, null, null, 0);

}

function getIncidentMatchTrackpointsProcedure(aCallback, aIdList) {
    var lIncidentCard = mAnalysisControls.CardView.selectedDataItem();
    var lKey;

    mAnalysisData.Tracks = [];

    for (lKey = 0; lKey <= aIdList.length - 1; lKey++) {
        var lMatchCard = mAnalysisControls.MatchesCardView.selectedDataItemById(aIdList[lKey]);
        var lEnrollee = GetEnrollee(lMatchCard.Data.EnrolleeId);
        var lStartDate = FixSentDate(moment(lMatchCard.StartDateDisplay)._d, lEnrollee);
        var lEndDate = FixSentDate(moment(lMatchCard.EndDateDisplay)._d, lEnrollee);
        var lRadius = (lIncidentCard.Data.Radius != 0 ? lIncidentCard.Data.Radius : mAnalysisData.SpatialRadius);

        veritracks.data.controller.readEnrolleeIncidentTrackpoints(lIncidentCard.Data.Latitude,
            lIncidentCard.Data.Longitude,
            lRadius,
            lStartDate,
            lEndDate,
            lMatchCard.Data.EnrolleeId,
            lIncidentCard.Data.Id,
            lMatchCard.Data.Id,
            initializeStoreIncidentTrackpoints,
            Sad,
            {
                'Number': lKey,
                'Count': aIdList.length - 1,
                'Callback': aCallback
            });
    }
}

function initializeStoreIncidentTrackpoints(aParams, aData) {
    "use strict";
    var lKey;

    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            mAnalysisData.Tracks.push(aData[lKey]);
        }
    }

    if (aParams.Number == aParams.Count) {
        aParams.Callback(null, mAnalysisData.Tracks);
    }
}

function spatialPrintMaps_OnClick() {
    "use strict";
    var lMatchCards = mAnalysisControls.MatchesCardView.getDataSource();
    var lCards = [];
    var lKey;

    for (lKey in lMatchCards) {
        if (lMatchCards.hasOwnProperty(lKey)) {
            if (lMatchCards[lKey].Data) {
                lCards.push(lMatchCards[lKey]);
            }
        }
    }

    var lIdList = getArrayByIds(lCards);

    getIncidentMatchTrackpointsProcedure(spatialPrintMap_OnSuccess, lIdList);
}

function spatialPrintMap_OnSuccess(aParams, aData) {
    "use strict";
    var lKey,
        lSpatialMatchesList = [],
        lDevices,
        lDevice,
        lPastDeviceId = 0,
        lSort = new SortExpression(),
        lBuilder = new SumoPredicateBuilder(),
        lMatchCards = mAnalysisControls.MatchesCardView.getDataSource(),
        lEnrolleeCard,
        lMatchesCardList = [];

    lSort.addAscendingColumn('TrackDate');

    aData = lSort.sort(aData);
    if (ObjectLength(aData) > 0) {
        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lDevice = GetDevice(aData[lKey].DeviceId);
                var lSpatialTrack = generateAnalysisSpatialMatchesTrack(aData[lKey], lDevice);
                lSpatialTrack.GroupId = aData[lKey].IncidentMatchId;
                lSpatialTrack.EnrolleeId = aData[lKey].EnrolleeId;
                lSpatialMatchesList.push(lSpatialTrack);

            }
        }

        mAnalysisData.SpatialMatches = lSpatialMatchesList;
        window.open('Spatial.Map.Print.htm');
    }
}

function spatialKMLMaps_OnClick() {
    "use strict";
    var lMatchCards = mAnalysisControls.MatchesCardView.getDataSource();
    var lCards = [];
    var lKey;

    for (lKey in lMatchCards) {
        if (lMatchCards.hasOwnProperty(lKey)) {
            if (lMatchCards[lKey].Data) {
                lCards.push(lMatchCards[lKey]);
            }
        }
    }

    var lIdList = getArrayByIds(lCards);

    getIncidentMatchTrackpointsProcedure(spatialKMLMap_OnSuccess, lIdList);
}

function spatialKMLMap_OnSuccess(aParams, aData) {
    "use strict";
    var lKey,
        lSpatialMatchesList = [],
        lDevices,
        lDevice,
        lPastDeviceId = 0,
        lSort = new SortExpression(),
        lBuilder = new SumoPredicateBuilder(),
        lMatchCards = mAnalysisControls.MatchesCardView.getDataSource(),
        lEnrolleeCard,
        lMatchesCardList = [];

    lSort.addAscendingColumn('TrackDate');

    aData = lSort.sort(aData);
    if (ObjectLength(aData) > 0) {
        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lDevice = GetDevice(aData[lKey].DeviceId);
                var lSpatialTrack = generateAnalysisSpatialMatchesTrack(aData[lKey], lDevice);
                lSpatialTrack.GroupId = aData[lKey].IncidentMatchId;
                lSpatialTrack.EnrolleeId = aData[lKey].EnrolleeId;
                lSpatialMatchesList.push(lSpatialTrack);

            }
        }

        mAnalysisData.SpatialMatches = lSpatialMatchesList;

        analysisMapsExportData();
    }
}

function spatialExcelMaps_OnClick() {
    "use strict";
    var lMatchCards = mAnalysisControls.MatchesCardView.getDataSource();

    var lHolder = spatialPrepareforConvert(lMatchCards);

    exportExcelMap(lMatchCards);

}

function exportExcelMap(aMatchCards) {
    "use strict";
    var lMatchCards = aMatchCards;

    var lHolder = spatialPrepareforConvert(lMatchCards);
    veritracks.mapping.data.ExcelExportData = lHolder;
    window.open('Interface/Excel.Export.html');
}

function spatialPrepareforConvert(aMatchCards) {
    "use strict";
    var lData = aMatchCards;
    var lProp;
    var lValue;
    var lHolder = [];
    var lEnrollee, lFirstName, lLastName;
    var JSON = lData.map(function (obj) {
        var lTheObj = {};
        for (lProp in obj) {
            if (isInSpatialCSVTitle(lProp)) {
                if (lProp == 'EnrolleeId') {
                    if (obj[lProp] != -1) {
                        lEnrollee = GetEnrollee(obj[lProp]);
                        lFirstName = lEnrollee.FirstName;
                        lLastName = lEnrollee.LastName;

                        lTheObj['EnrolleeLastName'] = lLastName;
                        lTheObj['EnrolleeFirstName'] = lFirstName;
                    }
                    else {
                        lTheObj['EnrolleeLastName'] = 'unknown';
                        lTheObj['EnrolleeFirstName'] = 'unknown';
                    }
                }
                else {
                    lValue = obj[lProp];
                    lTheObj[lProp] = lValue;
                }
            }
        }
        lHolder.push(lTheObj);
    });
    return { 'EnrolleeMatchComps': lHolder };

}

function isInSpatialCSVTitle(prop) {
    "use strict";
    var lCompare = ['Distance', 'EndDateDisplay', 'StartDateDisplay', 'TrackpointCount','EnrolleeId'];
    var lName = prop;
    var lFind = lCompare.indexOf(lName);

    if (lFind != -1) {
        return true;
    }

    return false;
}

function analysisIncidentPrintInit(aZone) {
    var allowed = "veritracks.com";
    if (document.domain.indexOf(allowed) !== -1) {
        document.domain = allowed;
    }
    var lDisplayType = 'roadmap',
        lZone = aZone,
        lPrintMap;

    var lLabel = {
        'Latitude': aZone.CenterLatitude + sumo.geo.conversion.feetToDegreeLatitude(aZone.Radius),
        'Longitude': aZone.CenterLongitude,
        'Name': RoundNumber(aZone.Radius, 2) + ' ft'
    };

    lZone.Type = 3; // view only

    mPrintControls.PrintMap = new sumo.maps.GoogleMapControl('uPrintMap', 'uIncidentDetailMap', { 'displayType': lDisplayType, 'OnClick': null });
    lPrintMap = mPrintControls.PrintMap;

    lPrintMap.layerAdd('Spatial', {
        'renderType': 'geometry',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1000000
    });

    // added radius to show user the total diameter of there circle
    lPrintMap.layerAdd('SpatialRadius', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 2000000,
    });

    lPrintMap.layerSetDataSource('Spatial', veritracks.mapping.prepareZoneData([lZone]));
    lPrintMap.layerSetDataSource('SpatialRadius', veritracks.mapping.prepareSuggestionLabelOverlayData([lLabel]));
    lPrintMap.fitBounds();
}

function analysisIncidentEnrolleeMGAPPrintInit(aDataSource, aZone) {
    var lDisplayType = 'roadmap',
        lZone = aZone,
        lPrintMap;

    var lLabel = {
        'Latitude': aZone.CenterLatitude + sumo.geo.conversion.feetToDegreeLatitude(aZone.Radius),
        'Longitude': aZone.CenterLongitude,
        'Name': RoundNumber(aZone.Radius, 2) + ' ft'
    };

    lZone.Type = 3; // view only

    mPrintControls.SecondPrintMap = new sumo.maps.GoogleMapControl('uPrintEnrolleeMGAPMap', 'uIncidentEnrolleeMGAPMap', { 'displayType': lDisplayType, 'OnClick': null });
    lPrintMap = mPrintControls.SecondPrintMap;

    lPrintMap.layerAdd('Spatial', {
        'renderType': 'geometry',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1000000
    });

    // added radius to show user the total diameter of there circle
    lPrintMap.layerAdd('SpatialRadius', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 2000000,
    });

    lPrintMap.layerAdd('EnrolleeMGAP', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 160000
    });

    lPrintMap.layerAdd('EnrolleeMGAPLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 160000
    });

    var lEnrolleeMGAP = [];
    var lMapLabels = [];
    for (lKey in aDataSource) {
        if (aDataSource.hasOwnProperty(lKey)) {
            lEnrolleeMGAP.push(aDataSource[lKey].TrackItem);
            lMapLabels.push(aDataSource[lKey].TrackItem.data);
        }
    }

    lPrintMap.layerSetDataSource('EnrolleeMGAP', lEnrolleeMGAP);
    lPrintMap.layerSetDataSource('EnrolleeMGAPLabels', veritracks.mapping.prepareSuggestionLabelOverlayData(lMapLabels, null, { VerticalOffset: -10, HorizontalOffset: -10 }));
    lPrintMap.layerSetDataSource('Spatial', veritracks.mapping.prepareZoneData([lZone]));
    lPrintMap.layerSetDataSource('SpatialRadius', veritracks.mapping.prepareSuggestionLabelOverlayData([lLabel]));
    lPrintMap.fitBounds();
}

function analysisIncidentAddressesPrintInit(aDataSource, aZone) {
    var lDisplayType = 'roadmap',
        lZone = aZone,
        lPrintMap;

    var lLabel = {
        'Latitude': aZone.CenterLatitude + sumo.geo.conversion.feetToDegreeLatitude(aZone.Radius),
        'Longitude': aZone.CenterLongitude,
        'Name': RoundNumber(aZone.Radius, 2) + ' ft'
    };

    lZone.Type = 3; // view only

    mPrintControls.PrintMap = new sumo.maps.GoogleMapControl('uPrintAddressMap', 'uIncidentAddressMap', { 'displayType': lDisplayType, 'OnClick': null });
    lPrintMap = mPrintControls.PrintMap;

    lPrintMap.layerAdd('Spatial', {
        'renderType': 'geometry',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1000000
    });

    // added radius to show user the total diameter of there circle
    lPrintMap.layerAdd('SpatialRadius', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 2000000,
    });


    lPrintMap.layerAdd('Address', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 160000
    });

    lPrintMap.layerAdd('AddressLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 160000
    });

    var lAddresses = [];
    var lMapLabels = [];
    for (lKey in aDataSource) {
        if (aDataSource.hasOwnProperty(lKey)) {
            lAddresses.push(aDataSource[lKey].TrackItem);
            lMapLabels.push(aDataSource[lKey].TrackItem.data);
        }
    }

    lPrintMap.layerSetDataSource('Address', lAddresses);
    lPrintMap.layerSetDataSource('AddressLabels', veritracks.mapping.prepareSuggestionLabelOverlayData(lMapLabels, null, { VerticalOffset: -10, HorizontalOffset: -10 }));
    lPrintMap.layerSetDataSource('Spatial', veritracks.mapping.prepareZoneData([lZone]));
    lPrintMap.layerSetDataSource('SpatialRadius', veritracks.mapping.prepareSuggestionLabelOverlayData([lLabel]));
    lPrintMap.fitBounds();
}

function analysisPrintInit(aZone, aDataSource, aEnrollee, aLabels, aKey) {
    var lDisplayType = 'roadmap',
        lKey,
        lCard,
        lZone = aZone,
        lVisitList = [],
        lZoneNameList = [],
        lPrintMap,
        lBuilder = new SumoPredicateBuilder();
    var lId = aEnrollee.Id + '' + aKey;
    var lLabel = {
        'Latitude': aZone.CenterLatitude + sumo.geo.conversion.feetToDegreeLatitude(aZone.Radius),
        'Longitude': aZone.CenterLongitude,
        'Name': RoundNumber(aZone.Radius, 2) + ' ft'
    };

    lZone.Type = 3; // view only

    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrollee.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    var lDataSource = query(aDataSource, lBuilder.RootExpression);
    mPrintControls.ArrayPrintMap[aEnrollee.Id] = new sumo.maps.GoogleMapControl('uPrintMap' + lId, 'uMapPanel' + lId, { 'displayType': lDisplayType, 'OnClick': null });
    lPrintMap = mPrintControls.ArrayPrintMap[aEnrollee.Id];
    var lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': true,
        'isVisible': true,
        'clickEventHandler': veritracks.mapping.enrolleeMarkerClick,
        'zIndexStart': 90000
    };

    lPrintMap.layerAdd('TrackPoints', lLayerOptions);

    lPrintMap.layerAdd('Spatial', {
        'renderType': 'geometry',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1000000
    });

    // added radius to show user the total diameter of there circle
    lPrintMap.layerAdd('SpatialRadius', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 2000000,
    });

    lLayerOptions = {
        'renderType': 'label',
        'doesPlayback': true,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 85000
    };
    lPrintMap.layerAdd('Labels', lLayerOptions);

    var lCount = 1;
    var lLabelList = [];
    //var lSort = new SortExpression();
    //lSort.addAscendingColumn('TrackDate');
    //lDataSource = lSort.sort(lDataSource);
    for (lKey in lDataSource) {
        if (lDataSource.hasOwnProperty(lKey)) {
            lCard = lDataSource[lKey];
            if (!isNullOrUndefined(lCard)) {
                lVisitList.push(veritracks.mapping.prepareTrackpointMarkerItem_dep({ 'Latitude': lCard.Latitude, 'Longitude': lCard.Longitude, 'TrackTypeId': 1 }));
                lCard.DisplayName = '(T' + lCount++ +')';
                lLabelList.push(lCard);
            }
        }
    }
    lPrintMap.layerSetDataSource('TrackPoints', lVisitList);
    lPrintMap.layerSetDataSource('Spatial', veritracks.mapping.prepareZoneData([lZone]));
    lPrintMap.layerSetDataSource('SpatialRadius', veritracks.mapping.prepareSuggestionLabelOverlayData([lLabel]));
    if (aLabels)
        lPrintMap.layerSetDataSource('Labels', veritracks.mapping.prepareTrackpointDetailCardLabelOverlayData(lLabelList));
    lPrintMap.fitBounds();
}

function analysisLabelCountToggle_OnClick() {
    "use strict";
    if (!$('#uAnalysisLabelToggle').hasClass('Selected')) {
        mAnalysisData.LabelCountToggle = true;
        $('#uAnalysisLabelToggle').addClass('Selected');
        mAnalysisControls.Map.layerShow('Labels');
    } else {
        mAnalysisData.LabelCountToggle = false;
        $('#uAnalysisLabelToggle').removeClass('Selected');
        mAnalysisControls.Map.layerHide('Labels');
    }
}

function oldSpatialIncidentPopup() {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uSaveIncidentButton_OnClick()'));
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'ClosePopup()'));

    DisplayPopup("Incident Create", "<div id='uCreateIncidentPanel'></div>", lButtonBar, false, false);
    populateElement('uCreateIncidentPanel', 'Analysis.Incidents.Popup.htm', function () {
        uAddIncidentButton();
    });
}

function generateOffenderIncidentPhotoPopup() {
    "use strict";

    var html = [],
        lPhotoTypes = getDataItems("OffenderPhotoType"),
        lPhotoTypeText = '',
        aOffender = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex];

    if (mEnrolleesData.OffenderPhotos.length == 0) {
        return;
    }
    for (var lKey in lPhotoTypes) {
        if (lPhotoTypes.hasOwnProperty(lKey) && lPhotoTypes[lKey].Id == aOffender.PhotoTypeId) {
            lPhotoTypeText = lPhotoTypes[lKey].PhotoTypeText;
            break;
        }
    }

    html.push("<div id='uOffenderPhotoPopupContainer'>");
    if (aOffender.PhotoTypeId == 4) {
        html.push("<img id='popup" + aOffender.Id + "' src='" + MUGSHOTS + aOffender.PhotoUri + "' style='height:395px;width:auto;margin:0px auto;'/>");
    } else if (aOffender.PhotoTypeId == 5) {
        if (aOffender.PhotoUri === "") {
            html.push("<img id='popup" + aOffender.Id + "' src='Images/NoPhoto.png' style='height:395px;width:auto;margin:0px auto;'/>");
        } else {
            html.push("<img id='popup" + aOffender.Id + "' src='" + MUGSHOTS + aOffender.PhotoUri + "' style='height:395px;width:auto;margin:0px auto;'/>");
        }
    } else {
        html.push("<img id='popup" + aOffender.Id + "' src='" + MUGSHOTS + aOffender.PhotoUri + "' style='height:395px;width:auto;margin:0px auto;'/>");
    }
    html.push("</div>");
    DisplayPopup(aOffender.PhotoDescription + " | " + lPhotoTypeText, html.join(""), null, false, true);
    resizeOffenderPhoto("popup" + aOffender.Id);
}
